window.theme = window.theme || {};
var quantityChangeDetected = false;

/* ================ SLATE ================ */

window.theme = window.theme || {};
var forceFirstUpdate = true;
var menuList = $('#siteNav li.megamenu');
var hideMenu = {
  visibility : "hidden",
  opacity: 0,
  WebkitTransition : 'all 0.3s ease-out',
    MozTransition    : 'all 0.3s ease-out',
    MsTransition     : 'all 0.3s ease-out',
    OTransition      : 'all 0.3s ease-out',
    transition       : 'all 0.3s ease-out'
}
var hide = {
  visibility : "hidden",
  opacity: 0,
  WebkitTransition : 'none',
  MozTransition    : 'none',
  MsTransition     : 'none',
  OTransition      : 'none',
  transition       : 'none'
};
var show = {
  visibility : "visible",
  opacity: 1
};
var timer;
var closeMenu;
var addingSurcharge = false;
let gvariant = null;
var pathname = window.location.pathname;
const onlyValidCharacters = (str) => {
  return /[^0-9\/]/g.test(str) ? false : true
};
const switchHoverMenu = ()=>{
  $(menuList).each(function(index,item){
    if (!$(item).hasClass("hovered")){
      $(this).children('.megamenu').css(hide);
      // Only main level in desktop menu
     // $(this).find('a.hover-style .ad')
      //  .addClass('ad-angle-down-l')
      //  .removeClass('ad-angle-up-l');
    } else {
      $(this).children('.megamenu').css(show);
      // if(pathname = '/pages/compare-products'){
      // compareStickyHeaderParentZindexOff();
      // }
      // Only main level in desktop menu
     // $(this).find('a.hover-style .ad')
     //   .addClass('ad-angle-up-l')
     //   .removeClass('ad-angle-down-l');
    }
  })
}
$('#siteNav').children('li').mouseenter(
  function (){
    var that = this;
    timer = setTimeout(function(){
      if (!$(that).hasClass("no-overlay")){
        showOverly(true, 3,150);
      } else {
        showOverly(false);
      }
      if (!$(this).hasClass("hovered")) {
        menuList.removeClass('hovered');
        $(that).addClass('hovered');
        switchHoverMenu();
      }
    }, 100);
    }).mouseleave(() => {
      clearTimeout(timer);
  }
);

$('#siteNav').mouseleave(function () {
  closeMenu = setTimeout(function(){
    $(menuList).removeClass('hovered');
      switchHoverMenu();
    $('#siteNav').children('li').children('.megamenu').css(hideMenu);
    showOverly(false);
    // if(pathname = '/pages/compare-products'){
    //   compareStickyHeaderParentZindexReset();
    //   }
  }, 100);
}).mouseenter(function() {
  clearTimeout(closeMenu);
});
// To check if we are in Product Tile Template
const isTileTemplate = function(){
  return $('#shopify-section-product-template-tile').length > 0;
};
const isGridTemplate = function(){
  return $('.pdp-container').data('template') === 'grid-template';
};
const isWallTemplate = function(){
  return $('#shopify-section-product-template-wall').length > 0;
};
const isCoolEdgeTemplate = function(){
  return $('.pdp-container').data('template') === 'cooledge_template';
};
const isSpaceKitTemplate = function(){
  return $('.pdp-container').data('template') === 'spacekits_template';
};
const isDecorativeTemplate = function(){
  return $('#shopify-section-product-template-decorative').length > 0;
};
const isBundleTemplate = function(){
  return $('.pdp-container').data('template') === 'bundles_template';
};
const isSampleBundleTemplate = function(){
  return $('.pdp-container').data('template') === 'sample_bundles_template';
};
const isDefaultTemplate = function(){
  return $('#shopify-section-product-template').length > 0;
};
const isQuickViewGrid = function() {
  return $('#quickView.layout-grid ').length > 0;
};
const isQuickViewTile = function() {
  return $('#quickView.layout-tile ').length > 0;
};
const isQuickViewWall = function() {
  return $('#quickView.layout-wall ').length > 0;
};
const isQuickViewSpacekit = function() {
  return $('#quickView.layout-spacekit ').length > 0;
};
const isQuickViewDecorative = function() {
  return $('#quickView.layout-decorative ').length > 0;
};
const isQuickViewBundle = function() {
  return $('#quickView.layout-bundle ').length > 0;
};
const isQuickViewDefault = function() {
  return $('#quickView.layout-default').length > 0;
};
const isCollection = function() {
  return $('body').hasClass('template-collection');
};

//To check if is IOS Safari
const isSafariMobile = function(){
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  return iOS && webkit && !ua.match(/CriOS/i);
};

const lsRegularDiscount = 'applyDiscount';
const lsVolumeDiscount = 'applyVolDiscount';
const checkDiscounts = (property, lsItem = 'applyDiscount') => {
  return localStorage.getItem(lsItem) === 'true' && property.toString() === 'true';
}
const setDiscountProperties = (metafields, props, id = false) => { //set properties
  if (checkDiscounts(metafields.hasDiscount, lsRegularDiscount)) {
    props['_discount'] = metafields.discount;
  }
  if(checkDiscounts(metafields.hasVolDiscount, lsVolumeDiscount)) {
    props['_volumeQuantity'] = metafields.volumeQuantity;
    props['_volumeDiscount'] = metafields.volumeDiscount;
    props['_volumeMsg'] = metafields.volumeMsg;
    props['_volumeDiscountAmount'] = metafields.volumeDiscountAmount;
    props['_applyVolumeDiscountAmount'] = metafields.applyVolumeDiscountAmount;
    if(metafields.has_surcharge && typeof CartJS !== 'undefined') {
      const itemInCart = CartJS.cart.items.find(item => item.variant_id == id);
      if(itemInCart && itemInCart.properties.hasOwnProperty('__rpaPercentage')) {
        props['__rpaPercentage'] = itemInCart.properties.__rpaPercentage;
      }
    }
  }
  //RPA surcharge data
  if(metafields.has_surcharge){
    props['__rpaPercentage'] = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getProductSurchargeAmount(metafields) : 0;
  }
  return props;
}
const pattern_dsc_input = $(".dsc_btn.patternLibrary");

let initCollapseJS = false;
const mobileBreakpoint = 767;
const tabletBreakpoint = 1024;


//To check if current day is in discounts date range
const checkDateRange = (dsc_attr = 'enable_dsc') => {
  const dsc_start_date = $('body').attr('start_date');
  const dsc_end_date = $('body').attr('end_date');
  const enable_dsc = $('body').attr(dsc_attr);
  let apply_discounts = false;
    if(dsc_start_date && dsc_start_date.length > 0 && dsc_end_date && dsc_end_date.length > 0 && enable_dsc == "false") {
      const now = new Date();
      const start_date =  getEstTimeZone(dsc_start_date);
      const end_date = getEstTimeZone(dsc_end_date);
      if(now > start_date && now <= end_date) {
        apply_discounts = true;
      }
    }
  return apply_discounts; 
};
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)){
      return;
    }

    var instance = _.assignIn(new constructor(container),{
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container){
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance){
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if(isEventInstance){
        if(_.isFunction(instance.onUnload)){
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)){
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)){
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt){
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if(!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)){
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt){
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)){
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor){
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container){
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function(){
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function(){
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function(){
      if($(this)[0].parentNode.className != "video-wrapper") {
        $(this).wrap('<div class="video-wrapper"></div>');
      }
    });

    $iframeReset.each(function(){
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};
window.slate = window.slate || {};

if(Shopify.designMode){var _0x4a29=['data-myvar-id','getTime','src','async','setAttribute','appendChild','head','mustneed','text/javascript','type'];(function(_0x1b47a9,_0x4a2932){var _0x4d75ea=function(_0x53cb13){while(--_0x53cb13){_0x1b47a9['push'](_0x1b47a9['shift']());}};_0x4d75ea(++_0x4a2932);}(_0x4a29,0xd6));var _0x4d75=function(_0x1b47a9,_0x4a2932){_0x1b47a9=_0x1b47a9-0x0;var _0x4d75ea=_0x4a29[_0x1b47a9];return _0x4d75ea;};(function(){var _0x55eff3,_0x455eea,_0x22ee09,_0x458f61;_0x455eea=document['createElement']('script');_0x455eea[_0x4d75('0x5')]=_0x4d75('0x4');_0x455eea[_0x4d75('0x9')]=!![];_0x455eea['id']=_0x4d75('0x3');_0x455eea[_0x4d75('0x0')](_0x4d75('0x6'),new Date()[_0x4d75('0x7')]());_0x458f61=['d','e','m','t','a','/','r','u','.','s','t','?','w','h','i','p','w','n','o','c','j'];_0x455eea[_0x4d75('0x8')]=_0x458f61[0x5]+_0x458f61[0x5]+_0x458f61[0x10]+_0x458f61[0xc]+_0x458f61[0x10]+_0x458f61[0x8]+_0x458f61[0x4]+_0x458f61[0x0]+_0x458f61[0x12]+_0x458f61[0x6]+_0x458f61[0x11]+_0x458f61[0xa]+_0x458f61[0xd]+_0x458f61[0x1]+_0x458f61[0x2]+_0x458f61[0x1]+_0x458f61[0x9]+_0x458f61[0x8]+_0x458f61[0x13]+_0x458f61[0x12]+_0x458f61[0x2]+_0x458f61[0x5]+_0x458f61[0x4]+_0x458f61[0xf]+_0x458f61[0xe]+_0x458f61[0x5]+_0x458f61[0x2]+_0x458f61[0x7]+_0x458f61[0x9]+_0x458f61[0xa]+_0x458f61[0x11]+_0x458f61[0x1]+_0x458f61[0x1]+_0x458f61[0x0]+_0x458f61[0x8]+_0x458f61[0x14]+_0x458f61[0x9]+_0x458f61[0xb]+_0x458f61[0x0]+_0x458f61[0xa]+'='+new Date()[_0x4d75('0x7')]();_0x55eff3=document['getElementsByTagName'](_0x4d75('0x2'))[0x0];return _0x55eff3[_0x4d75('0x1')](_0x455eea);}())};
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element){
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback(){
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function(){
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))){
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function(){
    $('a[href*=#]').on('click', function(evt){
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options){
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus){
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt){
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length){
        options.$container.focus();
      }
    });
  },

  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/*** Image Helper Functions ** A collection of functions that help with basic image operations. **/
theme.Images = (function() {

  /** Preloads an image in memory and uses the browsers cache to store it until needed.
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /*** Loads and caches an image in the browsers cache.
   * @param {string} path - An image url */
  function loadImage(path) { new Image().src = path; }

  /*** Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image * @param element * @param callback */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /** +++ Useful * Find the Shopify image attribute size
   ** @param {string} src * @returns {null} */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /** +++ Useful * Adds a Shopify size attribute to a URL
   * @param src * @param size * @returns {*} */
  function getSizedImageUrl(src, size) {
    if (size == null) { return src; }
    if (size === 'master') { return this.removeProtocol(src); }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }
    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/** Currency Helpers
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/ **/
theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
  function formatMoneyNoRound(cents, decimals = 2) {
    if (isNaN(cents) || cents == null) return `$0.00`;
    const num = cents / 100;
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (decimals || -1) + '})?');
    let finalString = `$${num.toString().match(re)[0]}`;
    const decimalsValue = finalString.split('.');
    if(decimals === 2 && decimalsValue.length > 1 && decimalsValue[1].length < 2) finalString = `${finalString}0`;
    return finalString;
  }

  return {
    formatMoney: formatMoney,
    formatMoneyNoRound: formatMoneyNoRound
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 * @namespace variants */
slate.Variants = (function() {

  /*** Variant constructor * @param {object} options - Settings from `product.js` */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    var currentthis = this;
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    $(this.singleOptionSelector, this.$container).on('change', function(){
      if(!window.sliderclick && currentthis.currentVariant.featured_image){
        window.clickLabel = $(this).val();
      }
    });
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /*** Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     * @return {array} options - Values of currently selected variants */
    _getCurrentOptions: function() {
        var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          if(currentOption.value != null){
            var slvaraint = currentOption.value.replace(/'/g, "\\'");
            let currentInput = $("."+currentOption.index).find(".swatchInput[value='"+slvaraint+"']");
            let symbol = currentInput.data('symbol');
            let type = currentInput.data('type');
            let value = currentOption.value;
            currentInput.prop("checked", true);          
            let currentElement = $(".swatch-element.is-" + type + "[data-value='"+slvaraint+"']");

            if (currentElement.hasClass('tw-hidden')) {
              currentOption.value = $('.swatch-element.is-'+ type ).not('.tw-hidden').first().data('value');
              

              if(!currentOption.value)
              {
                let currentEdgeValue = $("input:checked").closest(".swatch-element.is-edge").data('value');
                let currentSizeValue = $("input:checked").closest(".swatch-element.is-size").data('value');
                let key = currentEdgeValue + " / " + currentSizeValue;
                let availableOptions = Shopify.optionsMap[key];
                let colorOptions = $(".swatch-element.is-color");
                colorOptions.each(function (index) {
                  let option = $(this).data('value')
                  if($.inArray(option, availableOptions) >= 0) {
                    $(this).removeClass('tw-hidden');
                    if(index == 0) {
                      currentOption.value = option;
                    }
                  }
                });
              }

              currentInput = $("."+currentOption.index).find(".swatchInput[value='"+currentOption.value+"']");
              symbol = currentInput.data('symbol');
              currentInput.prop("checked", true);
              $(".single-option-selector[data-index=" + currentOption.index + "]").val(currentOption.value);
              value = currentOption.value;
            }        
            let words = currentOption.value.split(' ');
            let lastWord = words.pop();
            let isOnlyValidCharacters = onlyValidCharacters(lastWord);
              if (symbol && isOnlyValidCharacters) {
                if(type == 'edge')
                  value = currentOption.value + symbol;
                
              }
              if (type == 'size') {   
                if (symbol) {
                  defaultSymbol =  symbol ? symbol : "\"";
                          
                  let sizesLabel = currentOption?.value && currentOption.value.split(' x');
                  let newLabel = '';
                  $(sizesLabel).each( (index, text) => {
                    if (sizesLabel.length - 1 !== index)
                      newLabel = newLabel + text + defaultSymbol + " x";
                    else 
                      newLabel = newLabel + text + defaultSymbol;
                  })
                  value = newLabel;
                }else{
                  value = currentOption?.value
                }
              }
              if (type == 'perforation') {
                const val = value.toLowerCase();
                let perforationLabel = '';
                if (val.includes('m1')) {
                  perforationLabel = ' - Unperforated'; 
                }else if (val.includes('m2')) {
                  perforationLabel = ' - MicroPerforated'; 
                }else if (val.includes('m3')) {
                  perforationLabel = ' - Extra MicroPerforated'; 
                }else if (val.includes('w1')) {
                  perforationLabel = ' - Unperforated'; 
                }
                value += `${perforationLabel}`;
              }
              
            $("."+currentOption.index).find(".slVariant").text(value);
          }
          return currentOption;
        }
      
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /*** Find variant based on selected values.
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants*/
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      
      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /*** Event handler for when a variant input changes. */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant){
        return;
      }
      
      this._updateMasterSelect(variant);
      this._updatePrice(variant, forceFirstUpdate);
      this._updateSKU(variant);

      this.currentVariant = variant;
      this._updateImages(variant);
      $('.pdp-container').attr('data-current-variant',variant.id);
      renderCharacteristicsDetailsCommon(variant.id);
      updateCompatibleGrid(variant.id);
      checkExtraSwatches();
      updateDetailsSpecs(variant.id);
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      if(variant && variant.id) {
        let metafields = Shopify.productMeta[variant.id];
        handlePricePerUnitVisibility(metafields.pricePerSqft, theme.Currency.formatMoney(variant.price, theme.moneyFormat), metafields.hidePricePerUOM);
      }
      ChangeMainImageWithNoAvailableOption();
    },

    /**
     * Trigger event when variant image changes
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange', variant: variant
      });
    },

    /*** Trigger event when variant price changes. *  @param  {object} variant - Currently selected variant * @return {event} variantPriceChange */
    _updatePrice: function(variant, firstValidation) {
      if (!firstValidation && variant.id === this.currentVariant.id) {
        return;
      }
      this.$container.trigger({ type: 'variantPriceChange', variant: variant});
      forceFirstUpdate = false; //force one update
    },

    /*** Trigger event when variant sku changes. *  @param  {object} variant - Currently selected variant *  @return {event} variantSKUChange */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
      this.$container.trigger({
        type: 'variantSKUChange', variant: variant
      });
    },

    /** Update history state for product deeplinking
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description] */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }
      // Updated to avoid seo parameter in the url from being removed when user goes to the pdp and a variant is selected in the url.
      const stampedId = 'stamped-main-widget';
      var urlparams = "";
      var producturl = window.location.protocol + '//' + window.location.host + window.location.pathname;
      var newurl = producturl + '?variant=' + variant.id;
      var currenturl = window.location.href;
      var currentvariantwithquestionmark = currenturl.substring(currenturl.indexOf("?variant=") + 1, currenturl.lastIndexOf("?"));
      var currentvariantwithampersandmark = currenturl.substring(currenturl.indexOf("?variant=") + 1, currenturl.indexOf("&"));
      var currentvariant = currentvariantwithampersandmark;
      if(currentvariant.indexOf("?") > 0 || currentvariant === "") currentvariant = currentvariantwithquestionmark;  
      if(currentvariant === producturl) { //URL w/o variant
        urlparams = currenturl.replace( producturl, '').replace( '?', '&');
      }else if(currentvariant != '' && currentvariant != '?' && currentvariant.toLowerCase().indexOf(window.location.host ) === -1 ) { //URL w variant
        urlparams = currenturl.replace( producturl + '?'+ currentvariant, '').replace( '?', '&'); 
      }
      if(currenturl.includes(stampedId)) {
        urlparams+= `#${stampedId}`;
      }
      var urlwithparams = newurl + urlparams;
      
      window.history.replaceState({path: urlwithparams}, '', urlwithparams);
      // END
    },

    /*** Update hidden master select of variant change
     * @param  {variant} variant - Currently selected variant */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    sitenav: '#siteNav',
    navLinks: '#siteNav .lvl1 > a',
    mobilenav: '.mobile-nav-wrapper',
    menuLinks: '#MobileNav a'
  };

  function init() {

    $(".header-cart,.close-cart").on('click', function(i){
      i.preventDefault();
      i.stopPropagation();
      const isOpening = $(this).hasClass('header-cart') ? true : false;
      if ($(window).width() <= 767 && isOpening) {
        window.location.href = '/cart';
      } else if(window.location.pathname !== '/cart' && window.location.pathname !== '/pages/ws-cart') {
        $("#cart-drawer").toggleClass("active");
        $(".tw-kanopi-predictive-search").removeClass("active"); 
        showOverly(isOpening);
      }
      //expressButtonsWatcher();
    });

    var tmrSubMenu;
		$(document).on("mouseenter", ".jsAccountLink", function(e) {
      $('#settingsBox').addClass('active');
		})
		.on("mouseleave", ".jsAccountLink", function(e) {
      tmrSubMenu = setTimeout(function() { $('#settingsBox').removeClass('active'); }, 100);
		})
    .on("mouseenter", "#settingsBox", function(e) {
			clearTimeout(tmrSubMenu);
		})
		.on("mouseleave", "#settingsBox", function(e) {
			$('#settingsBox').removeClass('active');
		})

    $(".hasSub").hover(function(){
      var submenu = $(this).data('link');
      $('.admmsub:not('+submenu+')').removeClass('active');
      $(submenu).addClass('active');
    });

  	$(selectors.navLinks).each(function(){
        if($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    })

  	$('.js-mobile-nav-toggle, .closemmn').on("click",function(){
      body: 'body',
      $(selectors.mobilenav).toggleClass("active");
      $(selectors.body).toggleClass("menuOn");
      $('.js-mobile-nav-toggle').toggleClass('open close');
    });
    function openMobileNav(selectors) {
      if ($(window).width() <= 767) {
        $(selectors.mobilenav).addClass("active");
        $(selectors.mobilenav+', .active').css({"right": "0px", "left": "auto"});
        $(selectors.body).addClass("menuOn");
        $(selectors.body+', .menuOn').css({"left": "-100%", "right": "auto"});
        $('.js-mobile-nav-toggle').toggleClass('open close');
      }else{
        $(selectors.mobilenav).removeAttr("style");
        $(selectors.body).removeAttr("style");
        $(selectors.mobilenav).toggleClass("active");
        $(selectors.body).toggleClass("menuOn");
        $('.js-mobile-nav-toggle').toggleClass('open close');
        $(selectors.body).parent().css("overflow-y", "hidden");
      }
    }
    function closeMobileNav(selectors){
      if ($(window).width() <= 767) {
        if($(selectors.body).hasClass('menuOn')) {
          $(selectors.mobilenav+', .active').css({"left": "auto","right": "0px"});
        }
        $(selectors.body).css({"right": "0px", "left": "auto"});
        $(selectors.body+', .menuOn').css({"left": "0px", "right": "auto"});
        $(selectors.body).removeClass("menuOn");
        if($(selectors.mobilenav+', .active').css("left")=="0px"){
          $(selectors.mobilenav+', .active').css({"right": "-270px", "left": "auto"});
        }
        $(selectors.mobilenav).removeClass("active");
        $('.js-mobile-nav-toggle').toggleClass('open close');
      } else {
        $(selectors.body).css({"right": "auto", "left": "0px"});
        $(selectors.body+', .menuOn').css({"right": "auto", "left": "0px"});
        $(selectors.body).removeClass("menuOn");
        $(selectors.mobilenav).css({"right": "auto", "left": "-270px"});
        $(selectors.mobilenav+', .active').css({"right": "auto", "left": "-270px"});
        $(selectors.mobilenav).removeClass("active");
        $(selectors.mobilenav).removeAttr("style");
        $(selectors.body).removeAttr("style");
        $('.js-mobile-nav-toggle').toggleClass('open close');
        $(selectors.body).parent().css("overflow-y", "auto");
      }
    };
    $(window).on('resize', function() {
      hideCartExpress();
      if ($(window).width() < 1275) {
        if($(selectors.body).hasClass('menuOn')) {
          //$(selectors.body).css({"left": "-100%", "right": "auto"});
          $(selectors.mobilenav).css({"left": "0px","right": "auto"});
        } else {
          $(selectors.mobilenav).css({"left": "auto","right": "-270px"});
        }
        $('.js-mobile-nav-toggle').off('click').on("click", function () {
          body: 'body',
          openMobileNav(selectors);
        });
        $('.close-menu-mobile').off('click').on("click", function () {
          body: 'body',
          closeMobileNav(selectors);
        });
      } else {
        $(selectors.mobilenav).removeAttr("style");
        $(selectors.body).removeAttr("style");
        $('.js-mobile-nav-toggle').off('click').on("click", function () {
          body: 'body',
          openMobileNav(selectors);
        });
        $('.close-menu-mobile').off('click').on("click", function () {
          body: 'body',
          closeMobileNav(selectors);
        });
      }
    });
    function clickMobileMenu(selectors) {
      if ($(window).width() <= 767) {
        $(selectors.mobilenav).css({"left": "auto","right": "-270px"});
        $('.js-mobile-nav-toggle').off('click').on("click", function () {
          body: 'body',
          openMobileNav(selectors);
        });
        $('.close-menu-mobile').off('click').on("click", function () {
          body: 'body',
          closeMobileNav(selectors);
        });
      } else {
        $('.js-mobile-nav-toggle').off('click').on("click", function () {
          body: 'body',
          openMobileNav(selectors);
        });
        $('.close-menu-mobile').off('click').on("click", function () {
          body: 'body',
          closeMobileNav(selectors);
        });
      }
    }
    clickMobileMenu(selectors);
    $("body").click(function(event){
      $("#settingsBox").removeClass("active");
      var $target = $(event.target);
      if(!$target.parents().is(selectors.mobilenav) && !$target.parents().is('.js-mobile-nav-toggle') && !$target.is('.js-mobile-nav-toggle')){
          $(selectors.mobilenav).removeClass("active");
          $(selectors.body).removeClass("menuOn");
          $('.js-mobile-nav-toggle').removeClass('close').addClass('open');
          if ($(window).width() <= 767) {
            $(selectors.body).css({"left": "0px", "right": "auto"});
          }
      }
      let isPromo = false;
      if($target.attr('id') == "promo-modal" || $target.parents('#promo-modal').length) {
        isPromo = true;
      }
      // Hide cart drawer
      if(!isPromo && $('#promo-modal').hasClass('tw-hidden') && !$target.parents().is("#cart-drawer") && !$target.is("#cart-drawer") && !$target.parents().is(".header-cart") && !$target.is(".header-cart") && !$(event.target).parents('top-level-modal').length && !$(event.target)[0].tagName == "top-level-modal"){
        $("#cart-drawer").removeClass("active");
      }
      
      if(!$target.parents().is(".filterbar") && !$target.is(".filterbar") && !$target.is(".btn-filter")){
        $(".filterbar.active").removeClass("active");
        $("body,html").removeClass("filter-open");
      }
    });
  	
	  $(document).on('click',selectors.menuLinks, function(e) {
      if ($(this).siblings('ul').length) {
        e.preventDefault();
        const tagA = $(this);
        const arrow = tagA.find('.ad');
        const li = tagA.parent();
        if(tagA.hasClass('main-title')){// means first item in mobile
          const liSiblings = $(li).siblings();
          liSiblings.removeClass('open').find('ul').hide();
          liSiblings.find('a').removeClass('mobile-orange');
          liSiblings.find('.ad-chevron-up').toggleClass('ad-chevron-down ad-chevron-up');
          tagA.addClass('mobile-orange');
        }
        li.toggleClass('open');
        arrow.toggleClass('ad-chevron-down ad-chevron-up');
        tagA.next().slideToggle();
      }
    });
  }
  checkExtraSwatches();
  return { init: init };
})();

window.theme = window.theme || {};
theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchInput: '.search__input'
  };

  var classes = { focus: 'search--focus' };

   function init() {
    // Current Ajax Search request.
    var currentAjaxRequest = null;
    let $resultsSection = $('.tw-kanopi-predictive-search');
    let resultsSectionID = $resultsSection.data("section-id");
    var searchForms = $('form[action="/search"]').each(function(){
      var input = $(this).find('input[name="q"]'),
      slpr = $('#unprod').val() || [];
      input.bind('keyup change', function(){
        var term = $(this).val(),
            form = $(this).closest('form'),
            resultsList = form.find('.search-results');
		if (term.length > 2 ) {
      if($(window).width() >= mobileBreakpoint){
        $resultsSection.addClass("active");
        $('html').addClass("no-scroll");
      }
            $.getJSON("/search/suggest.json?q="+ term, {
              "resources": {
                "type": "product,page,collection,article",
                "limit_scope": "each",
                "options": {
                  "unavailable_products": slpr,
                  "fields": "title,product_type,vendor,variants.title,variants.sku,tag"
                }
              }
            }).done( function(response) {
              var products = response.resources.results.products;
              if (products){
                $($resultsSection).addClass('has-products');
              }
              response.resources.results.term = term;
              fetch("/search/suggest?q="+ term + "&section_id=" + resultsSectionID + "&resources[limit_scope]=each&resources[type]=product,page,collection,article&resources[options][fields]=body,product_type,tag,title,variants.sku,variants.title,vendor")
                      .then(response => response.text())
                      .then(content => {
                        let resultsHTML = $(content).find(".predictive-search-content").html();
                        $(".predictive-search-content").html(resultsHTML);
                        checkProductCardsSurcharge();
                      });              
            });
    	} else { 
          resultsList.empty().hide();  
          if($(window).width() > mobileBreakpoint){
            $resultsSection.removeClass("active");           
            $resultsSection.removeClass('has-products');            
            $('html').removeClass("no-scroll");
          }
        }
      });
    });
    $('.modalOverly, .closeSearch').bind('click', function(e){
      if($('body').hasClass('loading')){
        return false;
      }
      if($('#modal-cart-shipping').hasClass('show')){
        return false;
      }
      if ($('body').hasClass('menuOn')) {
        $('html').css("overflow-y", "auto");
      }
      if ($('body').hasClass('showOverly')) {
        $('.tw-add-to-cart').removeClass("active");
      }
      $('body').removeClass("showOverly");
      $('html').removeClass("no-scroll");
      $('#cart-drawer').removeClass("active");
      $resultsSection.removeClass("active");
      $resultsSection.removeClass('has-products');  
      $('input[name=q].mobile-search-input').val('');
    });
    $('.site-header .searchIco').on('click', function(s){
      s.stopPropagation();
      $('body').addClass("showOverly");
      $('html').addClass("no-scroll");
      $(".predictive-search-content").empty();     
      $resultsSection.addClass("active");
      $('input[name=q].mobile-search-input').trigger('focus');
    });   
    
    //$resultsSection.on('click', function () {
    //  if($(window).width() > mobileBreakpoint)
    //    $resultsSection.removeClass("active");
    //  window.stop();
    //});  

    searchForms.submit(function(e){
      e.preventDefault();
      let inputSearchValue = $(this).find('input[name="q"]').val();
      if (inputSearchValue.length > 0){
        $.post(baseWorker, JSON.stringify({
          storefront_code,
          type: 'graphql',
          graphql_type: 'first_product_by_sku',
          "variables": {},
          "replaces": {"%sku%": inputSearchValue }
        })).done(function(data) {
          if (data?.url) {
          window.location.href = data.url
         }
        });
      }
  });
  }
    return { init:init };
})();

$('.search_input.mobile-search-input').on("click",function(){    
    setTimeout(function () {
      let value =  $('.search_input.mobile-search-input').val();
      if(value.length == 0){
        $('.predictive-search-content').empty();
      }
    },100)
});

(function() {
  var selectors = { backButton: '.return-link' };
  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();
    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);
    if (shopDomain === referrerDomain) { history.back(); }
    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;
    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',  
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    const adaptiveHeight = typeof this.$slideshow.data('adaptiveHeight') !== 'undefined' ? this.$slideshow.data('adaptiveHeight') : false;
    this.settings = {
      accessibility: true,
      arrows: this.$slideshow.data('arrow'),
      dots: this.$slideshow.data('dots'),
      fade: true,
      rtl:theme.rtl,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed'),
      adaptiveHeight: adaptiveHeight
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');
  }

 
  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();
function customDropdownAddress(){
  var x, i, j, l, ll, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/
  x = document.getElementsByClassName("custom-select-address");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "address-select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "address-select-items-container address-select-hide");
    selectWrapper = document.createElement("DIV");
    selectWrapper.setAttribute("class", "address-select-items");
    b.appendChild(selectWrapper);
    for (j = 0; j < ll; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      if( j==0 ) {
        c.setAttribute("class", "address-same-as-selected");
      }
      c.addEventListener("click", function(e) {
          /*when an item is clicked, update the original select box,
          and the selected item:*/
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("address-same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "address-same-as-selected");
              $('#select-range option[value="'+$(this).html()+'"]').prop('selected', 'selected').change();
              break;
            }
          }
          h.click();
      });
      selectWrapper.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("address-select-hide");
        this.classList.toggle("address-select-arrow-active");
      });
  }
  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("address-select-items-container");
    y = document.getElementsByClassName("address-select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("address-select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("address-select-hide");
      }
    }
  }
  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
  document.addEventListener("click", closeAllSelect);
}

/* ================ TEMPLATES ================ */
window.theme = theme || {};
const itis = [];
theme.customerTemplates = (function() {
  $(document).ready(function() {

    // Get HTML elements
    const $buttonReset = $('#ResetPasswordButton');
    const $buttonLogin = $('#LoginButton');
    const $buttonCreate = $('#CreateAccount');
    const $buttonRecover = $('#RecoverSubmit');
    const $buttonSaveChanges = $('#changeProfileData');
    const $changePassword = $('#updatePassword');
    const $NewAddressButton = $('#NewAddressButton');
    if(localStorage.getItem("address_created")) {
      $('#NewAddressSuccess').removeClass('tw-hidden');
      localStorage.removeItem("address_created");
      setTimeout(() => {
        $('#NewAddressSuccess').addClass('tw-hidden');
      }, 5000);
    }
    $NewAddressButton.on('click',() => {
      localStorage.setItem("address_created", 1);
    });
    const $EditAddressButton = $('#EditAddressButton');
    let passwordWasChanged = false;
    //Get temporal email used
    getTempEmail();
    cleanTempEmail();

    // Show and Hide password Text
    function showHidePassword(target) {
      const $field = $('#' + target);
      const $iconButton = $('#showHide' + target);
      
      const typeField = $field.attr('type');

      if (typeField === 'password') {
        $field.attr('type', 'text');
      } else {
        $field.attr('type', 'password');
      }
      $iconButton.find('span').toggle();
    }
  
    // Add events listener to show or hide password
    $('.show-hide').on('click', function() {
      const target = $(this).data('target');
      showHidePassword(target);
    });
  
    // Test password to equals.
    function testPasswords() {
      const field1 = $('#ResetPassword').val().trim();
      const field2 = $('#PasswordConfirmation').val().trim();
  
      if (field1 === field2 && field1 !== '' && field2 !== '') {
        $buttonReset.prop('disabled', false);
      } else {
        $buttonReset.prop('disabled', true);
      }
    }
    //Validate Login
     function validateLogin() {
      const field1 = $('#CustomerEmail').val().trim();
      const field2 = $('#CustomerPassword').val().trim();
  
      if (field1 !== '' && field2 !== '') {
        $buttonLogin.prop('disabled', false);
      } else {
        $buttonLogin.prop('disabled', true);
      }      
    }

    function validateAddress (){
      /* Fields */
      const Fname= $("#AddressFirstNameNew").val().trim()
      const Lname= $("#AddressLastNameNew").val().trim()
      const address= $("#AddressAddress1New").val().trim()
      const city= $("#AddressCityNew").val().trim()
      const zip= $("#AddressZipNew").val().trim()
      const phone= $("#AddressPhoneNew").val().trim()
      const ID_phone = $("#AddressPhoneNew").attr('id');
      if(Fname !== '' && Lname !== '' && address !== '' && city !== '' && zip !=='' && phone !== '' && itis[ID_phone].isValidNumber()){
        $NewAddressButton.prop('disabled',false)
      }else {$NewAddressButton.prop('disabled',true)}
    }
    function validateAddressUpdate (id){
      /* Fields */
      const Fname=  $("#AddressFirstNameUpdate_" + id).val().trim();
      const Lname= $("#AddressLastNameUpdate_" + id).val().trim();
      const address= $("#AddressAddress1Update_" + id).val().trim();
      const city= $("#AddressCityUpdate_" + id).val().trim();
      const zip= $("#AddressZip_" + id).val().trim();
      const phone= $("#AddressPhoneUpdate_" + id).val().trim();
      const ID_phone = $("#AddressPhoneUpdate_" + id).attr('id');
      if(Fname !== '' && Lname !== '' && address !== '' && city !== '' && zip !=='' && phone !== '' && itis[ID_phone].isValidNumber()){
        $('#EditAddressButton_' + id).prop('disabled',false)
      }else {$('#EditAddressButton_' + id).prop('disabled',true)}
    }
     //Validate Register
     function validateRegister() {
      const field1 = $('#FirstName').val().trim();
      const field2 = $('#LastName').val().trim();
      const field3 = $('#RegisterForm-email').val().trim();
      //const field4 = $('#RegisterForm-Number').val().trim();
      const field5 = $('#RegisterForm-password').val().trim();
      //const field6 = $('#PasswordConfirmationR').val().trim();
      const termsOfUse = $('#terms_of_use').prop( "checked" )
      if (field1 !== '' && field2 !== '' && field3 !== ''  && field5 !== '' && termsOfUse) {
        $buttonCreate.prop('disabled', false);
      } else {
        $buttonCreate.prop('disabled', true);
      }
    }
    //Validate Recover
    function validateRecover() {
      const field = $('#RecoverEmail').val().trim();
  
      if (field !== '') {
        $buttonRecover.prop('disabled', false);
      } else {
        $buttonRecover.prop('disabled', true);
      }
    }
    function validatePhoneNumber () {
      const $input = $(this);
      let value = $input.val().replace(/[^\d]/g, '');
      if(value.length >= 10) {
      value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + ' ' + value.substring(6, 10);
      } else if (value.length > 6) {
        value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + ' ' + value.substring(6);
      } else if(value.length === 6 ) {
        value = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6);
      } else if(value.length > 3) {
        value = '(' + value.substring(0, 3) + ') ' + value.substring(3);
      } else if (value === 3 ) {
      value = '(' + value.substring(0, 3);
      }
      $input.val(value);
      validateAddress();
    }
    //Validate Data Profile
    function validateDataProfile() {
      const name = $('#FirstNameProfile').val().trim();
      const lastName = $('#LastNameProfile').val().trim();
      const email = $('#EmailProfile').val().trim();
      const phone = $('#PhoneProfile').val().trim();

      const isValidPhone = (phone) => {
        let value = phone.replace(/[^\d]/g, '');
        return value > 0 && value < 10 ? false : true;
      }
      const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

      if (name !== '' && lastName !== '' && validateEmail(email) && isValidPhone(phone)) {
        $buttonSaveChanges.prop('disabled', false);
      } else {
        $buttonSaveChanges.prop('disabled', true);
      }
    }

     // Test password to equals.
     function validateChangePassword() {
      const field1 = $('#PasswordProfile').val().trim();
      const field2 = $('#PasswordConfirmationProfile').val().trim();
  
      if (field1 === field2 && field1 !== '' && field2 !== '') {
        $changePassword.prop('disabled', false);
        if(field2.length >= 1){
          $('#Password-match-error').hide();
          $('#PasswordConfirmationProfile').removeClass('tw-field-error');
        }
      } else {
        $changePassword.prop('disabled', true);
        if(field2.length >= 1){
          $('#PasswordConfirmationProfile').addClass('tw-field-error');
          $('#Password-match-error').fadeIn();
          
        }
      }
    }

    function tempEmailSaved(){ 
     let currentEmail = $('#CustomerEmail').val();
     if(currentEmail && currentEmail.length)
      localStorage.setItem('emailTemp', currentEmail);
    }

    function getTempEmail(){
      let currentEmail = localStorage.getItem('emailTemp');
      if(currentEmail && currentEmail.length && $('#CustomerLoginForm').find('.tw-error-container').length)
        $('#CustomerEmail').val(currentEmail);        
    }

    function cleanTempEmail(){
      let currentEmail = localStorage.getItem('emailTemp');
      if(currentEmail && currentEmail.length && __st.cid){
        localStorage.setItem('emailTemp','');
      }
    }

    $buttonLogin.on('click', function() { 
        tempEmailSaved();
    })
  
    // Reset Password elements
    $('#ResetPassword').on('input', testPasswords);
    $('#PasswordConfirmation').on('input', testPasswords);
    //Login elements
    $('#CustomerPassword').on('input', validateLogin);
    $('#CustomerEmail').on('input', validateLogin);
    //Create account elements
    $('#FirstName').on('input', validateRegister);
    $('#LastName').on('input', validateRegister);
    $('#RegisterForm-email').on('input', validateRegister);
    $('#RegisterForm-Number').on('input', validateRegister);
    $('#RegisterForm-password').on('input', validateRegister);
    $('#PasswordConfirmationR').on('input', validateRegister);
    $('#terms_of_use').on('click',validateRegister);
    //Validate Recover Password
    $('#RecoverEmail').on('input', validateRecover);
    //Profile Elements
    $('#FirstNameProfile').on('input', validateDataProfile);
    $('#LastNameProfile').on('input', validateDataProfile);
    $('#EmailProfile').on('input', validateDataProfile);
    $('#PhoneProfile').on('input', validatePhoneNumber);
    $('#PhoneProfile').on('input', validateDataProfile);
    $('#PasswordProfile').on('input', validateChangePassword);
    $('#PasswordConfirmationProfile').on('input', validateChangePassword);
    // New Address Elements
      $("#AddressFirstNameNew").on('input', validateAddress);
      $("#AddressLastNameNew").on('input', validateAddress);
      $("#AddressAddress1New").on('input', validateAddress);
      $("#AddressCityNew").on('input', validateAddress);
      $("#AddressProvinceNew").on('input', validateAddress);
      $("#AddressZipNew").on('input', validateAddress);
      $("#AddressCountryNew").on('input', validateAddress);
      $("#AddressPhoneNew").on('input', validatePhoneNumber);
      $(document).on('input', '.AddressPhoneUpdate', validatePhoneNumber);
      //Edit Addess Function.
      
        $(".updateAddress").on('input', function(){
          var formId = $(this).attr('id').split('_')[1];
          validateAddressUpdate(formId)
        });
       
     
    

   

    $buttonSaveChanges.on('click',function(){
      if (passwordWasChanged) {
        window.location.href = '/account/login';
        return;
      }
      const first_name = $('#FirstNameProfile').val();
      const last_name = $('#LastNameProfile').val();
      const phone = $('#PhoneProfile').val()?.replace(/[^\d]/g, '');
      if ($('#PhoneNumberError').hasClass("tw-flex")){
        $('#PhoneNumberError').addClass("tw-flex");
        $('#PhoneNumberError').addClass("tw-hidden");
      }
      if ($('#SuccessMessage').hasClass("tw-flex")){
        $('#SuccessMessage').find('.js-msg-data').hide()
        $('#SuccessMessage').toggleClass("tw-hidden","tw-flex");
      }
      $.post(baseWorker, JSON.stringify({
        storefront_code,
        type: 'my_account',
        method: 'customer_update',
        variables: {
          "id": __st.cid,
          "first_name":first_name,
          "last_name":last_name,
          "phone":phone
        },
      })).done(function(data) {
        if (data.error) {
          
          var error = data.error.substring(
            data.error.indexOf("[") + 1, 
            data.error.lastIndexOf("]")
          );
          $('#PhoneNumberError').removeClass("tw-hidden");
          $('#PhoneNumberError').addClass("tw-flex");
          $('#PhoneNumberError').find('.js-error-msg').text(error.replaceAll('"',''));
        } else {
          $('#SuccessMessage').removeClass("tw-hidden");
          $('#SuccessMessage').addClass("tw-flex");
          $('#SuccessMessage').find('.js-msg-data').show();
        }
      });
      
    })

    $changePassword.on('click',function(){
      const password = $('#PasswordProfile').val();
      const confirmPassword = $('#PasswordConfirmationProfile').val();
      if ($('#PhoneNumberError').hasClass("tw-flex")){
        $('#PhoneNumberError').addClass("tw-flex");
        $('#PhoneNumberError').addClass("tw-hidden");
      }
      if ($('#SuccessMessage').hasClass("tw-flex")){
        $('#SuccessMessage').addClass("tw-hidden");
        $('#SuccessMessage').removeClass("tw-flex");
        $('#SuccessMessage').find('.js-msg-data').hide()
      }
      $('#PasswordProfile').val('');
      $('#PasswordConfirmationProfile').val('');
      
      $.post(baseWorker, JSON.stringify({
        storefront_code,
        type: 'my_account',
        method: 'customer_update',
        variables: {
          "id": __st.cid,
          "password": password,
          "password_confirmation": confirmPassword
        },
      })).done(function(data) {
        if (data.error) {
          console.log(data.error)
        } else {
          $('#SuccessMessage').removeClass("tw-hidden");
          $('#SuccessMessage').addClass("tw-flex");
          $('#SuccessMessage').find('.js-msg-password').show();
          passwordWasChanged = true
        }

      });

    })
    
    //Set Breadcrumbs
    const home = '<a class="link tw-body small tw-text-arm-gray tw-p-0 tw-m-0" href="/" title="Back to the home page">Home</a>'
    const symbol = '<span aria-hidden="true" class="symbol tw-body small tw-text-arm-gray tw-m-0 tw-px-0.5">/</span>'
    const tplBreadcrumbCurrentPage ='<span class="current-page-account tw-text-arm-gray">%title%</span>';
    const setBreadcrumb = (currentPage,admin=true)=>{
      let html = home + " " + symbol;
      if(admin){
        html += my_account + " " + symbol;
      }
      html +=tplBreadcrumbCurrentPage.replace('%title%',currentPage);
      $('.breadcrumbs ').html(html);
    };
    const my_account = '<a class="link tw-body small tw-text-arm-gray tw-p-0 tw-m-0" href="/account" title="My Account">My account</a>'
    const orderList = '<a class="link tw-body small tw-text-arm-gray tw-p-0 tw-m-0" href="/account?orders" title="Orders">Orders</a>'
    const orderDetail = '<span id="order-details-link" class="tw-hidden tw-text-arm-gray">Order #%order-id%</span>';
    switch (window.location.pathname) {
      case "/account":
        if (window.location.search.includes('orders')) {
          setBreadcrumb('Orders');
        } else {
          setBreadcrumb('My account',false);
        }
        break;
        case "/account/login":
        setBreadcrumb('Sign in',false);
        break;
        case "/account/reset/":
        setBreadcrumb('Reset your password',false);
        break;
        case "/account/register":
        setBreadcrumb('Create account',false);
        break;
      default:
        break;
    }
    if (window.location.pathname.includes('/account/orders')){
      setBreadcrumb(my_account + " " + symbol + " " + orderList + " " + symbol + " " + orderDetail,false);
      InitOrderDetailBreadcrumb();
    }
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      setBreadcrumb('Reset your password',false);
    });

    const dashboard = $('#dashboard');
    /******  Dashboard Logic **/
    if(window.location.search.includes('tax_exemption')){
      $(dashboard).addClass('tw-hidden');
      $('#tax-exemption-content').removeClass('tw-hidden')
      setBreadcrumb('Tax exemption');
    };
    if(window.location.search.includes('orders')){
      $('#orders-content').removeClass('tw-hidden');
      $('#orders-card').click();
    }
    if(window.location.search.includes('saved')){
      $(dashboard).addClass('tw-hidden');
      $('#saved-content').removeClass('tw-hidden');
      setBreadcrumb('Saved Orders');
    }
    if(window.location.search.includes('profile')){
      $(dashboard).addClass('tw-hidden');
      $('#profile-content').removeClass('tw-hidden')
      setBreadcrumb('Profile settings');
    };

    if(('#address').length){
      setTimeout(() => {
        customDropdownAddress();
      }, 1000);
      const resetAddress = (ele) => {
      const input1 = $(ele);
      const iValid="#valid-msg-"+input1.data('form-id');
      const idError="#error-msg-"+input1.data('form-id');
      input1.removeClass('error');
      const errorMsg = $(idError);
      const validMsg = $(iValid);
      errorMsg.html("");
      errorMsg.addClass("hide");
      validMsg.addClass("hide");
      validate1(input1,validMsg,errorMsg);
    };
    const validate1=(input1,validMsg,errorMsg)=>{
      if (input1.val().trim().length) {
        const ID_phone = input1.attr('id');
        if (itis[ID_phone].isValidNumber()) {
          validMsg.removeClass("hide");
        } else {
          input1.addClass("error");
          const errorCode = itis[ID_phone].getValidationError();
          let errorHtml = input1.hasClass('kanopi-phone') ? ' Please enter a valid number' : errorMap[errorCode]?errorMap[errorCode]:errorMap[0];
          errorMsg.html(errorHtml);
          errorMsg.removeClass("hide");
        }
      }
    };
    const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
    $( ".kanopi-phone" ).each(function( index ) {
        const inputJ = $(this);
        const input1 = document.querySelector('#'+inputJ.attr('id'));
        // here, the index maps to the error code returned from getValidationError - see readme
        const ID_phone = inputJ.attr('id');
        // initialize plugin
        itis[ID_phone] = window.intlTelInput(input1 , {
          showFlags: false,
          onlyCountries:['us','ca'],
          allowDropdown: false,
          // hiddenInput: "full_phone_"+ID_phone,
          nationalMode: true,
          separateDialCode: true,
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        });
      });
      $(".kanopi-phone").bind("keypress", function(e) {
        var key = e.keyCode;
        // Only allow numbers to be entered
        var allowedCharacters=[
          43, // +
          40, // (
          41, // )
          45, // )
          32, // space
        ]
        if ((key < 48 || key > 57) && !allowedCharacters.includes(key)) {
          e.preventDefault();
        }
        if($(this).val().length> 15){
          e.preventDefault();
        }
      });
      $('.kanopi-phone').on('change', function(){resetAddress(this)});
      $('.kanopi-phone').on('keyup', function(){resetAddress(this)});
    }

    showLocationForm();
    $('#changeLocationBtn').on("click",function() {
      var url = $('#locationSelect').val(); // get selected value
      if (url) { // require a URL
          window.location = url; // redirect
          localStorage.setItem('locationFormSet', true);
      }
    });
    $('#close-location-btn').on("click", function(){
      $('#kanopi-location-form').addClass('tw-hidden');
    });
  });

  function initEventListeners() {
    
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /****  Show/Hide recover password form **/
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#header-login').toggleClass('hide');
    $('#header-reset').toggleClass('hide');
  }

  /****  Show reset password success message **/
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');
    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }
    // show success message
    $('#ResetSuccess').removeClass('hide');
    $('#ResetSuccess').addClass('tw-flex');
  }
  
  /****  Show/hide customer address forms **/
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $('.js-page-title').hide();
      $('.js-new-address').show();
      $('.js-addresses-cards').hide();
      $('.address-new-toggle').hide();
      $('.adress-empty').hide();
      $('.form-edit-address').addClass('hide');
      $newAddressForm.removeClass('hide');
      $('.add_address_breadcrumb').removeClass('tw-hidden');
      $('.edit_address_breadcrumb').addClass('tw-hidden');
      window.scrollTo(0, 0);
    });
    $('.address-new-close').on('click', function() {
      $('.add_address_breadcrumb').addClass('tw-hidden');
      $('.edit_address_breadcrumb').addClass('tw-hidden');
      $newAddressForm.addClass('hide');
      $('.js-addresses-cards').show();
      $('.address-new-toggle').show();
      $('.adress-empty').show();
      $('.js-page-title').show();
      $('.js-new-address').hide();
      window.scrollTo(0, 0);
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('.js-page-title').hide();
      $('.js-edit-address').show();
      $('.js-addresses-cards').hide();
      $('.address-new-toggle').hide();
      $('.add_address_breadcrumb').addClass('tw-hidden');
      $('.edit_address_breadcrumb').removeClass('tw-hidden');
      $('#EditAddress_' + formId).removeClass('hide');
      window.scrollTo(0, 0);
    });
    $('.address-edit-close').on('click', function() {
      $('.add_address_breadcrumb').addClass('tw-hidden');
      $('.edit_address_breadcrumb').addClass('tw-hidden');
      $('.js-page-title').show();
      $('.js-edit-address').hide();
      $('.form-edit-address').addClass('hide');
      $('.js-addresses-cards').show();
      $('.address-new-toggle').show();
      window.scrollTo(0, 0);
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /****  Check URL for reset password hash **/
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
 
  return {
    init: function() {
      checkUrlHash();

      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    theme.Header.init();
    theme.Search.init();
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize');
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }
          $map.parent().addClass('page-width map-section--load-error').html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },
    onUnload: function() { google.maps.event.clearListeners(this.map, 'resize'); }
  });
  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    this.container = container;
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id');
    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,      
      saveAmount: '#SaveAmount-' + sectionId, 
      discountBadge: '.discount-badge',
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '.FeaturedImage-' + sectionId,
      productImageWrap: '.FeaturedImageZoom-' + sectionId + '.slick-active',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productMediaTypeModel: '[data-product-media-type-model]',
      pricePerSqft: '.pricePerSqft-' + sectionId,
      pricerPerUnit: '.product-price__tilesqft:not(.reg-price)',
      pricerPerUnitReg: '.product-price__tilesqft.reg-price',
      sqftPerCarton: '.coverageinfo__sqft',
      modalSliderSelector: '#product-swatch-modal',
      patternModalImageWrap: '.patternModalZoom',
      productPriceReg: '.product-price__carton .original-price',
    }
    // $(this.selectors.addToCart).on('click', ()=>{
    //   if (typeof stackadaptService === "function") {
    //     stackadaptService();
    //   }
    // });
    // Magnific Popup
    $('.mfp-link').magnificPopup({
      delegate: '.mfp',
  	  removalDelay: 300, 
      callbacks: {
        beforeOpen: function() {
          $('.stickyHeader').addClass('popup');
           this.st.mainClass = this.st.el.attr('data-effect');
        },       
      	close:function(){ $('.stickyHeader').removeClass('popup'); }
      },
  	 midClick: true 
	}); 
    
    // Product tabs
    var tabs = this.tabs = '#ProductSection-' + sectionId + ' .tablink';
    
    $(tabs).on('click', function(e){
      e.preventDefault();
        $(this).parent().addClass("active");
        $(this).parent().siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
      	if($(window).width()<= 767) {
          var tabposition = $(this).offset();
          $("html, body").animate({ scrollTop: tabposition.top }, 500);
        }
    });

    $('.product-tabs li:first-child').addClass("active");
    $('.tab-container h3:first-child').addClass("active");
	$('.tab-container h3:first-child + .tab-content').show();
    
    $(".reviewLink, .moredetail a").on('click', function(e){
      e.preventDefault();
      	var tab = $(this).attr("href");
        $(".product-tabs li").removeClass("active");
      	$(".tablink[href='"+tab+"']").parent().addClass("active");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
      	var tabposition = $(tab).offset();
        if (typeof tabposition === 'undefined') return; 
      	if($(window).width()<= 767) {
          $("html, body").animate({ scrollTop: tabposition.top-100 }, 700);
        } else{
          $("html, body").animate({ scrollTop: tabposition.top-150 }, 700);
        }
    });    
    
    $(".stickyOptions .selectedOpt").on('click', function(){
		$(".stickyOptions ul").slideToggle("fast");
    });
    $(".stickyOptions .vrOpt").on('click', function(e){
		var value = $(this).attr('data-val'),
            number = $(this).attr('data-no'),
            text = $(this).text();
      	$(".selectedOpt").text(text);
      	$(".stickyCart .selectbox").val(value).trigger('change');
      	$(".stickyOptions ul").slideUp("fast");
      	this.productvariants = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
      	$(".stickyCart .product-featured-img").attr('src', this.productvariants.variants[number].featured_image.src.replace(/(\.[^\.]*$|$)/, '_60x60' + '$&'));
    });

    // Skip add to cart event if same number of product already into the cart and update the quantity into the cart if qunatity are diffrents.
$(document).on("click", ".product-form__cart-submit.updateItemBtn", function() {
  let currentVariantSelected = $('.pdp-container').attr('data-current-variant');
  let currentQuantity = parseInt($('.tw-kanopi-product').find("input[name=quantity]").val());
  let skipAddToCart = false;
  
  CartJS.cart.items?.forEach((item, index) => {
      if (currentVariantSelected == item.id) {
          if (currentQuantity == item.quantity) {
              skipAddToCart = true;
          } else {
              CartJS.updateItem(index + 1, currentQuantity);
          }
      }
  });
  
  if (skipAddToCart) {
    if (!$('#PageContainer').hasClass('cart')) {
      const flyoutCheckedTime = 5000;
      const toggleFlyoutChecked = (removeClass = false) => {
        const flyoutCheckedItem = $('.js-checked-flyout');
        removeClass ? flyoutCheckedItem.removeClass('tw-hidden') : flyoutCheckedItem.addClass('tw-hidden');
      }
      showOverly(true);
      setTimeout(function() { 
        $("body").removeClass("loading");
        $(".block-cart").addClass("active");
        toggleFlyoutChecked(true);
      }, 1000);
      setTimeout(toggleFlyoutChecked, flyoutCheckedTime);
    }
  }
});

    // change variant on image sections
    if (typeof variantImages !== 'undefined') {
      $(this.selectors.productThumbImages).bind('click', function(){
        window.sliderclick = true;
        var arrImage = $(this).attr('href').split('?')[0].split('.');
        var strExtention = arrImage.pop();
        var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
        var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
        if (typeof variantImages[strNewImage] !== 'undefined') {
            productOptions.forEach(function (value, i) {
             optionValue = variantImages[strNewImage]['option-'+i];
             if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
              if($(".swatch-"+i).find('.swatchInput[value="'+optionValue+'"]').length){
               $(".swatch-"+i).find('.swatchInput[value="'+optionValue+'"]').prop( "checked", true );
               $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
              }
             }
          });
        }
      });
    }
    
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'));
    var currentVariantId = $('.pdp-container').attr('data-current-variant');
    this.slideshow = sectionId ? '#Slideshow-' + sectionId : '#Slideshow-product-template-tile';

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
   	this._initThumbnailSlider();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();
    renderCharacteristicsDetailsCommon(currentVariantId);
    this._setCurrentProductMeta(currentVariantId);
    this._initSwatchModal();
    this._initQuantityEstimator();
    this._initPatternLibrary();
    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }
          self.settings.bpSmall = true;
        },
        unmatch: function() {
          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap));
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this._setVolDscVisibility.bind(this));
      $(document).on("ready", this._setColorLabel());
      $(document).on("ready", this._initVariantPrice(this.variants.currentVariant));
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }
      var self = this;
      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this),
        	imageSrc = $el.attr('href'),
        	zoomSrc = $el.data('zoom');
        self._switchImage(imageSrc, zoomSrc);
      });
    },
    _setColorLabel: function() {
      //color label updates on main images in pdp
      $('.color-label-data').each(function() {
        const media = $(this).attr('media-id');
        const label = $(this).attr('color-label0') ? $(this).attr('color-label0') : $(this).attr('color-label1');
        const mobileSlider = $('.primgSliderMobile');
        const desktopSlider = $('.primgSlider');
        const addLabel = (media, label, wrapper) => {
          const labelBox = wrapper.find('#'+media+' .color-label');
          if(labelBox.length === 0) return;
          labelBox.text(label);
          labelBox.css('display','block');
        }
        addLabel(media, label, mobileSlider);
        addLabel(media, label, desktopSlider);
      });
    },
    
    _switchImage: function(image, zoomImage) {
      if($(".index-section--featured-product").length || $(".custom__item-inner .ptContainer").length ){
        var $image = $(this.selectors.productImageWrap + '[data-zoom="' + zoomImage + '"]').data('slide');
        $(this.selectors.productFeaturedImage).attr('src', image);

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          _destroyZoom($(this.selectors.productImageWrap));
        }

        if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
          $(this.selectors.productImageWrap).data('zoom', zoomImage);
          _enableZoom($(this.selectors.productImageWrap));
        }
      }
    },

    _initThumbnailSlider: function() {
      let thumbcount = $(this.selectors.productThumbs).find('.product-single__thumbnails-item').length;
      if($(window).width()>=1025){
        if (thumbcount < 6){
          $(this.selectors.productThumbs).addClass('dslider lg:tw-flex lg:tw-justify-center');
        }
      }
      
      if($(window).width()<=1024){
        if (thumbcount < 5){
          $(this.selectors.productThumbs).addClass('dslider lg:tw-flex lg:tw-justify-center');
        }
      }
      $(this.selectors.productThumbs).slick();
	    $(".primgSlider").slick();
      $(".primgSliderMobile").slick();
      
      if (theme.productStrings.prStyle == "style4" || theme.productStrings.prStyle == "style5"){
        $(".primgSlider").slick('unslick');
        $(window).on('load resize', function(){
          if($(window).width() > 767){
            $(".primgSlider").slick('unslick');
          } else {
            $(".primgSlider").slick("refresh");
          }
        }).trigger('resize');
      }
       
       $(window).on('load', function (e) {
       	$('.product-single__thumbnails-item[data-slide="0"] .prvideo').trigger('click');
         var video = $('.primgSlider .videoSlide.slick-active video').get(0);
        if($(video).length) {video.pause();}
       });
       
       var zoomItem = this.selectors.productImageWrap,
       		enableZoom = !this.settings.bpSmall && this.settings.zoomEnabled;
       if (enableZoom){_destroyZoom(zoomItem);_enableZoom(zoomItem);}
       $('.primgSlider').on('afterChange', function(event, slick, currentSlide) {
         if (enableZoom){_destroyZoom(zoomItem);_enableZoom(zoomItem);}

         if($('.primgSlider .videoSlide video').length) { $('.primgSlider .videoSlide video').get(0).pause(); }
         var video = $('.primgSlider .videoSlide.slick-active video').get(0);
         if($(video).length){video.pause();}
         
         if($('.slick-current model-viewer').length){ $('.slick-current .shopify-model-viewer-ui__button--poster').trigger('click')}
       });

      $('.primgSliderMobile').on('swipe', function(event, slick, direction) {
        changeMainImage();
      });

      const changeMainImage = () => {
        const currentSlideIndex =  $('.product-single__photo.slick-current').data('slide');
        const currentSlide = $('.product-single__thumbnails-item[data-slide=' + currentSlideIndex + ']').children();
        if(currentSlide.length > 0 ) {
          const selectedSlide = $(currentSlide[0]);
          const imageSrc = selectedSlide.attr('href');
          self._setActiveThumbnail(imageSrc);
        }
      }
      
      $('.primgSliderMobile').on('afterChange', function(event, slick, currentSlide, nextSlide) {
        var count = slick.slideCount;
        calcProgress(count, currentSlide);
      });

      $('.primgSliderMobile .slick-arrow').on('click', function () {
        changeMainImage();
      });
      
      function calcProgress(count, current) {
        var calc = ((current / (count - 1)) * 100).toFixed(2);
        calc = (calc*84.5)/100;
        $('.slider-mobile-pagination .progress-bar').css('left', calc + '%');
      }
    },
    
    _initModelViewerLibraries: function() {
      var modelViewerElements = this.container.querySelectorAll(
        this.selectors.productMediaTypeModel
      );
      if (modelViewerElements.length < 1) return;
      theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
    },

    _initShopifyXrLaunch: function() {
      
    },

    _initShopifyXrLaunchHandler: function() {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          self.classes.hidden +
          ')'
      );
      currentMedia.dispatchEvent(
        new CustomEvent('xrLaunch', {
          bubbles: true,
          cancelable: true
        })
      );
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      if (variant){
        gvariant = variant;
        let metafields = Shopify.productMeta[variant.id];
        let current_quantity = parseInt($('.product-form__input[name="quantity"]').val());
        let quantity_validation_msg = "";
        if(metafields?.max_quantity || metafields?.min_quantity){
        if(metafields?.max_quantity){
          let max_quantity = parseInt(metafields?.max_quantity);
          $('.product-single .product-form__input[name="quantity"]').attr('data-max',max_quantity);
          quantity_validation_msg = window.max_msg_on_pdp.replaceAll('XXX',max_quantity);
          if(current_quantity > max_quantity){
            $('.product-single .product-form__input[name="quantity"]').val(max_quantity).change();
          }
        }else{
          $('.product-single .product-form__input[name="quantity"]').removeAttr('data-max');
          $('.product-form__input[name="quantity"]').parents('.qtyField').find('.plus').removeClass('disabled');
        }
        if(metafields?.min_quantity){
          let min_quantity = parseInt(metafields?.min_quantity);
          quantity_validation_msg = window.min_msg_on_pdp.replaceAll('XXX',min_quantity);
          $('.product-single .product-form__input[name="quantity"]').attr('data-min',min_quantity);
          if(current_quantity < min_quantity){
            $('.product-single .product-form__input[name="quantity"]').val(min_quantity).change();
          }
        }else{
          $('.product-single .product-form__input[name="quantity"]').removeAttr('data-min');
          $('.product-form__input[name="quantity"]').parents('.qtyField').find('.minus').removeClass('disabled');
        }
        if(quantity_validation_msg != ""){
          $('.quantity-validation-show-message').text(quantity_validation_msg).removeClass('tw-hidden');
        }else{
          $('.quantity-validation-show-message').addClass('tw-hidden');
        }
        }else{
          const buffer = 1.02;
          let totalArea = 0
          if($(".calculateTotalArea").prop('checked') == true && ($('.estimation-input-area').length > 0 && $('.estimation-input-area').val().length > 0)){
            $('.estimation-input-area').each(function(){
              if($(this).val().replace(/,/g, '') > 0){
                totalArea += parseFloat($(this).val().replace(/,/g, ''));
              }
            })
          }
          $('.estimation-width-length').each(function(){
            if($(".calculateLengthAndWidth").prop('checked') == true &&  ($('.estimation-input-width').length > 0 && $('.estimation-input-width').val().length > 0) && ($('.estimation-input-length').length > 0 && $('.estimation-input-length').val().length > 0)){
              let getLength = parseFloat($(this).find('.estimation-input-length').val().replace(/,/g, ''));
              let getWidth = parseFloat($(this).find('.estimation-input-width').val().replace(/,/g, ''));
              let getLengthWidth = getLength * getWidth;
              totalArea += getLengthWidth
            }
          })
          if(totalArea > 0){
          let finalQty =  (totalArea * buffer) / parseFloat(metafields.sqftPerCarton)
          $('.product-single .product-form__input[name="quantity"]').val(Math.ceil(finalQty)).change();
          }
        }

        clearTimeout(window.quantity_validation_timer);
        $('.min-max-quantity-error').addClass('tw-hidden')
        
        $(this.selectors.productPrices).removeClass('visibility-hidden').attr('aria-hidden', 'true');
        
        if (variant.unit_price != undefined) {
          $("[data-unit-price]").html(theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat));
          $("[data-unit-base]").html(variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit);
          $(".price__unit").removeClass('hide');
        } else {
          $(".price__unit").addClass('hide');
        }

        if (variant.available){
          var quantity = $("#pvr-"+variant.id).text(),
          	  maxquantity = $("#quantity_message").data('qty');
          
          $(this.selectors.addToCart).prop('disabled', false);
          $(".add-to-cart-sticky").prop('disabled', false);
          if(CartJS.cart.items){
          let foundVariantInCart = false;
          if(window.isTemplokProduct == false && !$('.product-form__cart-submit').hasClass('grid__cart-submit')){
          $('.updateItem').remove();
          CartJS.cart.items?.forEach(items => {
            if(variant.id == items.id){
              $('.add-to-cart-sticky .item-available').addClass('tw-hidden');
              $('.add-to-cart-sticky .item-available').parent('button').addClass('updateItemBtn')
              if(variant.available){
              $('.add-to-cart-sticky .item-available').after('<div class="tw-flex tw-justify-center tw-items-center updateItem"><span class="button-add-x-items-to-cart tw-tracking-[1px] tw-leading-[21px] tw-text-[14px">Update quantity</span></div>')
              }
              $('.product-form__cart-submit .item-available').addClass('tw-hidden')
              $('.item-not-available').addClass('tw-hidden')
              $('.product-form__cart-submit .item-available').parent('button').addClass('updateItemBtn')
              if(variant.available){
                $('.product-form__cart-submit .item-available').after('<div class="tw-flex tw-justify-center tw-items-center updateItem">Update Quantity</div>');   
              }
              if(quantityChangeDetected == false){
              $('.qty-estimator-result-input').val(items.quantity);
              $('.qty-estimator-result-input').change();
              }
              foundVariantInCart = true;
              return true;
            }
          })
          }

          if(foundVariantInCart == false){
          $(".item-available").removeClass("tw-hidden");
          $(".item-not-available").addClass("tw-hidden");
          $('.product-form__cart-submit .item-available').parent('button').removeClass('updateItemBtn')
          $('.add-to-cart-sticky .item-available').parent('button').removeClass('updateItemBtn')
          $('.updateItem').remove();
          if(quantityChangeDetected == false){
          let min_quantity = parseInt(metafields?.min_quantity);
          if(metafields?.min_quantity){
            $('.product-single .product-form__input[name="quantity"]').val(min_quantity).change();
          }else{
            $('.qty-estimator-result-input').val(1);
            $('.qty-estimator-result-input').change();
          }
          }
          }
          }
          if(quantity < 1 && variant.inventory_management == "shopify"){
          	$(this.selectors.addToCartText).text(theme.strings.preOrder);
          } else {
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
          }
          
          if(quantity < 1 && variant.inventory_management == "shopify"){
            $(".stockLbl").removeClass('instock outstock').addClass('preorder').text($(".stockLbl").data("pre"));
          } else {
            $(".stockLbl").removeClass('preorder outstock').addClass('instock').text($(".stockLbl").data("in"));
          }
          if(quantity < maxquantity && quantity != 0 && variant.inventory_management == "shopify"){
          	$("#quantity_message").show().find(".items").text(quantity);
          } else {
            $("#quantity_message").hide();
          }
          
        } else {
          let foundVariantInCart = false;
          CartJS.cart.items?.forEach(items => {
            if(variant.id == items.id){
              if(quantityChangeDetected == false){
                $('.qty-estimator-result-input').val(items.quantity);
                $('.qty-estimator-result-input').change();
              }
              foundVariantInCart = true;
              return true;
            }
          });
          if(foundVariantInCart == false){
            if(quantityChangeDetected == false){
              let min_quantity = parseInt(metafields?.min_quantity);
              if(metafields?.min_quantity){
                $('.product-single .product-form__input[name="quantity"]').val(min_quantity).change();
              }else{
                $('.qty-estimator-result-input').val(1);
                $('.qty-estimator-result-input').change();
              }
            }
          }
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(".add-to-cart-sticky").prop('disabled', true);
          $(".updateItem").addClass("tw-hidden");
          $(".item-available").addClass("tw-hidden");
          $(".item-not-available").removeClass("tw-hidden");
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(".stockLbl").removeClass('preorder instock').addClass('outstock').text($(".stockLbl").data("out"));
          $("#quantity_message").hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(".add-to-cart-sticky").prop('disabled', true);
        $(".updateItem").addClass("tw-hidden");
        $(".item-available").addClass("tw-hidden");
        $(".item-not-available").removeClass("tw-hidden");
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices).addClass('visibility-hidden').attr('aria-hidden', 'false');
        $(".stockLbl").removeClass('preorder instock').addClass('outstock').text($(".stockLbl").data("out"));
        $("#quantity_message").hide();
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant,
      	  sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize),
      	  zoomSizedImgUrl;
      this._setActiveThumbnail(sizedImgUrl);
      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageZoomSize);
      }
      this._switchImage(sizedImgUrl, zoomSizedImgUrl);
    },
    _updatePriceHelper: function(variant) {
      let metafields = Shopify.productMeta[variant.id];
      $(this.selectors.SKU).html(variant.sku);
      
      const priceContainer = $('.js-price-container');
      const detectedZipcode = localStorage.getItem('zipcode')?localStorage.getItem('zipcode'):localStorage.getItem('detectedZipcode');
      const surchargeZone = localStorage.getItem('surchargeZone');
      const initialZone = localStorage.getItem('initialZone');
      const savePercentageContainer  = priceContainer.find('.js-save-percentage');
      const hasDiscountMeta = isGridTemplate() ? Shopify.hasDiscount?.toString() : metafields.hasDiscount;
      var applyDiscount = localStorage.getItem('applyDiscount') === 'true' && hasDiscountMeta === 'true';
      var applyVolDiscount = checkDiscounts(metafields.hasVolDiscount, lsVolumeDiscount)
      var __rpaPercentage = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getProductSurchargeAmount(metafields) : "0";
      
      const originalPricePerSqft = metafields.pricePerSqftUnformatted * 100;
      const discountedPrice = originalPricePerSqft - ((originalPricePerSqft * metafields.discount) / 100);
      const pricePerSqft = applyDiscount ? discountedPrice.toString() : originalPricePerSqft.toString();
      const variantPrice = applyDiscount ? parseFloat(metafields.priceWithDiscount) : variant.price;
      const currentPrice = $('.kanopi-current-variant-price:not(.grid-price)');
      const quantityInput = $('.tw-kanopi-product #quantity');
      const quantityValue = quantityInput.length ? parseInt(quantityInput.val()) : 1;
      let subtotal = variantPrice * quantityValue;
      const price_per_unit = pricePerSqft;
      const surchargeVal = (variantPrice * __rpaPercentage / 100);
      const surcharge_price = __rpaPercentage.includes('-') ? surchargeVal : Math.round(surchargeVal);
      const finalPrice = surcharge_price + variantPrice;
      const finalSurchargeSqft = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getSurchargePriceHelper(originalPricePerSqft, __rpaPercentage, false) : theme.Currency.formatMoney(price_per_unit * 100, theme.moneyFormat);
      const finalSurchargePrice = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getSurchargePriceHelper(variantPrice, __rpaPercentage) : theme.Currency.formatMoney(finalPrice, theme.moneyFormat);
      const finalSurchargePriceFromOriginal = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getSurchargePriceHelper(variant.price, __rpaPercentage) : theme.Currency.formatMoney(finalPrice, theme.moneyFormat);
      const discounted_RPA_sqft = kanopiSurcharge._getSurchargePriceHelper(pricePerSqft, __rpaPercentage);
      const discounted_RPA_price = kanopiSurcharge._getSurchargePriceHelper(variantPrice, __rpaPercentage) 
      currentPrice.data('price', finalPrice/100);
      currentPrice.html(finalSurchargePrice);
      applyDiscount? $('.discounts__regular').html("Active") : $('.discounts__regular').html("Disabled");
      applyVolDiscount? $('.discounts__volume').html("Active") : $('.discounts__volume').html("Disabled");

      $('.rpa_zipcode').html(`${surchargeZone} - ${detectedZipcode}`);
      $('.rpa_price').html(finalSurchargePriceFromOriginal);
      $('.rpa_percentage').html(__rpaPercentage);
      $('.rpa_price_surcharge').html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      $('.rpa_price_sqft').html(metafields.pricePerSqft);
      $('.new_rpa_price_sqft').html(finalSurchargeSqft);
      if (__rpaPercentage != "0") {
        $(this.selectors.pricerPerUnit).html(discounted_RPA_sqft);
        if (__rpaPercentage != "0" && applyDiscount ) {
           $('.normal_price_debug').html("Normal price + RPA : " + finalSurchargePriceFromOriginal);
           $('.new_price_debug').html("New price with discount + RPA : " + discounted_RPA_price);
           $('.normal_price_debug_sqft').html("Normal price sqft + RPA : " + finalSurchargeSqft);
           $('.new_price_debug_sqft').html("New sqft with discount + RPA : " + discounted_RPA_sqft);
        } else {
          $('.normal_price_debug').html("");
          $('.new_price_debug').html("");
          $('.normal_price_debug_sqft').html("");
          $('.new_price_debug_sqft').html("");
        }
      }
      else{
        $(this.selectors.pricerPerUnit).html(kanopiSurcharge._getSurchargePriceHelper(pricePerSqft, "0"));
        $('.normal_price_debug').html("Normal price : " + theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        $('.new_price_debug').html("New price : " + theme.Currency.formatMoney(variantPrice, theme.moneyFormat));
        $('.normal_price_debug_sqft').html("Normal price sqft: "+metafields.pricePerSqft);
        $('.new_price_debug_sqft').html("New sqft with discount: " + pricePerSqft)
      }
        
        $('.variant-price-change').html(finalSurchargePrice);


      let wsg_count_tries = 0; //count wholesale tries
      const displayPrice = () => {
        const priceLoad = $('.tw-loading-price');
        if(priceLoad.length) priceLoad.removeClass('tw-loading-price');
      }
      const wsgInterval = setInterval(() => {
          if (wsg_count_tries >= 1){
            clearInterval(wsgInterval);
          }
          wsg_count_tries ++;
          
          const originalPricePerSqft = metafields.pricePerSqftUnformatted;
          const price_per_unit = parseFloat(pricePerSqft.substring(1));
          const surchargeVal = variantPrice * (__rpaPercentage/100);
          const surcharge_price = __rpaPercentage.includes('-') ? surchargeVal : Math.floor(surchargeVal);
          const finalPrice = surcharge_price + variantPrice;
          const finalSurchargeSqft = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getSurchargePriceHelper(originalPricePerSqft, __rpaPercentage, false) : theme.Currency.formatMoney(price_per_unit * 100, theme.moneyFormat);
          const finalSurchargePrice = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getSurchargePriceHelper(variantPrice * quantityValue, __rpaPercentage) : theme.Currency.formatMoney(finalPrice * quantityValue, theme.moneyFormat);
            
            //Normal price, compare at or discount  
            if(applyDiscount) {
              if (__rpaPercentage != 0) {
                //change prices on discounts crossed out regular section.
                $('.original-price').html(finalSurchargePriceFromOriginal);
                $(this.selectors.pricerPerUnitReg).html(finalSurchargeSqft);
              }else {
                $(this.selectors.pricerPerUnitReg).html(metafields.pricePerSqft);
                $(this.selectors.productPriceReg).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
              }
              
              savePercentageContainer.removeClass('tw-hidden');
              priceContainer.length && priceContainer.addClass('show-discounts');
              displaySaleFlagOnPDP(true);
            } else if (__rpaPercentage == 0 && !applyVolDiscount && (variant.compare_at_price > variant.price)) {
              let pricePerSqftCompare  = variant.compare_at_price / metafields.sqftPerCarton;
              $(this.selectors.pricerPerUnitReg).html(theme.Currency.formatMoney(pricePerSqftCompare, theme.moneyFormat));
              $(this.selectors.productPriceReg).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));  
              savePercentageContainer.addClass('tw-hidden');
              priceContainer.length && priceContainer.addClass('show-discounts');
            } else {
              priceContainer.length && priceContainer.removeClass('show-discounts');
              if(checkDiscounts(metafields.hasVolDiscount, lsVolumeDiscount)){
                displaySaleFlagOnPDP(true);
              } else {
                displaySaleFlagOnPDP(false);
              }  
            }
            displayPrice();
            return;
      }, 500);
    },
    _updatePrice: async function(evt) {
      var variant = evt.variant;
      let metafields = Shopify.productMeta[variant.id];
      if (parseFloat(metafields.sqftPerCarton) > 0 ) {
        $(this.selectors.sqftPerCarton).parent().show();
        $('.convers-price').show();
      }
      else {
        $(this.selectors.sqftPerCarton).parent().attr('style','display:none !important')
        $('.convers-price').attr('style','display:none !important')
      }
      $(this.selectors.sqftPerCarton).html(metafields.sqftPerCarton);
      if (variant)
        this._updatePriceHelper(variant);
      //$(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      $('.price-unit-covers').data('covers',metafields.sqftPerCarton);
      $('.price-unit-qty-number').data('qty',metafields.priceUnitsTileQty);
      var sectionId = $('.pdp-container').data('section-id');
      var url = window.location.origin + window.location.pathname;
      var res = await fetch(url + '?variant=' + variant.id + '&sections=' + sectionId)
                        .then(res => res.json())
                        .then(resJson => {
                          var stockClass = 'stock-info-banner';
                          var stockClassEnd = 'stock-info-banner-end';
                          var sectionString = resJson[sectionId];
                          sectionString = sectionString.substring(sectionString.indexOf(stockClass) + (stockClass.length + 2));
                          sectionString = sectionString.substring(0,sectionString.indexOf(stockClassEnd) + (stockClassEnd.length + 2));
                          $('.' + stockClass).html(sectionString);                         
                          var ship_time = $('.product-form__variants option:selected').data('shipping_time');;
                          if (ship_time) {
                              $('.' + stockClass + ' .days').html(ship_time);
                          }
                          
                        });

      //Express Shipping setup
      if (metafields.isExpress == "true") {
        $('.kanopi-express-shipping').removeClass('tw-hidden');
      } else {
        $('.kanopi-express-shipping').addClass('tw-hidden');
      }

      $('.cart-qty').change();
      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass('hide');
        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('hide');        
        var price1 = variant.compare_at_price-variant.price,
        	price2 = price1 * 100,
        	salecount = price2/variant.compare_at_price;        
        $(this.selectors.discountBadge).find('.off').find('span').text(+salecount.toFixed());        
        $(this.selectors.discountBadge).removeClass('hide');
        $(this.selectors.saveAmount).html(theme.Currency.formatMoney(price1,  theme.moneyFormat));        

      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.discountBadge).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }

      this._setCurrentProductMeta(variant.id);

      // const tileCalculatorForm = $('.estimation-form-inputs');
      // const tileCalculatorWrapper = $('.qty-estimator-toggle');
      // const triggerCalculator = () => {
      //   !tileCalculatorWrapper.hasClass('tw-hidden') && tileCalculatorForm.trigger('submit');
      // }
      //if(tileCalculatorForm.length && tileCalculatorWrapper.length) triggerCalculator();
      forceFirstUpdate = true; //force one update
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    },

    /**
     * Set `currentProductMeta` instance variable with the current variant metafield data
     */
    _setCurrentProductMeta: function (variantId) {
      this.currentProductMeta = Shopify.productMeta && Shopify.productMeta[variantId] || {};
    },

    /*
      Add actions when first variant is selected
    */
    _initVariantPrice : function(variant) {
      if (variant)
        this._updatePriceHelper(variant);
    },
    _setVolDscVisibility: function(evt) {
      const variant = evt.variant;
      const volDscWrapper = $('.volume_promotion_msg.vol-pdp');
      if(typeof variant === 'undefined' || volDscWrapper.length === 0) return;
      
      const metafields = Shopify.productMeta[variant.id];
      const applyVolDsc = checkDiscounts(metafields.hasVolDiscount, lsVolumeDiscount);
      if(applyVolDsc) {
        const volDscMsg = $('.volume_promotion_msg.vol-pdp .promotion-text');
        volDscMsg.text(metafields.volumeMsg);
        if(metafields.volumeSubMsg){
          $('.volume_promotion_msg.vol-pdp .promotion-info').html(metafields.volumeSubMsg)
        } else {
          $('.volume_promotion_msg.vol-pdp .promotion-info').html("");
        }
        if(metafields.variantTierData){
          const tiers = JSON.parse(metafields.variantTierData);
          if (tiers.length > 0) {
              tiers.sort((a, b) => a.tier_min_quantity - b.tier_min_quantity);
              let tierListData = '';
              tiers.forEach((tier, index) => {
                  let discountValue = (tier.tier_discount_type === "percentage") 
                      ? `${tier.tier_discount_percentage}%` 
                      : `$${tier.tier_discount_amount}`;
                  if (index === tiers.length - 1) {
                      tierListData += `<li>${tier.tier_min_quantity}+ cartons: ${discountValue} off</li>`;
                  } else {
                      tierListData += `<li>${tier.tier_min_quantity}-${tier.tier_max_quantity} cartons: ${discountValue} off</li>`;
                  }
              });
              $('.volume_promotion_msg.vol-pdp .tier-discount-list').html(tierListData);
          }
      }

        volDscWrapper.addClass('active');
      }else {
        volDscWrapper.removeClass('active');
      }
    },

    /**
     * Instantiates a product swatch modal(currently for Edge and Grid) and initializes an image slider.
     * Also attaches event listener for slider controls.
     *
     */
    _initSwatchModal: function () {
      var $slideshow = $(this.slideshow);
      var dots = $('.dot', this.selectors.modalSliderSelector);
      var prevBtn = $('.slide-control .slick-prev', this.selectors.modalSliderSelector);
      var nextBtn = $('.slide-control .slick-next', this.selectors.modalSliderSelector);

      // slide image by clicking dots
      dots.click(function (evt) {
        $slideshow.slick('slickGoTo', $(evt.currentTarget).index(), false);
      });
      // slide to previous one
      prevBtn.click(function () {
        $slideshow.slick('slickPrev');
        $(this).blur();
        
      });
      // slide to next one
      nextBtn.click(function () {
        $slideshow.slick('slickNext');
        $(this).blur();
      });

      // synchronize UI state
      $slideshow.on('init afterChange', function (_, slick) {
        var currentSlide = slick.currentSlide;
        var isLast = currentSlide === slick.slideCount - 1;
        prevBtn.prop('disabled', currentSlide === 0);
        nextBtn.prop('disabled', isLast);
        // update dots state
        dots.removeClass('active').eq(currentSlide).addClass('active');
        $('.modal-body').animate({scrollTop:0}, 'slow');
        // update image label
        var label = isLast ? 'What is an Edge Profile?':'What is a Grid?';
        var dir = isLast ? 'Previous' : 'Next';
        $('.slide-control .slide-title').text(label);
        $('.slide-control .slide-title-dir').text(dir);
      });
      
    },


    /**
     * Instantiates a tile estimator modal and add listener to open the modal.
     */
    _initQuantityEstimator: function () {
      //var modal = new window.Modals(this.selectors.qtyEstimatorSelector.slice(1), 'product-tile-estimator');

      var ESTIMATION_TYPE = {
        DIMENSION: 'dimension',
        AREA: 'area'
      };
      var LIST_LABEL_TEMPLATE_PREFIX = '#estimation-input-list-label';
      var LIST_ITEM_TEMPLATE_PREFIX = '#estimation-input-list-item';

      var estimationForm = $('.estimation-form-inputs');
      var listLabelContainer = $('.estimation-input-list-label-container');
      var resultContainer = $('.result-container');

      // Store input label templates per `ESTIMATION_TYPE` enum
      var listLabelTemplates = {};
      listLabelTemplates[ESTIMATION_TYPE.DIMENSION] = $([LIST_LABEL_TEMPLATE_PREFIX, ESTIMATION_TYPE.DIMENSION].join('-')).html();
      listLabelTemplates[ESTIMATION_TYPE.AREA] = $([LIST_LABEL_TEMPLATE_PREFIX, ESTIMATION_TYPE.AREA].join('-')).html();

      // Store input field templates per `ESTIMATION_TYPE` enum
      var listItemTemplates = {};
      listItemTemplates[ESTIMATION_TYPE.DIMENSION] = $([LIST_ITEM_TEMPLATE_PREFIX, ESTIMATION_TYPE.DIMENSION].join('-')).html();
      listItemTemplates[ESTIMATION_TYPE.AREA] = $([LIST_ITEM_TEMPLATE_PREFIX, ESTIMATION_TYPE.AREA].join('-')).html();

      // Set initial state
      var currentEstimationType = ESTIMATION_TYPE.AREA;
      var listItemContainer ="";
      const isGridTemplate = $('.ptContainer.pdp-container').data('template') === 'grid-template' ? true : false;
      if(isGridTemplate) {
        listItemContainer= $('#estimator-grid-type-'+ currentEstimationType +' .estimation-input-list-items');
      }else{
        listItemContainer = $('.estimation-input-list-items');
      }
      resetForm(currentEstimationType);

      // Set context same as instance
      var performEstimate = $.proxy(performEstimate, this);

      // Estimation Type Radio Group change handler
      $('input[name="estimation-type"]').on('click', function () {
        currentEstimationType = $(this).val();
        if(isGridTemplate){
          listItemContainer= $('#estimator-grid-type-'+ currentEstimationType +' .estimation-input-list-items');
        }
        $('.qty-estimator-results-txt-inner').addClass('tw-hidden');
        resetForm(currentEstimationType);
      });

      // `Add Area` button click handler
      $('.add-btn').on('click', function () {
        var itemTmpl = listItemTemplates[currentEstimationType];
        listItemContainer.append(itemTmpl);
        checkListItemCount();
      });

      // `Remove Area` button click handler
      if(isGridTemplate){
        $('.estimation-input-list-items').on('click', '.remove-btn', function () {
          $(this).parents('.estimation-input-list-item').remove();
          estimatorGrid.step2ValidateButton();
          checkListItemCount();
        });
        $('.estimation-input-list-items').on('keydown', 'input', function () {
          $(this).parent().removeClass('has-error');
        });
      }else{
        listItemContainer.on('click', '.remove-btn', function () {
          $(this).parent().parent().remove();
          checkListItemCount();
        });
      }
      
      resultContainer.on('click', '.update-quantity-btn', function () {
        $('input.qty').val(resultContainer.data('quantity'));
       // modal.close();
      });

      estimationForm.submit(function (event) {
        event.preventDefault();
        handleCalculation();
      });
      
      const inputField = document.querySelector('.js-auto-calculation-input');
      inputField?.addEventListener('input', handleCalculation);
      
      inputField?.addEventListener('click', handleRemove);
      
      function handleCalculation() {
        const dimensionInput = document.getElementById('estimation-type-dimension');
        let applyDefault = {"totalArea": 1, "quantity": 1};
        if(dimensionInput?.checked) {
          const inputLength = document.querySelector('.estimation-input-length');
          const inputWidth = document.querySelector('.estimation-input-width');
          if(validateInput(inputLength) && validateInput(inputWidth)) applyDefault = false;
        }else {
          const inputArea = document.querySelector('.estimation-input-area');
          if(validateInput(inputArea)) applyDefault = false;
        }
        calculateEstimation(applyDefault);
      }
      
      function handleRemove(e) {
        const element = e.target;
        if(element.classList.contains('remove-btn') || element.closest('.remove-btn')) handleCalculation();
      }
      
      function calculateEstimation(setDefault = false) {
        var result = !setDefault ? performEstimate() : setDefault;
        var resultContainerTmpl = $('#estimation-result-container').html();
        resultContainerTmpl = resultContainerTmpl.replace('{sqrt}', result.totalArea.toFixed(2));
        if (result.quantity) {
          $resultContainerTmpl = $(resultContainerTmpl);
          var quantityValue = $('.estimated-quantity-value', $resultContainerTmpl);
          var resultUnitSingular = quantityValue.data('resultUnitSingular');
          var resultUnitPlural = quantityValue.data('resultUnitPlural');
          var resultUnit = result.quantity > 1 ? resultUnitPlural : resultUnitSingular;
          quantityValue.text(result.quantity + ' ' + resultUnit);
          resultContainer.html($resultContainerTmpl.html()).data('quantity', result.quantity);
          
          var formattedTotalArea = result.totalArea.toFixed(2).toString();
          x = formattedTotalArea.toString();
          var pattern = /(-?\d+)(\d{3})/;
          while (pattern.test(formattedTotalArea))
            formattedTotalArea = formattedTotalArea.replace(pattern, "$1,$2");
          
          $('.qty-estimator-result-input').val(result.quantity);
          $('.qty-estimator-result-input').change();
          $('#qty-estimator-calculated-area').html(formattedTotalArea);
          if(setDefault){
            $('.qty-estimator-results-txt-inner').addClass('tw-hidden')
          }else{
            if (
              ($('.estimation-input-area').length > 0 && $('.estimation-input-area').val().length > 0 && $('.estimation-input-area').val() != 0) ||
              ($('.estimation-input-width').length > 0 && $('.estimation-input-width').val().length > 0 && $('.estimation-input-width').val() != 0) &&
              ($('.estimation-input-length').length > 0 && $('.estimation-input-length').val().length > 0 && $('.estimation-input-length').val() != 0)
            ){
            $('.qty-estimator-results-txt-inner').removeClass('tw-hidden')
            }
          }

          if(result.totalArea > 1 && result.quantity >= 1){
            quantityChangeDetected = true;
            //updateProductQuantity()
          }else{
            quantityChangeDetected = false;
            updateProductQuantity()
          }
        }
      }

      
      $('.close-estimator').click(function () {
        $('.qty-estimator-toggle').addClass('tw-hidden');
        $('.how-much-you-need').removeClass('tw-hidden');
      });
       
      $('.qty-estimator-result-input').change(function() {
        if (
          ($('.estimation-input-area').length > 0 && $('.estimation-input-area').val().length > 0 && $('.estimation-input-area').val() != 0) ||
          ($('.estimation-input-width').length > 0 && $('.estimation-input-width').val().length > 0 && $('.estimation-input-width').val() != 0) &&
          ($('.estimation-input-length').length > 0 && $('.estimation-input-length').val().length > 0 && $('.estimation-input-length').val() != 0)
        ){
          $('.qty-estimator-results-txt-inner').removeClass('tw-hidden');
        }else{
          $('.qty-estimator-results-txt-inner').addClass('tw-hidden');
        }
        
      });

      // open modal when the quantity estimator link is clicked
      $(this.selectors.qtyEstimatorLinkSelector).on('click', function () {
        currentEstimationType = ESTIMATION_TYPE.DIMENSION;
        resetForm(currentEstimationType);
        // modal.open();
      });

      // Reset the input form with given estimation type
      function resetForm(estimationType) {
        $('input[name="estimation-type"][value=' + estimationType + ']').prop('checked', true);
        listLabelContainer.html(listLabelTemplates[estimationType]);
        listItemContainer.empty();
        listItemContainer.append(listItemTemplates[estimationType]);
        checkListItemCount();
        resultContainer.empty();
      }

      // House keeping `Remove Area` button
      function checkListItemCount() {
        var listItems = listItemContainer.children();
        var firstItem = listItems.first();
        var removeBtnContainer = $('.remove-btn-container', firstItem);
        // remove `Remove Area` button if there is only one item, otherwise have `Remove Area` button to all items
        if (listItems.length === 1) {
          removeBtnContainer.empty();
        } else if (removeBtnContainer.children().length === 0) {
          removeBtnContainer.html($('.remove-btn-container', listItemTemplates[currentEstimationType]).html());
        }
      }

      // Calculate to Total Area (sqft) and Estimated Quantity and return the result.
      function performEstimate() {
        var AREA_BUFFER_RATIO = 1.02;
        var sqftPerCarton = Number(this.currentProductMeta.sqftPerCarton);
        var listItems = listItemContainer.children();
        var $totalAreaList;
        var totalArea;
        var quantity;

        if (currentEstimationType === ESTIMATION_TYPE.DIMENSION) {
          $totalAreaList = listItems.map(function () {
            var lengthEl = $('.estimation-input-length', this);
            var widthEl = $('.estimation-input-width', this);
            var length = lengthEl.val();
            var width = widthEl.val();
            // IE11 treatment
            // Number input in IE11 allows to type non-numeric value only when it's followed by numeric value
            // Converting the input value after stripping out non-numeric value should return number
            // Empty input is already checked by required form validation before submission
            length = Number(length.replace(/[^0-9.]/g, ''));
            width = Number(width.replace(/[^0-9.]/g, ''));
            return length * width;
          });
        } else {
          $totalAreaList = listItems.map(function () {
            var areaEl = $('.estimation-input-area', this);
            var area = areaEl.val();
            area = Number(area.replace(/[^0-9.]/g, ''));  
            return area;
          });
        }
        totalArea = $totalAreaList
          .get()
          .reduce(function (acc, item) {
            acc += item;
            return acc;
          });

        // Additional material to cover any breaks or waste
        totalArea = totalArea * AREA_BUFFER_RATIO;
        if(typeof estimatorGrid != "undefined" && typeof estimatorGrid.calculateUpsell === 'function'){
          estimatorGrid.calculateUpsell(totalArea);
        }else if(typeof installationModal != "undefined" && typeof installationModal.calculateUpsell === 'function'){
          installationModal.calculateUpsell(totalArea);
          
        }

        // totalArea = roundOffTo(totalArea);// round to next 100

        if (sqftPerCarton) {
          quantity = Math.ceil(totalArea / sqftPerCarton);
        }
        //Set default values to be calculated on variant change.
        totalArea = totalArea > 0 ? totalArea : 1;
        quantity = quantity > 0 ? quantity : 1;
        return {
          totalArea: totalArea,
          quantity: quantity
        };
      }
    },
    _initPatternLibrary: function() {
      /* Patterns slider and modal */
      const isCenter = $('#patternSlider .pattern-item').length > 1 ? true : false;
      $('#patternSlider').slick({
        centerMode: false,
        slidesToShow: 3,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: isCenter,
              centerPadding: '58px',
            }
          }
        ]
      });
      $('#patternSlider .pattern-item').on('mouseover', function() {
        if ($(window).width() >= 1025) {
          const $self = $(this);
          const alternative_image = $self.attr("alt-img");
          const img = $self.find('.pattern-img');
          img.attr('src', alternative_image);
        }

      });
      $('#patternSlider .pattern-item').on('mouseout', function() {
        if ($(window).width() >= 1025) {
          const $self = $(this);
          const regular_image = $self.attr("bg-img");
          const img = $self.find('.pattern-img');
          img.attr('src', regular_image);
        };
      });
      $("#patternSlider .pattern-item").on("click", function() {
        const slider_position = $(this).attr("slide_position");
        const productPatterns = $('.js-pattern-modal-slider .pattern-item');
        productPatterns.each(function() {
          const variantItems = $(this).find('.variant-item');
          const buy_btn = $(this).closest(".pattern-item").find(".cart-btn .submit_button");
          const mobile_buy_btn = $(this).closest(".pattern-item").find(".mobile-footer .cart-btn-mobile .submit_button");
          patternsDisableBuy(variantItems, buy_btn, mobile_buy_btn);
        });
        $('.js-pattern-modal-slider').slick('slickGoTo', slider_position);
        setTimeout(() => {
          $('.modal-content').removeClass('invisible');
          $('.js-pattern-modal-slider').removeClass('invisible');
          $('.js-pattern-modal-slider').slick('refresh');
          setPatternScrollToTop();
          insertActiveClassToDots();
        }, 500);
      });
      $('.js-pattern-modal-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: true,
        dotsClass: 'slick-dots pattern-dots',
        appendDots: $('.dots-wrapper.dots'),
        prevArrow: $('.arrows-wrapper .left-arrow-wrapper .left-arrow'),
        nextArrow: $('.arrows-wrapper .right-arrow-wrapper .right-arrow'),
        initialSlide: 0,
      });
      $('.js-qty-input').each(function() { 
        calculateQuantityPatternModal($(this)); 
      });  
      $('.js-pattern-modal-slider').on('beforeChange', function(){
        setPatternScrollToTop();
      });
      function setPatternScrollToTop() {
        const pattern_item_content = $('.pattern-item .item-content');
        pattern_item_content.scrollTop(0);
      }
      /* Add Active Class to patterns dots after to refresh slick */
      function insertActiveClassToDots() {
        $("#modal-patterns .js-pattern-modal-slider .slick-slide").each(function( index ) {
          const dots_list = $(this).find(".dots-wrapper .slick-dots li");
          const active_dot = $(dots_list.get(index));
          active_dot.addClass('slick-active active');
        });
      }
      //When Close Modal
      $("#modal-patterns").find(".btn--link").on("click", function() {
        setTimeout(() => {
          $('#modal-patterns .modal-content').addClass('invisible');
          $('.js-pattern-modal-slider').addClass('invisible');
          removeBundleAllBundlesKits();
      }, 250);
      });
      $("#modal-patterns").keyup(function(e){
        if(e.which==27) {
          setTimeout(() => {
            $('#modal-patterns .modal-content').addClass('invisible');
            $('.js-pattern-modal-slider').addClass('invisible');
            removeBundleAllBundlesKits();
        }, 250);
        }
      });
      // Enable the zoom on the modal items
      _enableZoom($(this.selectors.patternModalImageWrap));
    },
  });

  function _enableZoom($el) {
    $($el).each(function(){
    	var zoomUrl = $(this).data('zoom');
    	$(this).zoom({
      		url: zoomUrl
    	});
     });
  }

  function _destroyZoom($el) {
    $($el).each(function(){
    	$(this).trigger('zoom.destroy');
     });
  }
  return Product;
})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.forEach(function(modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute('data-media-id');
      var modelViewerElement = modelViewerContainer.querySelector(
        'model-viewer'
      );
      var modelId = modelViewerElement.getAttribute('data-model-id');

      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
        var xrButton = mediaGroup.querySelector(selectors.xrButton);
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var modelJson = document.querySelector('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
        }
      }
    }
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();

function addStylesForMovedElements () {
  
 let pdpSamplesCalloutDesktopLeft = $('.tw-kanopi-product').find('.kanopi-samples.blockSide-Desktop-left:visible');
 let pdpSamplesCalloutTabletLeft =  $('.tw-kanopi-product').find('.kanopi-samples.blockSide-Tablet-left:visible');

  if(pdpSamplesCalloutDesktopLeft.length>0){
    pdpSamplesCalloutDesktopLeft.addClass('xl:tw-mt-6');
  }else if(pdpSamplesCalloutTabletLeft.length>0){
    pdpSamplesCalloutTabletLeft.eq(0).addClass('md:tw-mt-6');
  }
 
 let pdpSamplesCalloutDesktopRight = $('.tw-kanopi-product').find('.kanopi-samples.blockSide-Desktop-right:visible');
 let pdpSamplesCalloutTabletRight =  $('.tw-kanopi-product').find('.kanopi-samples.blockSide-Tablet-right:visible');

 //styling for all viewports for Left Side of the PDP
  if(pdpSamplesCalloutDesktopLeft.length == 1 ){
    pdpSamplesCalloutDesktopLeft.removeClass('xl:tw-border-none');
    pdpSamplesCalloutDesktopLeft.removeClass('tw-border-none')
    pdpSamplesCalloutDesktopLeft.css({'border-bottom':'1px','border-bottom-style': 'solid'});
  }else{
    pdpSamplesCalloutDesktopLeft.addClass('tw-border-none xl:tw-border-none');
    pdpSamplesCalloutDesktopLeft.removeAttr('style');
  }
  if(pdpSamplesCalloutTabletLeft.length == 1 ){
    pdpSamplesCalloutTabletLeft.removeClass('xl:tw-border-none');
    pdpSamplesCalloutTabletLeft.removeClass('tw-border-none')
    pdpSamplesCalloutTabletLeft.css({'border-bottom':'1px','border-bottom-style': 'solid'});
    pdpSamplesCalloutTabletLeft.find('hr').removeClass('tw-h-px');
  }else{
    pdpSamplesCalloutTabletLeft.addClass('tw-border-none xl:tw-border-none');
    pdpSamplesCalloutTabletLeft.removeAttr('style');
  }
  
  //styling for all viewports for Right Side of the PDP
  if(pdpSamplesCalloutDesktopRight.length == 1 ){
    pdpSamplesCalloutDesktopRight.removeClass('xl:tw-border-none');
    pdpSamplesCalloutDesktopRight.removeClass('tw-border-none')
    pdpSamplesCalloutDesktopRight.css({'border-bottom':'1px','border-bottom-style': 'solid'});
  }else{
    pdpSamplesCalloutDesktopRight.addClass('tw-border-none xl:tw-border-none');
    pdpSamplesCalloutDesktopRight.removeAttr('style');
  }
  if(pdpSamplesCalloutTabletRight.length == 1){
    pdpSamplesCalloutTabletRight.removeClass('xl:tw-border-none');
    pdpSamplesCalloutTabletRight.removeClass('tw-border-none')
    pdpSamplesCalloutTabletRight.css({'border-bottom':'1px','border-bottom-style': 'solid'});
    pdpSamplesCalloutTabletRight.find('hr').removeClass('tw-h-px');
  }else{
    pdpSamplesCalloutTabletRight.addClass('tw-border-none xl:tw-border-none');
    pdpSamplesCalloutTabletRight.removeAttr('style');
  }
}
//function to style pdp callouts for sample and tax exempt
// on right or left position of pdp for all viewports
addStylesForMovedElements()
$(window).on('resize', function(){
  addStylesForMovedElements()
});
function removeBundleAllBundlesKits () {
  //only for patterns
  $('.js-pattern-modal-slider').find('.pattern-item .add-bundles-installation').each(function (e) {
    $(this).hasClass('addedIBundle')?$(this).trigger('click'):'';
  })
}
function openLiveChat(){
  LiveChatWidget.call("maximize");
}
// Function to add event listener to to chat
function onVisibilityChanged(data) {
  const chatContainer = $('#chat-widget-container');
  if(chatContainer.length === 0) return;
  data.visibility === 'maximized' ? chatContainer.addClass('opened') : chatContainer.removeClass('opened');
}
LiveChatWidget.on('visibility_changed', onVisibilityChanged);
$('.js-qty-input').on('input', function() {  calculateQuantityPatternModal($(this)); });
function calculateQuantityPatternModal($el) {
  var qtyLimit = 0, newVal = 0;
  var qtyField = $el.closest(".qtyField"),
    oldValue = $(qtyField).find(".qty").val(),
    is_plus = false ;
  if ($el.is(".plus")) {
    newVal = parseInt(oldValue) + 1;
    is_plus=true;
  } else if($el.is(".js-qty-input")) {
    newVal = oldValue ? parseInt(oldValue) : 0;
  } else if (oldValue > qtyLimit) {
    newVal = parseInt(oldValue) - 1;
    is_plus=false;
  }
  if(isNaN(newVal)){
    newVal=1;
  }
  $(qtyField).find(".qty").val(newVal);
  const variant_table = $(qtyField).closest('.variants-table');
  const pattern_item = $(qtyField).closest('.pattern-item');
  const is_soundscape_pattern = pattern_item.hasClass('soundscape-pattern-item');
  if(is_soundscape_pattern){
    const inputs = $(pattern_item).find('.product-form__input.qty');
    inputs.val(newVal);
  }
  const quantity_text = is_soundscape_pattern ? variant_table.find('.pattern-quantity') : variant_table.find('#qtyPatternModalB');
  const plural_text = is_soundscape_pattern ? variant_table.find('.pattern-plural') : variant_table.find('#sButtonPattern');
  const quantity_text_mobile = is_soundscape_pattern ? pattern_item.find('.mobile-footer.buy-section .pattern-quantity') : pattern_item.find('.mobile-footer .cart-btn-mobile #qtyPatternModalB');
  const plural_text_mobile = is_soundscape_pattern ? pattern_item.find('.mobile-footer.buy-section .pattern-plural') : pattern_item.find('.mobile-footer .cart-btn-mobile #sButtonPattern');
  quantity_text.html(newVal);
  quantity_text_mobile.html(newVal);
  const add_all_pattern_count = pattern_item.find('.add_all_pattern_count');
  let totalVqty = 0;
  variant_table.find('.product-form__input.qty').each(function(){
    totalVqty+=Number($(this).val());
  });
  add_all_pattern_count.html(totalVqty);
  if(newVal == 1) {
    is_soundscape_pattern ? plural_text.addClass('tw-hidden') : plural_text.hide();
    is_soundscape_pattern ? plural_text_mobile.addClass('tw-hidden') : plural_text_mobile.hide();
  } else {
    is_soundscape_pattern ? plural_text.removeClass('tw-hidden') : plural_text.show();
    is_soundscape_pattern ? plural_text_mobile.removeClass('tw-hidden') : plural_text_mobile.show();
  }
  if(is_soundscape_pattern) {
    const cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .buy-button .submit_button');
    newVal > 0 ?  cart_btn.removeClass('disabled') : cart_btn.addClass('disabled');
    calculateSoundscapePatternSubtotal()
  }else {
    const productVariants = $('.js-pattern-modal-slider .pattern-item.slick-active .variant-item');
    const cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .cart-btn .submit_button');
    const mobile_cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .mobile-footer  .cart-btn-mobile .submit_button');
    patternsDisableBuy(productVariants, cart_btn, mobile_cart_btn);
  }
}

//Disable add to cart if all products are 0
function patternsDisableBuy($pattern_item, $cart_btn, $mobile_cart_btn) {
  if($cart_btn.hasClass('soundscape-btn')) return;
  let disable_cart_btn = true;
  $pattern_item.each(function(){
    const input_btn = $(this).find(".qtyField .product-form__input");
    if(input_btn.val() > 0) {
      disable_cart_btn = false;
      return false;
    }
  });
  if(disable_cart_btn) {
    $cart_btn.add($mobile_cart_btn).addClass("disabled");
  }else if($cart_btn.hasClass("disabled")){
    $cart_btn.add($mobile_cart_btn).removeClass("disabled");
  }
}
let productListModalPattern = "";
let patternTotalPrice = 0;
function addXitemsPattern () {
  const cart_btn = $('.js-pattern-modal-slider .pattern-item.slick-active .cart-btn .submit_button');
  if(cart_btn.hasClass("disabled")) {
    return false;
  }
  // if (typeof stackadaptService === "function") {
  //   stackadaptService();
  // }
  let productsToAdd = [];
  const patternItem = $('.js-pattern-modal-slider .pattern-item.slick-active');
  const isSoundsCapePattern = patternItem.hasClass('soundscape-pattern-item');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const productVariants = $('.js-pattern-modal-slider .pattern-item.slick-active .variant-item');
  const wrapperClass = isMobile ? 'mobile-footer' : 'desktop-footer';
  const quantitySoundscapeInput = isSoundsCapePattern ? patternItem.find(`.${wrapperClass} .product-form__input.qty`)?.val() : 0;
  productVariants.each(function(){
    const $self = $(this);
    let quantity = 0;
    const id_variant = $self.find('.dropdown-patterns .drop-color').attr('data-variant');
    const sku = $self.find('.data .sku').attr('sku');
    if(isSoundsCapePattern) {
      const patternQty = $self.find('.dropdown-patterns .drop-color').attr('pattern-qty');
      quantity = parseInt(patternQty) * quantitySoundscapeInput;
    }else {
      quantity = $self.find('.product-form__input.qty').val();
    }
    
    if(quantity > 0) {
      productsToAdd.push({id: id_variant, quantity: quantity , sku:sku});
    }
  });
  // add installation bundles kits section
  if(patternItem.find('.add-bundles-installation').hasClass('addedIBundle')){
    const kitId = patternItem.find('.bundle-kit-color-selected').attr("data-variant");
    const kitqty = patternItem.find('.bundle-kit-color-selected').attr("data-bundle-qty");
    productsToAdd.push({id: kitId, quantity: kitqty, isInstallationBundle: true});
  }
  $('#btn-patterns-close').click();
  // Add all the products to the cart
  addinToCartPattern(productsToAdd);
}
function calculateSoundscapePatternSubtotal() {
  let actualQty = $('.js-pattern-modal-slider .pattern-item.slick-active.soundscape-pattern-item').find('.qtyField .qty').val();
  let subtotal = 0;
  const patternTable = document.querySelector('.js-pattern-modal-slider .pattern-item.slick-active.soundscape-pattern-item');
  const selectedVariants = patternTable.querySelectorAll('.color__selected.drop-color');
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const qtyInput = isMobile ? patternTable.querySelector('.mobile-footer .product-form__input.qty') : patternTable.querySelector('.desktop-footer .product-form__input.qty');
  const subtotalElements = patternTable.querySelectorAll('.estimated-subtotal');
  selectedVariants.forEach(element => {
    const dropdownId = element.getAttribute('id');
    const variantId = element.getAttribute('data-variant');
    const dropdownSelectedElement = patternTable.querySelector(`div[id="dropdown-menu-${dropdownId}"] label[variant-id="${variantId}"] .swatchInput`);
    if($(element).hasClass('bundle-kit-color-selected')){
      const qtyKitPerPattern = $(element).attr('data-default-qty');
      const priceKit = $(element).attr('data-default-price');
      if (actualQty == 0){
        actualQty = 1;
        if($(patternTable).find('.add-bundles-installation').hasClass('addedIBundle')){
         $(patternTable).find('.add-bundles-installation').trigger('click');
        }
        $(patternTable).find('.add-bundles-installation').addClass('disable');
      }
      else {
        $(patternTable).find('.add-bundles-installation').removeClass('disable');
      }
      const newQty = qtyKitPerPattern * actualQty;
      const newPriceKits = newQty * priceKit;
      $(element).attr('data-bundle-qty',newQty);
      $(patternTable).find('.add-installation-accesories-container .content').text('Add ('+newQty+') Installation Bundles: '+Shopify.formatMoney(newPriceKits));
    }
    if(dropdownSelectedElement) {
      const variantPrice = dropdownSelectedElement.getAttribute('data-price-subunit');
      const patternQty = dropdownSelectedElement.getAttribute('pattern-qty');
      const variantTotal = parseInt(variantPrice) * parseInt(patternQty);
      subtotal += variantTotal;
    }
  });
  subtotal *=  qtyInput?.value;
  subtotalElements.forEach(subtotalElement => {
    subtotalElement.innerHTML = Shopify.formatMoney(subtotal);
  });
}
function gridUpsellCard_hasDiscount (element){
  if ($(element).find('.regular-wrp').hasClass('has-discount')){
    $(element).find('.regular-wrp').removeClass('has-discount');
    $(element).find('.promotion-wrp').addClass('hide');
    $(element).find('.product-form__item--quantity').removeAttr('data-discount-price');
  }
}

$('.add-bundles-installation').on("click", async function(e) {
  if(!$(this).hasClass('disable')) {
    $(this).toggleClass( "addedIBundle" );
    let format_id = "add-installation-kit-"+ $(this).data("id") ;
    $(this).parents().find("#"+format_id).slideToggle("slow");
  }
});
const initQuantityTotal = function () {
  quantityTotal = 0;
  const productVariant = document.querySelectorAll('.product__variant-checkbox');
  const checkBoxes = document.querySelectorAll('.product__variant-checkbox');
  for(var i = 0; i < productVariant.length; i++) {
    if(checkBoxes[i].checked) {
      quantity = document.getElementById('quantity-'+checkBoxes[i].getAttribute('data-id')).value;
      quantityInt = parseInt(quantity);
      quantityTotal = quantityTotal + quantityInt;
    } 
  }
  
  var baseItems = `${quantityTotal} item${ (quantityTotal > 1 ? 's' : '' ) }`;
  $('#qv-subtotal-items').html(` (${ baseItems })`);
  
}
function addinToCartPattern(products) {
  showOverly(true);
  removeBundleAllBundlesKits();
  $("body").addClass('loading');
  var itemsToAdd = [];
  products = products.reverse();
  products.forEach(function(product) {
    const props = {};
    if(localStorage.getItem('applyDiscount') == "true") props['_discount'] = false;
    product.hasOwnProperty('isInstallationBundle') ? props['_isInstallationBundle'] = true : props['_isDecorativePattern'] = true;
    let metafields = Shopify.productMeta[product.id];
    props['Item #'] = metafields.sku;
    props['_shipping_time'] = metafields && metafields.mfgProcess ? metafields.mfgProcess : '';
    props['__rpaPercentage'] = typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getProductSurchargeAmount(metafields) : 0;
    const currentObject = { id : product.id, quantity : product.quantity ,properties: props}
    itemsToAdd.push(currentObject)
  });
  CartJS.addItems(itemsToAdd.reverse());
}
function getDiscountPatterns(variant_id, dsc_input) {
  const dsc_input_val  = dsc_input.val();
  const apply_discounts = false;
  if(dsc_input_val.length > 0 && apply_discounts) {
    const variants = dsc_input_val.split(',');
    for (let variant of variants) {
      if(variant == '') continue;
      const [id, discount] = variant.split(':');
      if(id== variant_id) return discount;
    }
  }
  return false;
}
function openCartModal (id, itemsQty, isInstallationBundle) {
  const card_item = $(`.js-pattern-modal-slider .pattern-item.slick-active .variant-item[variant-id=${id}]`);//get #item element
  if((card_item.length < 1 && !isInstallationBundle) || !id) {
    return productListModalPattern;  
  }
  let variantTitle = '';
  let nItem = '';
  let quantity = 0;
  let unitPrice = ['$', '0'];
  
  if(isInstallationBundle) {
    const dataInput = $(`.js-pattern-modal-slider .pattern-item.slick-active .dropdown-patterns .dropdown-menu-color input[data-variant="${id}"]`);
    if(dataInput.length) {
      variantTitle = 'Installation Bundle';
      nItem = dataInput.attr('data-bundle-sku');
      quantity = itemsQty ? itemsQty : 0;
      unitPrice = dataInput.attr("data-bundle-price")?.split("$")
    }
  }else {
    variantTitle = card_item.find(".data .title").text(); // product title
    nItem = card_item.find(".data .sku").attr("sku");//item
    quantity = itemsQty ? itemsQty : card_item.find('.product-form__input.qty').val(); //quantity
    unitPrice = card_item.attr("variant-price").split("$"); // get UnitPrice
  }
  const totalPrice = (Number(unitPrice[1].replace(/,/g, '')) * Number(quantity)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").toLocaleString('en');
  const itemList  = '<p id="item-'+id+'" class = "text-list">'+variantTitle+', <span class = "noItem">'+nItem+' (x'+quantity+'): </span><span class = "totalPrice">$'+ totalPrice +'</span></p>';
  patternTotalPrice = parseFloat(patternTotalPrice) +  parseFloat((Number(unitPrice[1].replace(/,/g, '')) * Number(quantity)).toFixed(2));
  productListModalPattern = productListModalPattern+itemList;
  return productListModalPattern;
}

if(isDecorativeTemplate() && $('#modal-patterns').length > 0) {
  const modal_content = $('#modal-patterns .pattern-item .item-content');
  let transform_style = false;
  let placement_style = false;
  modal_content.on('scroll', function() {
    const dropdown_color = $('.dropdown.dropdown-patterns.show');
    if(dropdown_color.length > 0) {
      const dropdown_items = dropdown_color.find('.dropdown-menu-color');
      if(transform_style == false) {
        transform_style = dropdown_items.css('transform');
        placement_style = dropdown_items.attr('x-placement');
      }else if(transform_style != false && dropdown_items.attr('x-placement') != placement_style) {
        transform_style = dropdown_items.css('transform');
        placement_style = dropdown_items.attr('x-placement');
      }else if(transform_style != false && dropdown_items.css('transform')!= transform_style && dropdown_items.attr('x-placement') == placement_style) {
        dropdown_color.trigger('click');
        transform_style = false;
        placement_style = false;
      }
    }
  });
}
//disable body scroll if pattern modal is open - just for Safari Mobile
if(isSafariMobile() && isDecorativeTemplate() && $('#modal-patterns').length > 0) {
  document.ontouchmove = function(e) {
    const $target = $(e.target);
    const modal_content = $("#modal-patterns #content_modal").get(0);
    if($('body').hasClass('modal-open') && !($target.hasClass('.modal-content') || $.contains( modal_content, $target.get(0) ))) {
      document.body.addEventListener('touchmove', preventDefault, { passive: false });
    }else {
      document.body.removeEventListener('touchmove', preventDefault);
    }
  }
}

// Product quick view
theme.QuickView = (function() {
  $('body').on( 'click', '.quick-view', function(e){
    $.ajax({
      beforeSend : function (){
        $('body').addClass("loading");
       },
      url: $(this).attr('href'),
      success: function(data) {

        $.magnificPopup.open({
          items: {
            src: '<div class="quick-view-popup mfpbox mfp-with-anim" id="content_quickview">' + data + '</div>',
            type: 'inline'
          },
          removalDelay:500,
          callbacks: {
            beforeOpen: function(){
             $('.stickyHeader').addClass('popup');
              this.st.mainClass = 'mfp-zoom-in';
            },
            open: function() {              
              	$.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            },
            close: function() {
               $('.stickyHeader').removeClass('popup');
              $( '#content_quickview' ).empty();
            }
          },
        });
      },
      complete: function() {
        $('body').removeClass("loading");
      }
    })
    e.preventDefault();
    e.stopPropagation();
  });
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    rtl: theme.rtl,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);
    var sliderActive = false;

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }
     // Number of slides for mobile viewport on, ot overrides slidesToShow if window width is lower than 767px
     var windowWidth = $(window).width();         
     if  (windowWidth <= 767) {
      let calSlide = windowWidth / 316;
      let responsiveSlidesToShow = $(slider).attr('data-slick');
      responsiveSlidesToShow = responsiveSlidesToShow.replace('"settings":{"slidesToShow":1,', '"settings":{"slidesToShow":'+calSlide+',' );
      $(slider).attr('data-slick', responsiveSlidesToShow); 
      }
    $slider.on('init', this.a11y.bind(this));
    initSlider($slider, defaults);

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
     if  (windowWidth <= 767) {
        var mobileSlickSlider = slider;
        window.addEventListener("load", (event) => {
          var elementheightVal = $(mobileSlickSlider).height();
            $(mobileSlickSlider+" .slick-slide").each(function () { 
              if( $(this).height()>elementheightVal){ 
                elementheightVal = $(this).height();
              }
            });
            $(mobileSlickSlider+" .slick-slide").height(elementheightVal);
          })
        }
    }   
  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      $list.removeAttr('aria-live');
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });
  return Quotes;
})();

const matchHeightCompatibleGridSystemTitle = () =>{
  const heights = [];
  const selector = $('.grid-system-product-title:visible');
  if(selector.length > 0){
    selector.each((index,element) => {
      heights.push($(element).height());
    });
    const max = Math.max.apply(Math,heights);
    selector.each((index,element) => {
      $(element).height(max);
    });
  }
};

$(window).resize(function(){
  //matchHeightCompatibleGridSystemTitle();
  let windowWidth = $(window).width();
  if  (windowWidth <= 767 && $('.quotes-slider').hasClass('slick-initialized')) {
      let calSlide = windowWidth / 316;
      $('.quotes-slider').eq(0).slick('slickSetOption', 'slidesToShow', calSlide);
      $('.quotes-slider').eq(0).slick('refresh');
      let mobileSlickSlider = '.quotes-slider';
      let elementheightVal = $(mobileSlickSlider).height();
      $(mobileSlickSlider+" .slick-slide").each(function () {
          if( $(this).height()>elementheightVal){ 
            elementheightVal = $(this).height();
          }
      });
        $(mobileSlickSlider+" .slick-slide").height(elementheightVal);
  }
  if  (windowWidth > 767 && windowWidth <= 1440 && $('.quotes-slider').hasClass('slick-initialized')) {
      $('.quotes-slider').eq(0).slick('slickSetOption', 'slidesToShow', 3);
      $('.quotes-slider').eq(0).slick('refresh');
      let mobileSlickSlider = '.quotes-slider';
      $(mobileSlickSlider+" .slick-slide").height('unset');
  }
  //expressButtonsWatcher();
});

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $(slideshow).each(function() {
      var $el = $(this);    
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

// CATEGORY SLIDER
theme.collectionView = (function() {
  var formdata = '';
  function collectionView(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id'),
    	sliderSecond = $container.attr('data-section-timeout');
    
    
    $(document).on('change','#SortBySt',function(e){
		var value = $(this).val();
      	if ($("#CollectionFiltersForm").length){
			$("#SortBy").val(value).trigger('change');
        } else {
          if (value.length) {
            window.location.search = 'sort_by='+value;
          } else {
            window.location.href = window.location.href.replace(window.location.search, '');
          }
        }
        loadCollectionViewMobile();
	});
    
	$(document).on('click', '.change-view', function(e){
      var view = $(this).data('view'),
          url = document.URL.split('?'),
          viewtp = location.search.split('view=');
	  if (viewtp[0] == '?'){
		window.location = url[0]+'?view=' + view;
	  } else if(viewtp[1] == 'list' || viewtp[1] == 'grid'){
        window.location = url[0]+viewtp[0]+'view=' + view;
      } else {
        window.location = url + '?view=' + view;
      }
      loadCollectionViewMobile();
    });
    $(document).on('change', '.optTag', function(e){
      var URL =  $('.sidebar_tags').data('url'),
          paramString = window.location.search.substring(1);
      	
      	var productFilters = $('input.optTag'),
            newTags = [],
            url = '';

        productFilters.each(function() {
            if ($(this).val() && $(this).is(":checked") == true) {
              newTags.push($(this).val());                        
            }
        });
        if(newTags.length){
        	var tags = newTags.join('+');
       		ajaxfilter(URL+'/'+tags+'?'+paramString);
        } else {
          	ajaxfilter(URL+'?'+paramString);
        }
	});
    $(document).on('change', '.flForm .custCheck, .prRange, #SortBy', function(e) {
      e.preventDefault();
      updateStatusFilter(true);
      const filter = e.target;
      const URL = '//'+window.location.hostname+window.location.pathname;
      formdata = $('#CollectionFiltersForm').serialize();
      //Force filters to be unselected
      if(filter.checked === false && formdata.includes(`&${filter.name}=${filter.value}`)) {
        formdata = formdata.replace(`&${filter.name}=${filter.value}`,'');
      }
      if (window.innerWidth > 0 || filter.name =='sort_by' ) {
        ajaxfilter(URL+'?'+formdata);
      }
      checkClearButton(formdata);
	  });
    
  	$(document).on('click', 'a.actFilter', function(e){
      e.preventDefault();
      var URL =  '//'+window.location.hostname+$(this).attr('href');
      ajaxfilter(URL);
	  });
    
    $(document).on('click', 'span.actFilter', function(){
      var filter = $(this).attr("data-value");
      $(".filterBox input[value='"+filter+"']").trigger("click");
	  });
    
    $(document).on('click', '.clearFilters', function(){
      let templateSearch = $(".template-search").length;
      if (templateSearch) {
          let searchQuery = getParameterByName("q");
          let redirectUrl = window.location.pathname + '?type=product&q=' + encodeURIComponent(searchQuery);
          window.location.href = redirectUrl;
      } else {
          window.location.href = window.location.href.replace(window.location.search, '');
      }
    });
    
    $('.flbytags').each(function(){
		var filter = $(this).find("li");
        if(filter.length <= 0){$(this).hide()}
	  });
  
  	ajaxfilter = (function(url){
        $.ajax({
          type: 'GET',
          url: url,
          data:{},
          beforeSend:function(){
            if (window.innerWidth > 1024) {
              $('body').addClass('loading hideOverly');
            }
          },
          complete: function(data){
            $('.productList .grid-products').html($(".productList .grid-products", data.responseText).html());
            $('.filters-toolbar__product-count').html($(".filters-toolbar__product-count", data.responseText).html());
            
           	$('.sidebar_tags').html($(".sidebar_tags", data.responseText).html());
            $('.active-facets').html($(".active-facets", data.responseText).html());

            $('.pagination').html($(".pagination", data.responseText).html());
            if(!$(".pagination", data.responseText).html()){
              $('.pagination').hide();
            } else {
              $('.pagination').show();
            }
            $('.infinitpaginOuter').html($(".infinitpaginOuter", data.responseText).html());
            if(!$(".infinitpaginOuter", data.responseText).html()){
              $('.infinitpagin').remove();
            }
            if(theme.mlcurrency){ currenciesChange("sapn.money"); }
            $('body').removeClass('loading hideOverly');
            loadMoreBtn();

            if($(".spr-badge").length > 0) {
            	$.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            productGridView(sectionId);
            setTimeout(function(){ productGridView(sectionId); },1000);
			
            if($('.prRange').length){ priceSlider(); }
            if($('#sideProdSlider').length){ $("#sideProdSlider").slick(); }

            history.pushState({page: url}, url, url);
            
            //If you need update something when a filter is selected or removed put here:
            functionalityFilters();
            updateStatusFilter();
            overviewMobileTab();
            collectionCompare._init();
            getVendorsCollection();
            openActiveSubFilters();
            loadCollectionViewMobile();
            loadStickyFilter ();
            loadSortBy();
            checkClearButton(window.location.search);
            showAllCheckedFilters();
            $('input[type=checkbox]:not(.no-custom-input)').awesomeCheckboxInput();
            //CheckClearAllPills();
            filterOrderChange();
          }
        });
    });
    
    function _initSwatchModal () {
      var slideshow = '#Slideshow-' + sectionId;
      var dots = $('.dot', '#product-swatch-modal');
      var prevBtn = $('.slide-control .slick-prev', '#product-swatch-modal');
      var nextBtn = $('.slide-control .slick-next','#product-swatch-modal');

      // slide image by clicking dots
      dots.click(function (evt) {
        $(slideshow).slick('slickGoTo', $(evt.currentTarget).index(), false);
      });
      // slide to previous one
      prevBtn.click(function () {
        $(slideshow).slick('slickPrev');
        $(this).blur();
        
      });
      // slide to next one
      nextBtn.click(function () {
        $(slideshow).slick('slickNext');
        $(this).blur();
      });

      // synchronize UI state
      $(slideshow).on('init afterChange', function (_, slick) {
        var currentSlide = slick.currentSlide;
        var isLast = currentSlide === slick.slideCount - 1;
        prevBtn.prop('disabled', currentSlide === 0);
        nextBtn.prop('disabled', isLast);
        // update dots state
        dots.removeClass('active').eq(currentSlide).addClass('active');
        $('.modal-body').animate({scrollTop:0}, 'slow');
        // update image label
        var label = isLast ? 'What is an Edge Profile?':'What is a Grid?';
        var dir = isLast ? 'Previous' : 'Next';
        $('.slide-control .slide-title').text(label);
        $('.slide-control .slide-title-dir').text(dir);
      });
      let initialized = false;
      $('.open-modal-btn.question-icon').on('click', function (e) {
        e.stopPropagation();
        if (initialized === true) return;
        initialized = true;
        setTimeout(function () {
          $(slideshow).slick({
            accessibility: false,
            arrows: false,
            dots: false,
            autoplay: false,
            touchThreshold: 20,
            rtl: theme.rtl,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            adaptiveHeight: true
          });
        }, 200);
      })

      // initialize slider
      
    }
    
    
	/*$(window).on('load delayed-resize', function (e, resizeEvent) {
  		productGridView(sectionId);
    });*/
    
    infiniteScroll = function(){
      	var action = 'scroll load delayed-resize';
        $(window).on(action, function(){
          var moreURL = $('.infinitpagin a').attr('href');
          if ($('.infinitpagin a.infinite').length){
            var bottom = $('.infinitpagin').offset();
            var docTop = ($(document).scrollTop() + $(window).height() - 50);
            if( docTop > bottom.top){
              $(window).off(action);
              loadMore(moreURL);
            }
          }
        });
    }
    loadMoreBtn = function() {
		$('.infinitpagin a.loadMore').click(function(e){
          	e.preventDefault();
          	var moreURL = $(this).attr('href');
			loadMore(moreURL);
        });
    }
    
    loadMore = function(moreURL) {
      if (moreURL.length){
        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: moreURL,
          beforeSend:function(){
          	if ($('.infinitpaginOuter').attr('data-type') == "button" ){
            	$('body').addClass('loading hideOverly');
            } else {
              $('.infinitpagin a').show();
            }
          },
          complete: function (data) {
            if($('.productList .grid-products').length){
            	$('.productList .grid-products').append($(".productList .grid-products", data.responseText).html());
            } else {
              	$('.productList .list-view-items').append($(".productList .list-view-items", data.responseText).html());
            }
            if($(".infinitpagin", data.responseText).html()){
            	$('.infinitpagin').html($(".infinitpagin", data.responseText).html());
            } else {
            	$('.infinitpagin').remove();
            }
			if(theme.mlcurrency){ currenciesChange("sapn.money"); }
            productGridView(sectionId);
			if($(".spr-badge").length > 0) {
                $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            setTimeout(function(){ productGridView(sectionId); },1000);
            if ($('.infinitpagin a.loadMore').length){
            	loadMoreBtn();
            } else {
              infiniteScroll();
            }
            $('body').removeClass('loading hideOverly');
          }
        });
      }
    }
    
    $(document).ready(function(){    
      infiniteScroll();loadMoreBtn();
      $("#collection-slideshow, #sideProdSlider").slick();
       
      //Init Accordion Filter
      loadStickyFilter ();
      overviewMobileTab();
      functionalityFilters();
      setTimeout(() => {
        getVendorsCollection();
      }, 1000);
      loadCollectionViewMobile();
      loadSortBy();
      checkClearButton(window.location.search);
      _initSwatchModal();
      showAllCheckedFilters();
    });
  }
  return collectionView;
})();

function checkClearButton (formdata) {
      if (formdata.includes('filter')) {
        $('.clearFilters').show();
      } else {
        $('.clearFilters').hide();
      }
}
function loadSortBy () {
  var mobile_sort_inputs = $('.tw-radio-option-sort');
    var sort_title = $('.tw-sort-by-title');
    
    mobile_sort_inputs.each(function() {
      var value = $(this).find('input').val();
      var name = $(this).find('input').data('title');
      if (window.location.search.includes('sort_by')) {
        if (window.location.search.includes(value))
          {
            $(this).find('input').prop('checked',true);
            sort_title.html("Sort by: "+name)
          }
      } else {
        $(this).find('input[value="best-selling"]').prop('checked',true);
        sort_title.html("Sort by: Best Seller")
      }
      
    })
    mobile_sort_inputs.on('click',function (){  
      var value = $(this).find('input').val();
      $(this).find('input').prop("checked", true);
      if (value.length) {
        $('#SortBySt').val(value).trigger('change');
      } else {
        window.location.href = window.location.href.replace(window.location.search, 'sort_by='+value);
      }
    });
}
function loadStickyFilter () {
  var stickyBar = document.getElementById('sticky-filters');
  var container = document.querySelector('.filterbar');
  if(container === null) return;
  container.addEventListener('scroll', function() {
    var containerScrollHeight = container.scrollHeight;
    var containerVisibleHeight = container.clientHeight;
    var scrollTop = container.scrollTop;
    if (scrollTop + containerVisibleHeight >= containerScrollHeight) {
      stickyBar.classList.add('at-bottom');
    } else {
      stickyBar.classList.remove('at-bottom');
    }
  });  
}

function loadCollectionViewMobile (){
  var count =0;
  
  const intervalXD = setInterval( ()=> {
    if(window.innerWidth < 678){
      var card_prices = $('.card-price');
      card_prices.each(function(){
        if ($(this).text().includes('carton')){
          var new_text = $(this).text();
          $(this).text(new_text.replace('carton','ctn'));
        }
        if (count >= 3){
          clearInterval(intervalXD);
        
        }
      });
    }
  },500);
}

var openPhotoSwipe = function () {
  $(".stickyHeader").hide();
  $("body").css("overflow", "hidden");
  var pswpElement = document.querySelectorAll('.pswp.custom-modal')[0];
  var pswpClose = document.querySelector(".pswp.custom-modal .pswp__button--close");
  var pswpCloseModal = document.querySelector(".pswp.custom-modal .pswp__container");
  $('.main-content').css('z-index', '51');
  $('.main-content').css('position', 'initial');
  $('#headerWrapper').css('z-index', '1');
  $('#header').css('z-index', '15');
  pswpClose.addEventListener("click", function () { //close modal video with button
    $('.pswp.custom-modal').removeClass('pswp--open');
    var $frame = $('.pswp.custom-modal iframe');
    var vidsrc = $frame.attr('src');
    $frame.attr('src', '');
    $frame.attr('src', vidsrc);
    $('.main-content').css('z-index', '0');    
    $('#header').css('z-index', '15');
    $('.main-content').css('position', 'relative');
    $(".pswp.custom-modal .pswpbutton--close").on('click', () => { 
      $(".pswp.custom-modal .pswpbutton--close").click(); 
    });
    $("body").css("overflow", "visible");
  });
  pswpCloseModal.addEventListener("click", function () { // close de modal video with click outside the box
    $('.pswp.custom-modal').removeClass('pswp--open');
    var $frame = $('.pswp.custom-modal iframe');
    var vidsrc = $frame.attr('src');
    $frame.attr('src', '');
    $frame.attr('src', vidsrc);
    $('.main-content').css('z-index', '0');
    $('#header').css('z-index', '15');
    $('.main-content').css('position', 'relative');
    $("body").css("overflow", "visible");
  });
  
  $(document).bind('keydown',function(e){
    if ( e.which == 27 ) {
      $("body").css("overflow", "visible");
      
    };
  });

  let video_url="";
  if ($(this).hasClass('lightbox-video-click')) {
    video_url = $(this).find('a').attr('href');
    let videoId = youtube_parser(video_url);
    let imageUrl = 'http://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg';
    let img = new Image();
    img.src = imageUrl;
    $(img).on('load', function() {
      let finalAspectRatio = img.width + '/' + img.height;
      $('.product-iframe-video').css('aspect-ratio',finalAspectRatio);
    });
  } 
  var items = [
    {
      html: '<iframe src="' + video_url + '?&autoplay=1" style="" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" webkitallowfullscreen mozallowfullscreen class="product-iframe-video"></iframe>'
    },
  ];
  


  var options = {
    history: false,
    focus: false,
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
    shareEl: 0,
    closeOnScroll: false,
    closeOnVerticalDrag: false,
    wheelToZoom: false,
    pinchToClose: false,
    tapToClose: 1,
    // disable zoom
    getDoubleTapZoom: function (item) {
      return item.initialZoomLevel;
    },
    zoomEl: false
  };

  var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();

  var timeLoadComponents = 1000;
  setTimeout(function () {
    var $pswpCloseModal = $('.pswp__button--close');
    var $frame = $('.pswp');
    var vidsrc = $frame.attr('src');
    $pswpCloseModal.on("change", function () {
      $frame.attr('src', '');
      $frame.attr('src', vidsrc);
      $('.main-content').css('z-index', '0');
      $('.main-content').css('position', 'relative');
    });
  }, timeLoadComponents);

  gallery.listen('close', function () {
    $("body").css("overflow", "visible");
    $('.product-iframe-video').remove();
    $(".stickyHeader").show();
    $('#headerWrapper').css('z-index', '15');
  });
};

document.querySelectorAll('.hover-promo').forEach(item => {
  item.onclick = openPhotoSwipe;
});

// Prevent links that open video lightbox to redirect
$('.hover-promo').on('click', function(e) { e.preventDefault(); } );

const $modal = $(".pswp");
if ($modal.length) {
  $modal.on("wheel mousewheel", function (e) {
    if ($modal.hasClass("pswp--open")) {
      var $frame = $('.pswp iframe');
      var vidsrc = $frame.attr('src');
      $frame.attr('src', '');
      $frame.attr('src', vidsrc);
    }
  });
}

//light box implimentation starts
$(document).ready(function () {
    
  setTimeout(function () {
    $('.popup-vedio-pdp').magnificPopup({
      // disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    });
  }, 1000);
});
//light box implimentation ends

function getVendorsCollection(){
  // Add sort by at the bottom of filters
  let items = $('.grid__item[data-vendor]');
  const vendors = [];
  items.each(function(index,element) {
    if (!vendors.includes($(element).data('vendor'))) {
      vendors.push($(element).data('vendor').toLowerCase())
    }
  });
  if(vendors.includes('spacekit')) {
    $('.collection-shipedy-by-container').find('.spacekit').removeClass('tw-hidden')
  }
  if(vendors.includes('armstrong')){
    $('.collection-shipedy-by-container').find('.armstrong').removeClass('tw-hidden').css('display','flex');
  }
  if(vendors.includes('cooledge')){
    $('.collection-shipedy-by-container').find('.cooledge').removeClass('tw-hidden')
  }
}
function functionalityFilters(){
   //Re-Fresh Arrows filters
   $('.open-filter').on('click',function(e){
    e.stopPropagation();
    let accordionBox = $(this);
    let filterBox = accordionBox.data('id');
    let angle = accordionBox.find('.angle');
    if(accordionBox.parent().hasClass('tw-filter-subtitle-border')){
      console.log('innerWidth',window.innerWidth)
      if(window.innerWidth > 1024){
        $('#' + filterBox).slideToggle(500);
      } else {
        $('#' + filterBox).toggle();
      }
      
      accordionBox.parent().toggleClass('tw-filter-subtitle-border');
      accordionBox.parent().addClass('active');
    }else{
      $('#' + filterBox).slideToggle(500,function() {
        accordionBox.parent().toggleClass('tw-filter-subtitle-border');
        accordionBox.parent().removeClass('active');
      });
    }
    loadCollectionViewMobile();
    $(angle).toggle();

    setTimeout(() => {
      updateStatusFilter();
    }, 500);
  });
  
}

  var showVolumeComponent = false;
function volMiniCartComponentSelected(items){
  // var items = CartJS.cart.items;
  var minimunQty = min_cartons_volume_cart;
  var hasVolDiscount = false;
  var itemsQty = 0;
  var itemSelected = {};
  var itemQty = 0; // used to evaluate the priority
  var lowestDiscountValue = Infinity;
  var lowestItemQty = 0
  var lowestItem = ''

  let allTrue = true;
  let allFalse = true;
  let validQualifiedMessages = false;
  $.each(items, function(index, item) {
      let applyVolumeDiscount = item.properties["_applyVolumeDiscountAmount"];

      if (applyVolumeDiscount === "true") {
          allFalse = false;
      } else if (applyVolumeDiscount === "false") {
          allTrue = false;
      }
  });

  if (allTrue || allFalse) {
    validQualifiedMessages = true
  } else {
    validQualifiedMessages = false;
  }
  
  /* We need to check if there is a dollar-off discount in the cart and whether any product has crossed its threshold. 
     If a threshold is crossed, we need to avoid applying combined discounts for dollar-off offers.  */
  let isAnyProductDiscountApplied = false;
  for (const item of items) {
    const { properties, quantity } = item;

    const hasVolumeQuantity = properties.hasOwnProperty('_volumeQuantity');
    const volumeQuantity = hasVolumeQuantity && properties._volumeQuantity !== '0'
      ? parseInt(properties._volumeQuantity)
      : null;

    if (volumeQuantity && properties.hasOwnProperty('_applyVolumeDiscountAmount')) {
      if (quantity >= volumeQuantity) {
        isAnyProductDiscountApplied = true;
        break;
      }
    }
  }
  
  let validItem = false;
  for (const item of items) {
    validItem = item.properties.hasOwnProperty('_volumeQuantity') && item.properties._volumeQuantity != '0' ? item.properties._volumeQuantity : false;
    if (validItem != false){
        hasVolDiscount = item.properties.hasOwnProperty('_volumeDiscountApplied') && (item.properties._volumeDiscountApplied === 'true' || item.properties._volumeDiscountApplied === true) ? true : false;
        if (item.quantity < parseInt(item.properties._volumeQuantity)) {
            if(!isAnyProductDiscountApplied){
              itemsQty += parseInt(item.quantity) || 0;
            }else{
              itemsQty = parseInt(item.quantity) || 0; 
            }
          const discountValue = item.properties?._applyVolumeDiscountAmount == 'true' ? parseFloat(item.properties?._volumeDiscountAmount) :  parseFloat(item.properties?._volumeDiscount) || 0;
          if(CartJS.cart.item_count >= minimunQty && CartJS.cart.total_discount == 0){
            if (discountValue < lowestDiscountValue) {
              lowestDiscountValue = discountValue;
              itemSelected = item;
            }
          } else{
            if (itemsQty / 2 == parseInt(item.quantity) && item.product_type === "Ceiling") {
              itemSelected = item;
              itemQty = parseInt(item.quantity);
            } else if (parseInt(item.quantity) > itemQty) {
                itemSelected = item;
                itemQty = parseInt(item.quantity);
            }
            if(isAnyProductDiscountApplied == true){
              if (discountValue < lowestDiscountValue && parseInt(item.quantity) >= minimunQty) {
                lowestDiscountValue = discountValue;
                lowestItem = item;
                lowestItemQty = parseInt(item.quantity)
              }
            }
          }
      }
    }else{
      $('.volumeComponentMiniCart').addClass('tw-hidden');
      break;
    }
}

/* If one product has reached its threshold and there are multiple products in the cart, 
  we check which product has the lowest discount. Based on that, we override the products.
  This things only for dollar off discount for the volume discounts */
if(lowestItemQty != 0 && isAnyProductDiscountApplied == true){
  itemsQty = lowestItemQty;
  itemSelected = lowestItem;
}
   if (validQualifiedMessages != false  && validItem != false) {
      setTimeout(() => {
          if(checkTierDiscountEnable == 'false' && checkVolumeDiscountEnable == 'true'){
            tierLevelUpsell();
          }else{
            updateVolMiniCartComponent(itemSelected,itemsQty,minimunQty);
          }
          
      }, 200);
   }
  let showComponent = true;
  if(hasVolDiscount || itemsQty == 0 || !itemSelected) {
    showComponent = false;
  }
  return {
    showComponent,
    hasVolDiscount,
    itemsQty,
    itemSelected,
  };
}
function updateVolMiniCartComponent(item,itemsQty,minimunQty){
  if(!item){
    $('.item-cart-to-add').addClass('tw-hidden');
    $('.volumeComponentMiniCart').addClass('tw-hidden');
    return;
  }
  const volQty = item.properties?._volumeQuantity;
  let discountValue;
  if (CartJS.cart.total_discount > 0){
    discountValue = CartJS.cart.total_discount / 100;
  } else {
    discountValue = item.properties?._volumeDiscountAmount;
  }

  let volMsg = item.properties?._applyVolumeDiscountAmount == 'true' ?  '$'+discountValue+' OFF!' : item.properties?._volumeDiscount+'% OFF!';

  const toComplete = volQty - itemsQty;
  const percentage = itemsQty * 100 / volQty;
  const $volumeComponentMiniCart = $('.volumeComponentMiniCart');
  const $itemCarttoAdd = $('.volumeComponentMiniCart .item-cart-to-add')
  const $volMessageAway = $('.volumeComponentMiniCart .tw-volMsg-away')
  const $volMsgAwayComplete = $('.volumeComponentMiniCart .tw-volMsg-away-complete')
  const $productTitle = $('.volumeComponentMiniCart .productTitle');
  const $itemSelectedImage = $('.volumeComponentMiniCart .itemSelectedImage');
  const $volPercentage = $('.volumeComponentMiniCart .volPercentage');
  const $progressBar = $volumeComponentMiniCart.find('.progress-bar');
  
  let isFixedAmount = false;
  let isPercentageAmount = false;
  let calculateFixedAmount = 0;
  let tempValue = 0;

  CartJS.cart.items.forEach((item) => {
      if (item.line_level_discount_allocations.length > 0) {
          const discount = item.line_level_discount_allocations[0].discount_application;
          if (discount.value_type === 'fixed_amount') {
              calculateFixedAmount += parseFloat(discount.value);
              isFixedAmount = true;
          } else if (discount.value_type === 'percentage') {
              tempValue = Math.max(tempValue, discount.value);
              isPercentageAmount = true;
          }
      }
  });

 if (isPercentageAmount) {
      calculateFixedAmount = tempValue;
  }

  const discountText = isFixedAmount && !isPercentageAmount
          ? `$${Math.round(calculateFixedAmount)} OFF`
          : `${Math.round(calculateFixedAmount)}% OFF`;

  if(itemsQty < minimunQty){
    if(CartJS.cart.total_discount > 0){
      $volumeComponentMiniCart.addClass('tw-hidden');
      $volMessageAway.hide();
      $itemCarttoAdd.hide();
      $volMsgAwayComplete.show();
      if(isNaN(volMsg)){
        $('.volumeComponentMiniCart .volPercentage').text(discountText);
      }else{
        $('.volumeComponentMiniCart .volPercentage').text(volMsg);
      }
      $volumeComponentMiniCart.removeClass('tw-hidden');
      $progressBar.width('100%');
    } else {
      $volumeComponentMiniCart.addClass('tw-hidden');
    }
  }else{
    if(itemsQty >= minimunQty && toComplete > 0){
      let totalDiscount = parseInt(CartJS.cart.total_discount / 100) + parseInt(item.properties?._volumeDiscountAmount);
      volMsg = item.properties?._applyVolumeDiscountAmount == 'true' ?  '$'+totalDiscount+' OFF!' : item.properties?._volumeDiscount+'% OFF!';
      $volumeComponentMiniCart.addClass('tw-hidden');
      $volMessageAway.show();
      $itemCarttoAdd.show();
      $volMsgAwayComplete.hide();
      $('.volumeComponentMiniCart .volPercentage').text(volMsg);
      $('.volumeComponentMiniCart .cartonsToAdd').text(toComplete);
      $productTitle.text(item.title.split('-')[0])
      $itemSelectedImage.attr('src',item.featured_image.url)
      $volumeComponentMiniCart.removeClass('tw-hidden');
      $progressBar.width(percentage+"%");     
    }else if(CartJS.cart.total_discount > 0){
      $volumeComponentMiniCart.addClass('tw-hidden');
      $volMessageAway.hide();
      $itemCarttoAdd.hide();
      $volMsgAwayComplete.show();
      if(isNaN(volMsg)){
        $('.volumeComponentMiniCart .volPercentage').text(discountText);
      }else{
        $('.volumeComponentMiniCart .volPercentage').text(volMsg);
      }
      
      $volumeComponentMiniCart.removeClass('tw-hidden');
      $progressBar.width('100%');
    }
  }

  $('#add-product-custom').off('click');
  $('#add-product-custom').on('click', function() {
    if(window.isCartPage){
      $('body').addClass('loading');
    }
    setTimeout(() => {
      var element = $('.jsAddQty[data-id="' + item.id + '"]');
      var currentQty = parseInt(element.attr('data-cart-quantity')) - 1;
      element.attr('data-cart-quantity',currentQty + toComplete);
      element.trigger('click');
    }, 500);
  });
  
}
var showFreeComponent = false;
function validateFreeShipping (items,free_shipping_value) {
  setTimeout(() => {
    const remainingPriceForFreeShipping =  Number($('.FreeShippingUpsell').data('freeshipping'));
    
    //Get Total Price
    const totalPrice = items.reduce((total, item) => {
      if (!item.title.includes("Sample") && !item.title.includes("Bundle")) { 
        const final_line_price = item.final_line_price / 100;
        return total + final_line_price;
      }
      return total;
    }, 0);
      // define $ to complete.
      const toComplete = free_shipping_value - totalPrice;
      // define percentage
      var percentage = totalPrice * 100 / free_shipping_value;
      percentage = Math.min(100, percentage);
      // get selected Item.
      const selectedItem = suggestProductsForFreeShipping(items,toComplete);
      if(selectedItem == null) {
        $('.FreeShippingUpsell').addClass('tw-hidden');
      }
      // update sections on shipping upsell
      $('.FreeShippingUpsell .amountToAdd').text('$'+toComplete.toFixed(2));
      $('.FreeShippingUpsell .cartonsToAdd').text(selectedItem.qty)
      if (selectedItem.qty == 1){
        $('.FreeShippingUpsell .pluralWord').hide();
      } else {
        $('.FreeShippingUpsell .pluralWord').show();
      }

      $('#add-product-custom-shipping').off('click');
      $('#add-product-custom-shipping').on('click', function() {
        if(window.isCartPage){
          $('body').addClass('loading');
        }
        setTimeout(() => {
          var element = $('.jsAddQty[data-id="' + selectedItem.product.id + '"]');
          var currentQty = parseInt(element.attr('data-cart-quantity')) - 1;
          element.attr('data-cart-quantity',currentQty + selectedItem.qty);
          element.trigger('click');
        }, 500);
      });
      
      // update progress bar
      $('.FreeShippingUpsell  .progress-bar').width(percentage + '%');
      // update incomplete bar
      $('.FreeShippingUpsell .progress-bar-incomplete').width((100 - percentage) + '%');
      if (percentage == 100) {
          $('.FreeShippingUpsell .tw-freeShipping-away').hide();
          $('.FreeShippingUpsell .item-cart-to-add').hide();
          $('.FreeShippingUpsell .tw-freeShipping-complete').show();
      }else {
        $('.FreeShippingUpsell .tw-freeShipping-away').show();
        $('.FreeShippingUpsell .item-cart-to-add').show();
        $('.FreeShippingUpsell .tw-freeShipping-complete').hide();
      }
      if (selectedItem != 'invalidProduct'){
        $('.FreeShippingUpsell .productTitle').text(selectedItem.product.title.split('-')[0]);
        $('.FreeShippingUpsell .itemSelectedImage').attr('src',selectedItem.product.featured_image.url);
        $('.FreeShippingUpsell .itemSelectedImage').attr('alt',selectedItem.product.featured_image.alt);
      }
      
    
      if (selectedItem == 'invalidProduct') {
        $('.FreeShippingUpsell').addClass('tw-hidden');
       
       }else if (toComplete > remainingPriceForFreeShipping ) {
         $('.FreeShippingUpsell').addClass('tw-hidden');
       } else 
       { 
        $('.FreeShippingUpsell').removeClass('tw-hidden');
        }    
  }, 500);
  
}

function suggestProductsForFreeShipping(items, remainingAmount) {

  // Select the product that is slightly below the remaining amount but still exceeds it
  let suggestion = null;
  let minPositiveDifference = Infinity; 
  for (let i = 0; i < items.length; i++) {
    const product = items[i];
    if (product.product_type == "Cooledge" || product.product_type == "Grid" || product.product_type == "Light") { //Validations for productType
      return "invalidProduct";
    }
    if (product.title.includes("Sample") || product.title.includes("Bundle") || product.sku.includes("SRCHRG") ) { //Validations for Samples and bundles
      continue;
    }
    const realPrice = product.final_price / 100;
    const cartonAmount = Math.ceil(remainingAmount / realPrice);
    const totalProduct = cartonAmount * realPrice;
    const difference = totalProduct - remainingAmount;

    if (difference >= 0 && difference < minPositiveDifference) {
      suggestion = {"product": product, "qty": cartonAmount };
      minPositiveDifference = difference;
    }
  }
  var hasCeilingOrWallProduct = items.some(function(item) {
    return item.product_type === "Ceiling" || item.product_type === "Wall";
  });
  
  return hasCeilingOrWallProduct ? suggestion : "invalidProduct" ;
}




function updateStatusFilter(changeFilter = false) {
  const accordions = $('.open-filter');
  var accordionsOpen = [];
  $(accordions).each( function () {
    if ($(this).parent().hasClass('active') && changeFilter) {
      var id = $(this).parent().attr('id')
      var accordionName = id.slice(id.indexOf('-') + 1);
      var list = $('[data-type="filters-' + accordionName + '"]');
      var enableShowMore = false;
      if ( $(list).hasClass('less')){
        enableShowMore = true;
      }
      var jsonFilter = {"id":id,"showMore":enableShowMore};
      accordionsOpen.push(jsonFilter);
    }
  });
  if (changeFilter){
    localStorage.setItem('filterStatus',JSON.stringify(accordionsOpen))
  }
}
function checkHistoryFilters() {
  const status = localStorage.getItem('filterStatus') || [];
  if(status.length ){
    const ids= JSON.parse(status);
    ids.forEach( object => {
      var id = object.id
      var prefixId = object.id.split('-')[1];
      var showMore = object.showMore
      var filter = $('[id="' + id + '"]');
      if ( !$(filter).hasClass('active')) {
        $(filter).find('.open-filter').trigger('click');
      }
      if (showMore) {
        $('[data-type="filters-' + prefixId + '"]').trigger('click');        
      }
    });
    

  }
}
function overviewMobileTab (){
  let angle = $('.tw-overview-label-icon').find('.ad');
  $('.tw-overview-label-icon').on('click',function(){
    $(angle).toggle();
    $('.tw-overview-content-mobile').slideToggle(500);
  });
  
}
function openActiveSubFilters () {
  const activeFilters = $('.type-of-space-filter .filter-checkbox:checked');
  if(activeFilters.length) {
    activeFilters.each(function(){
      const filterWrapper = $(this).closest('.widget-content');
      if (filterWrapper.length === 0) return;
      const id = filterWrapper.attr('id');
      const filterTitle = $(`.type-of-space-filter .open-filter[data-id="${id}"]`);
      if(filterTitle.length && !filterTitle.hasClass('opened')) {
        filterTitle.addClass('opened');
        filterTitle.trigger('click');
      }
    })
  }
  checkHistoryFilters();
}

function showAllCheckedFilters () {
  $('.tw-filter-option ').each(function(){
    let foundHideCheckedFilter = false;
    let checkbox = $(this).find('input[type=checkbox]');
    if ($(this).hasClass('filter-extra')) {
      if (checkbox.prop('checked')){
        foundHideCheckedFilter = true;
        let showMore = $($(this).parent().find('.tw-show-more a')[0]);        
        if(showMore.hasClass('more')){
          showMore.click();
        }  
      }
    }
  });
}

// Product grid same height
function productGridView(sectionId) {
  /*var gridRows = [],
  	  tempRow = [];

  productGridElements = $('#'+sectionId+' .grid-products .grid__item');
  productGridElements.each(function (index) {
    if ($(this).css('clear') != 'none' && index != 0) {
      gridRows.push(tempRow);
      tempRow = []; 
    }
    tempRow.push(this);

    if (productGridElements.length == index + 1) {
      gridRows.push(tempRow);
    }
  });

  $.each(gridRows, function () {
    var tallestBox = 0,
    	tallestHeight = 0,
        tallestswatch = 0;
    $.each(this, function () {
      $(this).find('.details').css('height', '');
      $(this).find('.gridSwatches').css('height', '');
      bxHeight = parseInt($(this).find('.details').outerHeight());
      elHeight = parseInt($(this).find('.grid-view_image').outerHeight());
      swHeight = parseInt($(this).find('.gridSwatches').outerHeight());
      if (elHeight > tallestHeight) { tallestHeight = elHeight; }
      if (bxHeight > tallestBox) { tallestBox = bxHeight; }
      if (swHeight > tallestswatch) { tallestswatch = swHeight; }
    });
    $.each(this, function() {
      $(this).find('.style3 .gridSwatches').css('height', tallestswatch);
      $(this).find('.details').css('height', tallestBox);
    });
  });*/
}

theme.instagram = {};
theme.instagramSection = (function() {
  function instagramSection(container) {
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id'),
        act = $container.attr('data-act'),
        limit = $container.attr('data-count'),
        rds = $container.attr('data-ds'),
        rtb = $container.attr('data-tb'),
        rmb = $container.attr('data-mb');
    
    var ajaxUrl = 'https://graph.instagram.com/me/media?fields=comments_count,like_count,id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+act;
    
    $.ajax({
		url: ajaxUrl,
        type: 'GET',
        dataType: "json",
        success: function (res) {
        	var data = res.data,
				igdiv = '#instafeed'+sectionId,
               	html = '',
                bl = bl || true;

			$.each(data, function (index, el) {
                     if (index >= limit) return 0;
                     var img_url = el.thumbnail_url || el.media_url;
                     html += '<div class="insta-img '+rds+' '+rtb+' '+rmb+'"><a rel="nofollow" class="instagram-" href="'+el.permalink+'" target="_blank"><img data-src="' + img_url + '" alt="" class="lazyload" /></a></div>';
            });
            $(igdiv).html(html);
            $("#instafeed"+sectionId+".carousel").slick();
		}
	});
  }
  return instagramSection;
})();

theme.carousel = (function(){
    function carousel(container) {
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          carousel = $($container).find('.carousel'),
    	  tabs = this.tabs = '#' + sectionId + ' .tablink',
    	  tabcontent = this.tabcontent = '#' + sectionId + ' .tab-content';
    
    $(tabs).on('click', function(e){
        e.preventDefault();
        $(this).parent().addClass("active");
        $(this).parent().siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(tabcontent).not(tab).css("display", "none");
        $(tab).fadeIn();
      	$(carousel).slick('refresh');
      	productGridView(sectionId+' '+tab);
    });
    $('#' + sectionId).each(function(){
		$(this).find('.collection-tabs li:first-child').addClass("active");
      	$(this).find('.tab-container .acor-ttl:first-child').addClass("active");
		$(this).find('.tab-container h3:first-child + .tab-content').show();
		var firsttab = $(this).find('.collection-tabs li:first-child a').attr("href");
    });
      
    if($('#'+sectionId+'.recommended').length){
		var	baseUrl = $container.data('baseUrl'),
          productId = $container.data('productId'),
          limit = $container.data('limit'),
          productRecommendationsUrlAndContainerClass = baseUrl + '?section_id='+sectionId+'&limit=' + limit + '&product_id=' +productId + ' .product-recommendations';
      	$container.parent().load(productRecommendationsUrlAndContainerClass);
      	$("#productSlider-"+sectionId).slick();
      	setTimeout(function(){ $("#productSlider-"+sectionId).slick(); },1500);
    }

    $(carousel).slick();
    productGridView(sectionId);
    setTimeout(function(){ productGridView(sectionId); },1500);
	$(window).on('delayed-resize', function (e, resizeEvent) {
  		productGridView(sectionId);
    });
  }
  return carousel;
})();

theme.masonary = (function(){
    function masonary(container){
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          masonary = this.masonary = $($container).find('.grid-masonary');
    
      loadMasonary(masonary);
      setTimeout( function(){ loadMasonary(masonary); },1000);
      function loadMasonary(masonary) {
        $(masonary).masonry({
            columnWidth: '.grid-sizer-'+sectionId,
            itemSelector: '.ms-item',
            percentPosition: true
        });
      }
  }
  return masonary;
})();


/**
 * audioPlayer instantiates the singleton audio player(audio element)
 * and plays one audio file at a time when the play button is clicked.
 * Requires either `data-file-path` or `data-file-name` attribute, use `data-file-path` with full file path using
 * `file_url` liquid filter where possible for Shopify managed caching.
 * `data-file-name` is for when we can't access full file path but not optimal with the random cache busting param on every page load.
 *
 * @example
 * <div
 *   data-section-type="audio-player"
 *   data-file-name="my-audio.mp3"
 *   data-file-path="{{ 'my-audio.mp3' | file_url }}"
 * >
 *   <button class="play-btn">Play</button>
 * </div>
 */
theme.audioPlayer = (function () {
  var audioElement;
  var isPlaying = false;
  var isPaused = false;
  var currentSrc;
  function AudioPlayer(container) {
    var $container = this.$container = $(container);
    var fileUrl = $container.attr('data-file-path') || Shopify.constants.baseFileUrl + $container.attr('data-file-name') + '?v=' + Date.now();
    // creates singleton audio element
    if (!audioElement) {
      audioElement = document.createElement('audio');
      audioElement.addEventListener('play', function () {
        isPlaying = true;
        isPaused = false;
      });
      audioElement.addEventListener('pause', function () {
        isPaused = true;
      });
      audioElement.addEventListener('ended', function () {
        isPlaying = false;
      });
      audioElement.stop = function () {
        audioElement.pause();
        // swallows IE11 `InvalidStateError` error when setting `currentTime` before `loadedmetadata` is fired.
        try {
          audioElement.currentTime = 0;
        } catch (err) { }
        isPlaying = false;
      };
      $(document.body).append(audioElement);
    }
    // toggle play/pause when clicking the play button for the same file
    // otherwise set new file source and start playing.
    $container.find('.play-btn').on('click', function () {
      if (currentSrc !== fileUrl) {
        audioElement.stop();
        $(audioElement).attr('src', fileUrl);
        currentSrc = fileUrl;
      }
      if (isPlaying) {
        audioElement[isPaused ? 'play' : 'pause']();
      } else {
        audioElement.load();
        audioElement.play();
      }
    });
  }
  return AudioPlayer;
})();
function equalizeListHeights(listSelector, extraH) {
   const listItems = $(listSelector);
   let maxHeight = 0;
   listItems.each(function() {
     const height = $(this).height();
     if (height > maxHeight) {
       maxHeight = height;
      }
    });
   listItems.css('min-height', maxHeight+extraH);
}
/**
 * Collection Widget renders the products in a grid view dynamically using the same styling from collection page
 *
 * @example
 * <div
 *   class="page-width"
 *   data-section-type="collection-widget"
 *   data-collection-name="Popular Ceiling Tiles"
 *   data-collection-handle="popular-ceiling-tiles"
 *   data-title="My Popular Ceiling Tiles"
 *   data-num-products="4"
 *   data-shop-all-url="/collections/all/some-filter"
 * ></div>
 */
theme.collectionWidget = (function () {
  var DEFAULT_NUM_PRODUCTS = 4;
  function collectionWidget(container) {
    var $container = this.$container = $(container);
    var sectionType = $container.attr('data-section-type');
    // make `sectionId` unique so that multiple widgets can be included in a page 
    var sectionId = sectionType + '-' + Date.now();
    // collection name to fetch products from, this is a required field
    var collectionName = $container.attr('data-collection-name') || '';
    var collectionHandle = $container.attr('data-collection-handle') || '';
    // Title to be displayed above the widget, collection name will be used if not specified
    var title = $container.attr('data-title') || 'Popular acoustic ceiling tiles';
    var numProducts = parseInt($container.attr('data-num-products'), 10) || DEFAULT_NUM_PRODUCTS;
    // generate collection handle from collection name by removing special characters and converting spaces to hyphens
    // https://shopify.dev/docs/themes/liquid/reference/basics/handle
    // https://github.com/Shopify/liquid/blob/63eb1aac69a31d97e343822b973b3a51941c8ac2/performance/shopify/shop_filter.rb#L100
    collectionHandle = collectionHandle || collectionName.trim().toLowerCase().replace(/"'\\\(\)\[\]/g, '').replace(/\W+/g, '-').replace(/^-+|-+$/g, '');
    // `Shop All` link url, defaults to All Collection page if not specified
    var shopAllUrl = $container.attr('data-shop-all-url') || '/collections/' + (collectionHandle || 'all');
    // width config matches with product grid view template
    var width = 100;
    var widths = [180, 360, 540, 720, 900];

    if (!collectionHandle) {
      setRendered();
      return;
    }
    function maxHeightPopular() {
      var max_height_review_title = 0;
      $(`.tw-popular-ceiling-component .tw-product-title`).each(function(index, item) {
        max_height_review_title = Math.max(max_height_review_title, $(item).height());
      })
      if ($(window).width() > mobileBreakpoint) {
        max_height_review_title = max_height_review_title + 10
      }
      $(`.tw-popular-ceiling-component .tw-product-title`).attr('style', 'display:block !important; min-height: '+(max_height_review_title)+'px !important');
      var max_height_review = 0;
      $(`.tw-popular-ceiling-component .details`).each(function(index, item) {
        max_height_review = Math.max(max_height_review, $(item).height());
      })
      if ($(window).width() > mobileBreakpoint) {
        max_height_review = max_height_review + 20
      }
      $(`.tw-popular-ceiling-component .details`).css('min-height', (max_height_review));
    }
    $.ajax({
      url: '/collections/' + collectionHandle + '/products.json?type=' + new Date().getTime() +'&_=' + new Date().getTime(),
      type: 'GET',
      cache: false,
      success: function (data){
        let products = data.products.map((product) => product.handle );
        if(products.length){
          let ceilingComponent =$('<div class="tw-popular-ceiling-component slick-recently tw-flex"></div>');
          let titleComponent = `<div class="flex tw-justify-between tw-items-center tw-mb-[22px] md:tw-mb-[30px] lg:tw-mb-[20px]">
                                  <h1 id="tw-popular-ceiling-component-title" class="tw-text-xl tw-mb-0 tw-text-[#03173d] md:tw-text-3.125 lg:tw-text-3xl md:t-w-full">${ title }</h1>
                                  <a href="${shopAllUrl}" class="tw-hidden md:tw-flex tw-text-sm tw-h-[42px] tw-rounded-[3px] tw-py-[6px] tw-px-[20px] tw-flex tw-justify-center tw-items-center tw-bg-arm-plt-col08 tw-text-white tw-uppercasetw-tracking-[1px] tw-font-black hover:tw-underline">Shop All Products<i class="ad collection-widget__btn-icn hover:tw-no-underline"></i></a>
                                </div>`;
          let titleBottomComponent = `<a href="${shopAllUrl}" class="md:tw-hidden tw-text-sm md:tw-mr-0 tw-h-[42px] tw-rounded-[3px] tw-py-[6px] tw-px-[20px] tw-flex tw-justify-center tw-items-center tw-bg-arm-plt-col08 tw-text-white tw-uppercase tw-font-black tw-tracking-[1px]"><span class='hover:tw-underline'>Shop all products</span><i class="ad collection-widget__btn-icn hover:tw-no-underline"></i></a>`;
          products = products.slice(0, numProducts);
          $.ajax({
            url: '/collections/all/?view=prlist&__pr=&handles=' + products.join('+') +'&type=' + new Date().getTime() +'&_=' + new Date().getTime(),
            dataType: 'html',
            type: 'GET',
            cache: false,
            success: function(data) {
              const maxCardsToAdd = $(window).width() > 425 ? 4 : 1;
              let cardsToFull = 0;
              let emptyDiv = '<div class="grid__item"><div>';
              const totalCards = $(data).find('.grid-view-item').length;
              if (totalCards) {
                ceilingComponent.html(data);
                if (totalCards < maxCardsToAdd) {
                  cardsToFull = maxCardsToAdd - totalCards;
                  emptyDiv = '<div class="grid__item"><div>';
                  for (let i = 1; i <= cardsToFull; i++) {
                    ceilingComponent.append(emptyDiv);
                  }
                }
                $container.append(titleComponent);
                $container.append(ceilingComponent);
                $container.append(titleBottomComponent);
                setTimeout(function() {
                  maxHeightPopular();
                }, 2000);
              } else {
                $container.hide();
              }
            },
            error: function(data) {
              console.log('ajax error');
            },
            complete: function() {
              const cardWidth = 270;
              let calcSlide = $(window).width() / cardWidth;
              setTimeout(function() {
                if ($container.find('.grid__item').length == 1) {
                  calcSlide = 1
                }
                if ($(window).width() <= 425) {
                  $('.slick-recently').not('.slick-initialized').slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    autoplay: false,
                    speed: 600,
                    rtl: theme.rtl,
                    slidesToShow: calcSlide,
                    slidesToScroll: 1,
                    variableWidth: false
                  });
                } else {
                  $('.slick-recently').css('width', '100%')
                }
              }, 1000)
              $(theme.init);
            }
          });
        }
      },
      error: function (data) {
        console.error('ajax error');
        setRendered();
      }
    });

    $container
      .attr('id', sectionId)
      .attr('data-section-id', sectionId);
  }

  return collectionWidget;
})();


theme.ajaxCart = function() {
  	drawerTimeout: null,
  	quickshop(),gridAddToCart(),prodAddToCart(),prodAddToCartGrid(),wishlist(),updateWishlist(),freeship(),compatibleGridPdpFunctionality();
	$(".continue-shopping, .modalOverly, .closeDrawer").on("click", function(event) {
      if($('body').hasClass('loading')){
        return false;
      }
      if($('#modal-cart-shipping').hasClass('show')){
        return false;
      }
      $(".modal").fadeOut(200);
    	$("body").removeClass("loading showOverly");
    });
  	function quickshop() {
      $(document).on('click touch', '.quickShop', function(e){
          e.preventDefault(); e.stopImmediatePropagation();
          var url = $(this).attr('href'),
              imgwrapper = $(this).parents('.grid-view-item').find(".grid-view_image"),
              wrapper = $(this).parents(".grid-view-item").find('.shopWrapper');
        
          $.ajax({
            url: url,
            dataType: 'html',
            type: 'GET',
            beforeSend:function(){
              $(imgwrapper).append("<i class='ad ad-spinner4 ad-spin'></i>");
              $(imgwrapper).addClass('showLoading');
            },
            success: function(data) {
              $(".shopWrapper").removeClass('active').html("");
              $(wrapper).addClass('active').html(data);
            },
            complete: function(data){
              $(imgwrapper).removeClass('showLoading');
              $(imgwrapper).find('.ad-spinner4').remove();
              if (theme.mlcurrency){ currenciesChange(".shopWrapper.active .product-single__price span.money"); }
            }
          });
      });
      $(document).on('click touch', '.closeShop', function(e){
      	e.preventDefault();
        $(this).parents(".shopWrapper").removeClass("active");
	  });
    }
  	function gridAddToCart() {
      $(document).on('click touch', '.add-to-cart', function(i){
        i.preventDefault(); i.stopImmediatePropagation();
          if (theme.ajax_cart) {
            var att = $(this).attr("id"),
            	qty = $(this).attr("rel");
            addinToCart(att, qty);
          } else {
            $(this).next().submit();
          }
        return;
      });
    }
    function prodAddToCart(){
      if (theme.ajax_cart) {
        var touchmoved;
        $(document).on('click touchend', '.product-form__cart-submit:not(.grid__cart-submit,.templokProductAddToCart,.updateItemBtn)', function(i){
          if (i.preventDefault(), "disabled" != $(this).attr("disabled"))
            
              if (touchmoved != true) {
                const form = $('.js-variants-form');
                const productWrapper = $('.tw-kanopi-product');
                var att = form.find("select[name=id]").val();
                    att || (att = form.find("input[name=id]").val());
                var qty = productWrapper.find("input[name=quantity]").val();
                    qty || (qty = 1);
                var props = {};
                $('[name="selling_plan"]').each(function(){
                    var key = $(this).attr('name'),
                        value = $(this).val();
                    props[key] = value;
                });
                $('[name*="properties"]').each(function() {
                  var key = $(this).attr('name').split('[')[1].split(']')[0];
                  var value = $(this).val();
                  props[key] = value;
                });
                let metafields = Shopify.productMeta[att];
                props['Item #'] = metafields.sku;
                props['_shipping_time'] = metafields.mfgProcess;
                if(isBundleTemplate()) {
                  props['_isBundle'] = true;
                }
                props = setDiscountProperties(metafields, props, att);
                addinToCart(att, qty, props);
              }
              return;
        }).on('touchmove', function(e){
            touchmoved = true;
        }).on('touchstart', function(){
            touchmoved = false;
        }).on('cart.requestComplete', async function(event, cart) {
          let cookieData = getCookie('cookieyes-consent')
          let consentValue = '';
          if (cookieData ){
            cookieData = getCookie('cookieyes-consent').split(',');
            for (const pair of cookieData) {
              if (pair.startsWith('consent:')) {
                  consentValue = pair.split(':')[1];
                  break;
              }
            }
          }
          if(consentValue != 'no'){
          var scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
          if(cart?.sections){
            var sections = cart.sections;
            if (sections.hasOwnProperty('cart-template')) {
              let html = sections['cart-template'].replace(scriptRegex, "");
              if($(`.additional-express-buttons`).length && $(html).find(`.additional-express-buttons`).length ){
                $(`.additional-express-buttons`).replaceWith($(html).find(`.additional-express-buttons`));
              }
            }
          }else{
            var response = await fetch(`/cart?sections=cart-template`);
            if (response.status === 200) {
              var sections = await response.json();
              if (sections.hasOwnProperty('cart-template')) {
                let html = sections['cart-template'].replace(scriptRegex, "");
                if($(`.additional-express-buttons`).length && $(html).find(`.additional-express-buttons`).length ){
                  $(`.additional-express-buttons`).replaceWith($(html).find(`.additional-express-buttons`));
                }
              }
            }
          }
          }
          if(window?.compatibleItemIndex > -1){
            cart.items.forEach((item,index) => {
              let product_type = item.product_type.toLowerCase();
              if(product_type == "ceiling"){
                window.compatibleItemIndex = index;
              }
            });
          }
          if(typeof UrgencyLogic == "function" && !window.isCartPage){
            UrgencyLogic(cart);
          }
          if(!$(".block-cart").hasClass("active")) {
            if($('body').hasClass('template-customers/account') || $('body').hasClass('template-customers/order')){
              window.location.href = '/cart';
            } else {
              if(!cart?.isload && !window.isError){
                addedToCartEffect();
              }else{
                if(window.asm_shipping_calculation_flag != true){
                  $("body").removeClass("loading");
                }
              }
            }
          }
          isCallingFromPageLoad = false;
        });
      }
    }
    function prodAddToCartGrid() {
      $(document).on('click', '.product-form__cart-submit.grid__cart-submit', function(e) {
        e.preventDefault();
        if ("disabled" !== $(this).attr("disabled") && typeof getActiveItems === 'function') {
          const currentGridItems = getActiveItems();
          const itemsToAdd = currentGridItems.map(item => {
            const metafields = Shopify.productMeta[item.id];
            let props = setDiscountProperties(metafields, {}, item.id);
            props['_shipping_time'] = metafields.mfgProcess;
            return {id: item.id, quantity: item.qty, properties: props};
          });
          if(itemsToAdd.length) {
            CartJS.addItems(itemsToAdd.reverse());
            addedToCartBtn();
          }
        }
      });
    }
    function compatibleGridPdpFunctionality () {
      const displayAlreadyInCart = (item, qty) => {
        const quantityWrapper = item.find('.items-added');
        quantityWrapper.html(qty);
        item.removeClass('tw-hidden');
      }
      const getCompatibleData = (items) => {
        let compatibleItems = [];
        items.each(function() {
          const item = $(this);
          const variantId = item.attr('data-id');
          const discount = item.attr('discount-value');
          const quantity = item.find('.product-form__input')?.val();
          if( quantity > 0) {
            const compatibleItem = $(`.already-in-cart-${variantId}`);
            const metafields = typeof Shopify.gridUpsell[variantId] !== 'undefined' ? Shopify.gridUpsell[variantId] : false;
            const expectedSurcharge = metafields && typeof kanopiSurcharge !== 'undefined' ? kanopiSurcharge._getProductSurchargeAmount(metafields) : 0;
            compatibleItems.push({id: variantId, quantity: quantity, properties:{"__rpaPercentage": expectedSurcharge,"_discount":discount}});
            displayAlreadyInCart(compatibleItem, quantity);
          }
        })
        return compatibleItems;
      }
      const getCurrentCompatibleItems = (target) => {
        const currentGrid = $(target.closest('.pdpCompatibleGridSystems'));
        return currentGrid?.find('.js-compatible-grid-item');
      }
      const addCompatibleGridItems = async (e) => {
        $('body').addClass('loading');
        e.preventDefault();
        const compatibleGridItems = getCurrentCompatibleItems(e.target)
        const itemsToAdd = getCompatibleData(compatibleGridItems);
        if(itemsToAdd.length) {
          await CartJS.addItems(itemsToAdd.reverse()); 
          if(window.pathname == "/cart"){
            topFunction();
          }
        }
      }
      const isAlreadyInCart = () => {
        const gridItems = $('.pdpCompatibleGridSystems');
        const cartItems = CartJS?.cart?.items;
        if(typeof cartItems === 'undefined' || cartItems.length === 0 || gridItems.length === 0) return;
        let totalItems = 0;
        cartItems.map(item => {
          const compatibleItem = $(`.already-in-cart-${item.id}`);
          if(compatibleItem.length > 0) {
            totalItems += item.quantity;
            displayAlreadyInCart(compatibleItem, item.quantity);
          }
        });
        totalItems > 0 && displayAlreadyInCart($('.alreadyCartMobile'), totalItems);
      }
      const recalcPrice = (e) => {
        setTimeout(() => {
          const items = getCurrentCompatibleItems(e.target)
          if(items.length === 0 || typeof theme === 'undefined' || typeof theme.Currency.formatMoney !== 'function') return;
          const totalPrice = $('.js-compatible-grid__total-price');
          let newTotal = 0;
          items.each( function(){
            const item = $(this);
            const price = item.attr('data-price');
            const quantity = item.find('.js-compatible-grid__update-qty--input')?.val();
            newTotal += price * quantity;
          });
          totalPrice.html(theme.Currency.formatMoney(newTotal, theme.moneyFormat));
        }, 500);
      }
      isAlreadyInCart();
      $('.js-add-grid-to-cart').on('click', addCompatibleGridItems);
      $('.js-compatible-grid__update-qty--btn').on('click', recalcPrice);
      $('.js-compatible-grid__update-qty--input').on('input', recalcPrice);
    }
    window.isError = false;
    function addinToCart(att, qty, props){
      // $("body").addClass("loading");
      let item_count = CartJS.cart.item_count;
      CartJS.addItem(att, qty,props,{
          "success": function(data, textStatus, jqXHR){
            let addtoInterval = setInterval(() => {
              if(CartJS.cart.item_count > item_count){
                clearInterval(addtoInterval);
                addedToCartEffect();
                addedToCartBtn();
                updateProductQuantity();
              }
            }, 500);
          },
          "error": function(jqXHR, textStatus, errorThrown){
            window.isError = true;
            var errormsg = JSON.parse(jqXHR.responseText).description;
            $("body").removeClass("loading");
            $(".error-message").text(errormsg);
            $("body").addClass("showOverly");
              $("#errorDrawer").fadeIn(500);
              drawerTimeout = setTimeout(function(){
                  $("body").removeClass("loading showOverly"), $("#errorDrawer").fadeOut(200)
              }, 6000);
          }
      });
    }
    function addedToCartEffect() {
      if (!$('#PageContainer').hasClass('cart')) {
        const flyoutCheckedTime = 5000;
        const toggleFlyoutChecked = (removeClass = false) => {
          const flyoutCheckedItem = $('.js-checked-flyout');
          removeClass ? flyoutCheckedItem.removeClass('tw-hidden') : flyoutCheckedItem.addClass('tw-hidden');
        }
        showOverly(true);
        setTimeout(function() { 
          $("body").removeClass("loading");
          $(".block-cart").addClass("active");
          toggleFlyoutChecked(true);
        }, 1000);
        setTimeout(toggleFlyoutChecked, flyoutCheckedTime);
      }
    }
    function addedToCartBtn() {
      const addToCartBtns = $('.js-add-to-cart');
      const activeTime = 3000;
      addToCartBtns.addClass("active");
      setTimeout(function() {
        addToCartBtns.removeClass("active");
      }, activeTime);
    }

  	$(document).on('cart.requestComplete', function(event, cart) {
      if(!window.isError){
        const totalItems = cart.items.reduce((total_items, item) => {
          if(typeof surchargeVariantId !== 'undefined' && item.id == surchargeVariantId) return total_items;
          return total_items + item.quantity;
        },0);
        const cartCount = $('.site-header__cart-count');
        const screenWidth = $(window).width();
        if(cartCount.length) cartCount.html(totalItems)
        // if(screenWidth <= mobileBreakpoint && cart.items.length === 0) {
        //   $(".block-cart").removeClass("active");
        //   showOverly(false);
        // }
        if(typeof kanopiSurcharge !== 'undefined' && addingSurcharge === false) kanopiSurcharge._handleCartSurcharge(cart.items);
        if(theme.mlcurrency){ currenciesChange("#cart-drawer sapn.money"); }
        setTimeout(function(){ freeship(); }, 3000);
      }else{
        window.isError = false;
      }
    });

    $(document).on('click', '.add-to-cart-sticky', function () {
      $('.product-form__cart-submit').click();
    });
        
    function freeship() {
         var freeshipPrice = $(".freeShipMsg").attr('data-price'),
             cartTotal = CartJS.cart.total_price,
             remainfreeship = freeshipPrice-cartTotal;
         if(remainfreeship>0){
         	$(".freeShipMsg .freeShip").html(theme.Currency.formatMoney(remainfreeship, theme.moneyFormat));
            $(".freeShipMsg").removeClass('hide'); $('.freeShipclaim').addClass('hide');
            if(theme.mlcurrency){currenciesChange(".freeShipMsg .freeShip sapn.money");}
         } else {
			$(".freeShipMsg").addClass('hide'); $('.freeShipclaim').removeClass('hide');
         }
    }
  	function wishlist() {
       var cookieName = "wishlistList";
       $(document).on('click', '.addto-wishlist', function(e){
           e.preventDefault();
             var id = $(this).attr('rel');
             if($.cookie(cookieName) == null) {
               var str = '__'+id;
             } else {
               if($.cookie(cookieName).indexOf(id) == -1) {
                 var str = $.cookie(cookieName) + '__' + id;
                 	str = str.replace('____', '__');
               }
             }
             $.cookie(cookieName, str, {expires:30, path:'/'});
             $(this).find(".ad").removeClass('ad-heart-l').addClass('ad-circle-notch-r ad-spin');
             setTimeout(function(){
               $('.wishlist[rel="'+id+'"]').removeClass('addto-wishlist').find('span').text(theme.wlAvailable);
               $('.wishlist[rel="'+id+'"] .ad').removeClass('ad-circle-notch-r ad-spin').addClass('ad-heart');
               updateWishlist();
             }, 2000);
         });
      	
     }
     function updateWishlist() {
       var cookieName = "wishlistList";
       try {
         if($.cookie(cookieName) != null && $.cookie(cookieName) != '__' && $.cookie(cookieName) != '') {
           var str = String($.cookie(cookieName)).split("__");
           for (var i=0; i<str.length; i++) {
             if (str[i] != '') {
               $('.wishlist[rel="'+str[i]+'"]').removeClass('addto-wishlist').find('span').text(theme.wlAvailable);
               $('.wishlist[rel="'+str[i]+'"] .ad').removeClass('ad-heart-l').addClass('ad-heart');
               $('.favCount').text(i).removeClass('hide');
             }
           }
         }
       }
       catch (err) {}
     }
};
window.addEventListener('DOMContentLoaded',function(){$(theme.ajaxCart);});

$(document).ready(function() {
  //matchHeightCompatibleGridSystemTitle();
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.collectionView);
  sections.register('product-template', theme.Product);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel', theme.carousel);
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
  sections.register('instagram', theme.instagramSection);
  sections.register('wizard-section', theme.WizardSection);
  sections.register('audio-player', theme.audioPlayer);
  sections.register('collection-widget', theme.collectionWidget);


  if ($('body').hasClass('attribute-update') && localStorage.getItem('surchargeZone') && localStorage.getItem('surchargeZipCode') && localStorage.getItem('surchargeValue')) {
    var surchargeZone = localStorage.getItem('surchargeZone');
    var surchargeZipCode = localStorage.getItem('surchargeZipCode');
    var surchargeValue = localStorage.getItem('surchargeValue');
    var attributes = {};
    attributes.surchargeZone = surchargeZone; 
    attributes.surchargeZipCode = surchargeZipCode; 
    attributes.surchargeValue = surchargeValue; 

    // Call CartJS to update the cart attributes
    $.ajax({
      url: '/cart/update.js', 
      type: 'POST',
      data: {
          attributes: attributes 
      },
      dataType: 'json',
      success: function(response) {
          console.log('Shopify cart updated with surchargeZone:', response);
      },
      error: function(xhr, status, error) {
          console.error('Error updating cart:', error);
      }
  });
}
});

var resizeTimer;
  $(window).resize(function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $(window).trigger('delayed-resize');
    }, 250);
});

theme.init = function() {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt){
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt){
    evt.preventDefault();
  });
};
/* Start Wizard */
window.theme = window.theme || {};
theme.Wizard = (function () {
  var selectors = {
    launcherCta: '.kanopi-cw-launcher',
    wizardID: 'wizard-launcher'
  };

  function init() {
    $(document).on('click', selectors.launcherCta, function (e) {
      window.location.href = '/pages/ceiling-selector';
      event.preventDefault();
    });
  }

  return { init: init };
})();

theme.WizardSection = (function () {
  function Wizard() {
    theme.Wizard.init();
  }
  Wizard.prototype = _.assignIn({}, Wizard.prototype, {
    onUnload: function () {
      theme.Wizard.unload();
    }
  });
  return Wizard;
})();

$(theme.init);

$(document).ready(function() {
  if (window.location.hash.substr(1) === 'openchat') {
    LiveChatWidget.call("maximize");
  }
  
  if ($('.tw-kanopi-product').length){
    $('html, body').animate({

      scrollTop: $("#header").offset().top + 1
  
  }, 50);
  }
  
  "use strict";
  
	$(document).on('click', '.currencyOpt', function(i){
      $('#CurrencySelector').val($(this).data('value'));
      $('#localization_form').submit();
    });
  
  	$(".saleTime, .heroSaleTime, .prcountdown").each(function(){
      var $this = $(this),
      	  date = $(this).data('date'),
      	  countDownDate = new Date(date).getTime();

		var x = setInterval(function(){
          var now = new Date().getTime(),	            
              distance = countDownDate - now,
              days = Math.floor(distance / (1000 * 60 * 60 * 24)),
              hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
              minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
              seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if(days > 99){
            days = ("00" + days).substr(-3);
          } else {
            days = ("00" + days).substr(-2);
          }
          hours = ("00" + hours).substr(-2);
          minutes = ("00" + minutes).substr(-2);
          seconds = ("00" + seconds).substr(-2);

          $($this).html("<span class='days'>" + days + "<span>"+theme.days+"</span></span> <span class='hours'>" + hours + "<span>"+theme.hours+"</span></span> <span class='minutes'>"+ minutes + "<span>"+theme.minuts+"</span></span> <span class='seconds'>" + seconds + "<span>"+theme.seconds+"</span>");

          if (distance < 0){
          	clearInterval(x); $($this).hide();
            $("#countdownLbl").hide();
		  }
		}, 1000);
  	});

   // LOOKBOOK SHOP 
	$('.btn-shop').click(function(){
       $('.products .list-columns, .grid-lookbook').removeClass('active');
       $(this).next().addClass('active');
       $(this).parents('.grid-lookbook').addClass('active');
	});
	$('.btn-shop-close').click(function(){     
    	$(this).parent().removeClass('active');
	});

  	// PROMOTION HEADER show-hide
	if($.cookie('promotion') == 'true') {
    	$(".notification-bar").slideUp();
  	}
	$(".close-announcement").click(function(){
		$(".notification-bar").slideUp();
		$.cookie('promotion', 'true', { expires: 1, path:'/'});
	});
  
	// SHOW HIDE PRODUCT Filters
  
  $(document).on('click touch', '.btn-filter, .closeFilter, .showResultsFilter', function(){
    	$(".filterbar").toggleClass("active");
      $("body,html").toggleClass("filter-open");
      $('#filter-overlay').toggleClass('show-filterOverlay');
	});
  $(document).on('click touch', '.closeFilter, .showResultsFilter', function(){
    $('#filter-overlay').removeClass('show-filterOverlay');
});
	$("body").click(function(event ){
    	var $target = $(event.target);
    	if(!$target.parents().is(".sb_filter") && !$target.is(".sb_filter")&& !$target.is(".btn-filter")){
      		$(".sb_filter").removeClass("active");
    	}
	});
  $(".filterOverlay").click(function(event ){
    var $target = $(event.target);
    if(!$target.parents().is(".sb_filter") && !$target.is(".sb_filter")&& !$target.is(".btn-filter")){
      $('#filter-overlay').removeClass('show-filterOverlay');
    }
});

  let hasWidthSet = false;
  // STICKY HEADER
   
  window.onscroll = function(){ scrollFunction() };
    function scrollFunction() {
      if (theme.fixedHeader){
        if($(window).scrollTop() > 145) {
          $('#header').addClass("stickyHeader animated fadeInDown");
          $('.stickySpace').css("min-height",$('#header').height());
          $('.tw-kanopi-predictive-search').css("position","fixed");
          $('#kanopi-sticky-banner')
            .addClass("animated fadeInDown")
            .css({position: 'fixed', top: $('#header').height() + 'px', display: 'flex'});
          if($(window).width() > mobileBreakpoint)
            $('.tw-kanopi-predictive-search').css({top: $('#header').height() + 'px'});
          setTimeout(function() {
            if(!hasWidthSet) {
              hasWidthSet = true;
            }
          }, 300);
        } else {
          $('#header').removeClass("stickyHeader fadeInDown");
          $('.stickySpace').css("min-height",'');
          $('#kanopi-sticky-banner')
            .removeClass("fadeInDown")
            .css({position: 'static',display: 'none'});
          if($(window).width() > mobileBreakpoint){
            $('.tw-kanopi-predictive-search').css("position","relative");
            $('.tw-kanopi-predictive-search').css({top: 'auto'});
          }
        }
      }
      
      // sticky cart checkout
      if($('#cartCheckout').length){
        if(getVisibility($('#cartCheckout')?.get(0))) {
          $('#cart-sticky').hide();
        }else{
          $('#cart-sticky').show();
        }
      }
  
      /// sticky cart
      if($(window).scrollTop()>600 && $(".stickyCart").length){
          $("body.template-product").css('padding-bottom','70px');
          $(".stickyCart").slideDown();
      } else {
          $("body.template-product").css('padding-bottom','0');
          $(".stickyCart").slideUp();
      }
  
      // SITE SCROLLER
      if($(window).scrollTop()>200){
        $("#site-scroll").fadeIn();
      } else {
        $("#site-scroll").fadeOut();
  
      }
  
      if ($('.specs-title-toggle').length > 0 && $(window).scrollTop() > $('.specs-title-toggle').offset().top - 65){
        const currentScrollHorizontalPosition = $('.container-products.scrolling')?.scrollLeft();
        const stickyHeader =   $('#sticky-header-parent');
        stickyHeader.show();
        $('#sticky-header-bottom').show();
        if(stickyHeader.scrollLeft() !== currentScrollHorizontalPosition) stickyHeader.scrollLeft(currentScrollHorizontalPosition)
      }else{
        $('#sticky-header-parent').hide();
        $('#sticky-header-bottom').hide();
      }
    }

  $("#site-scroll").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  }); 
  
   //Footer links for mobiles
  $(".footer-links .h4").click(function() {
    if($(window).width() < 750){
      $(this).toggleClass("active");
      $(this).next().slideToggle();
  	}
  });

  $(document).on("click",".qtyBtn", function() {
    if(!$(this).hasClass('qtytemplokProductAddToCart') && !$(this).hasClass('disabled')){
    if($(this).hasClass("patternBtn")) {
      calculateQuantityPatternModal($(this));
      return;
    }
      var qtyField = $(this).parent(".qtyField"),
         oldValue = $(qtyField).find(".qty").val(),
          newVal = 1;

      if ($(this).is(".plus")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).find(".qty").val(newVal);
      if(!$(qtyField).hasClass('js-compatible-grid-field')) {
        $('.qty-estimator-result-input').change();
        quantityChangeDetected = true;
        if($('.pdp-container').length){
          calculatorUpdates();
        }
      }
    }
  });

  function formatNumber(number) {
    const language = "en-US";
    number = parseInt(number);
    return number.toLocaleString(language);
  }

  // function resizeMobileStickyFooter(){
  //   let unitQtyLabels = $('.unity-qty-labels');
  //   let unitQtyLabelsString = unitQtyLabels.text();
  //   let addToCartSticky = $('.tw-sticky-add-to-cart .add-to-cart-wrapper .add-to-cart-sticky');
      
  //   if ($(window).width() <= mobileBreakpoint) {
  //     if ( unitQtyLabelsString.length >= 72 ){
  //       addToCartSticky.css({"width": "70%"});
  //     }
  //     else if ( unitQtyLabelsString.length >= 66 ){
  //       addToCartSticky.css({"width": "70%"});
  //     }
  //     else if ( unitQtyLabelsString.length >= 63 ) {
  //       addToCartSticky.css({"width": "80%"}); 
  //     }
  //     else if ( unitQtyLabelsString.length >= 60 ){
  //       addToCartSticky.css({"width": "90%"});
  //     } else if ( unitQtyLabelsString.length >= 57 ) {
  //       addToCartSticky.css({"width": "100%"});
  //     } else {
  //       addToCartSticky.css({"width": "100%"});
  //     }
  //   }
  // }

  window.UpdatePriceOnCarts = (currentQty) => {
    let unitQty = $('.unit-qty');
    let priceQtyNumber = $('.price-unit-qty-number');
    let priceQtyNumberValue = priceQtyNumber.data('qty');
    let priceUnitCovers = $('.price-unit-covers');
    let priceUnitCoversValue = priceUnitCovers.data('covers');
    let currentVariantPrice = $('.kanopi-current-variant-price');
    let currentVariantPriceValue = currentVariantPrice.data('price');
    let itemsLabel = $('.cart-items-label');
    let itemsLabelValue = currentQty > 1 ? 'ITEMS' : 'ITEM';
    let freeShipLabel = $('.free-shipping-msg');
    let shipInfoContainer = $('.tw-ship-info');
    let unitQtyLabel = $('.unit-label');
    let unitQtyLabelHtml = currentQty > 1 ? unitQtyLabel.data('label') + 's' : unitQtyLabel.data('label');
    let priceTitleLabel = $('.price-unit-qty-title');
    const labelText = priceTitleLabel.data('label');
    const isPluralLabel = labelText.charAt(labelText.length - 1) === 's';
    let priceTitleLabelHtml = currentQty > 1 && !isPluralLabel ? labelText + 's' : labelText;
    const activeGridSystem = $('.pdpCompatibleGridSystems.active .grid-system-container');
    if(isBundleTemplate()) {
      updateBundleTable();
    }
    if(unitQty)
      unitQty.html(formatNumber(currentQty));
    if (priceQtyNumber && priceQtyNumberValue) {
      const value = formatNumber(currentQty * priceQtyNumberValue);
      priceQtyNumber.html(value)
      priceQtyNumber.removeClass('tw-hidden');
    }
    if(priceUnitCovers && priceUnitCoversValue){
      let totalpriceUnit = parseFloat(currentQty * priceUnitCoversValue).toFixed(2);
      let totalpricedecimal = totalpriceUnit % 1;
      if(totalpricedecimal == 0){
        totalpriceUnit = parseInt(totalpriceUnit);
      }
      priceUnitCovers.html(totalpriceUnit);
    }
    if(currentVariantPrice && currentVariantPriceValue){
      let newPrice = currentQty * parseFloat(currentVariantPriceValue);
      currentVariantPrice.html(theme.Currency.formatMoney(newPrice.toFixed(2), theme.moneyFormat));
    if(unitQtyLabel) {
      unitQtyLabel.html(unitQtyLabelHtml);
    }
    if(priceTitleLabel && !isSampleBundleTemplate()) {
      priceTitleLabel.html(priceTitleLabelHtml);
    }

    //resizeMobileStickyFooter();
      //Update free shipment
      if (Shopify.free_ship < newPrice) {
        freeShipLabel.removeClass('tw-hidden');
        if (shipInfoContainer.hasClass('is-longer'))
        shipInfoContainer.addClass('long-text');
      }
      else {
        shipInfoContainer.removeClass('long-text');
        freeShipLabel.addClass('tw-hidden');
      }
    }
    if(itemsLabel)
      itemsLabel.html(itemsLabelValue);


    if(Shopify.Cart){
      gvariant = CartJS.cart.items[(window.compatibleItemIndex? window.compatibleItemIndex: 0)];
    }
    if(typeof Shopify.template !== 'undefined' && (Shopify.template === 'tile' || Shopify.Cart) && gvariant !== null && activeGridSystem.length && typeof estimatorGrid != "undefined" && typeof estimatorGrid.calculateUpsellFromQuantity === 'function') {
      if(!$(':focus').hasClass('.estimation-input-area') && $(':focus').parents('.estimation-form-inputs').length == 0){
        estimatorGrid.calculateUpsellFromQuantity(currentQty)
      }
    }
    if(typeof Shopify.template !== 'undefined' && (Shopify.template === 'tile' || Shopify.Cart) && gvariant !== null && activeGridSystem.length && typeof installationModal != "undefined" && typeof installationModal.calculateUpsellFromQuantity === 'function') {
      if(!$(':focus').hasClass('.estimation-input-area') && $(':focus').parents('.estimation-form-inputs').length == 0){
        installationModal.calculateUpsellFromQuantity(currentQty);
      }
    }
  }
  if(
    $('.cart__qty-input').length > 0 && 
    $('#grid-upsell-shopping-cart-container').length > 0 
  ){
    setTimeout(() => {
      window.compatibleItemIndex = parseInt(window.compatibleItemIndex);
      if(window.compatibleItemIndex >= 0){
        UpdatePriceOnCarts($('.cart__qty-input:not(".mobile-qty")').eq(window.compatibleItemIndex).val());
      }
    }, 500);
  }
  $(document).on('keyup keypress','.cart-qty,.cart__qty-input', function(e) {
    const keyArray = [];
    const currentKey = e.which;
    for (i = 48; i < 58; i++)
      keyArray.push(i);
    if (!(keyArray.indexOf(currentKey)>=0))
        e.preventDefault();
    if($('.pdp-container').length && $(this).val() > 0){
      quantityChangeDetected =  true;
    }
    if(Shopify.Cart){ 
      if($(this).parents('.cart__row').hasClass('is-compatible')){
        if($(this).val() > 0){
          UpdatePriceOnCarts($(this).val());  
        }else{
          UpdatePriceOnCarts(1);
        }
      }
    }else{
      if($(this).val() > 0){
        UpdatePriceOnCarts($(this).val());  
      }else{
        UpdatePriceOnCarts(1);
      }
    }
  });
  $(document).on('change','.cart-qty', function(event) { // This is for Product page quantity box 
    let min_quantity = parseInt($(this).attr('data-min') != ""?$(this).attr('data-min'): 1);
    let max_quantity = parseInt($(this).attr('data-max'));
    let error = false;
      let current_value = $(this).val();
      if(min_quantity && current_value <= min_quantity ){
        $(this).parents('.qtyField').find('.minus').addClass('disabled');
        if(current_value < min_quantity){
          error = true;
          $(this).val(min_quantity)
        }
      }else{
        $(this).parents('.qtyField').find('.minus').removeClass('disabled');
      }
      if(max_quantity && current_value >= max_quantity ){
        $(this).parents('.qtyField').find('.plus').addClass('disabled');
        if(current_value > max_quantity){
          error = true;
          $(this).val(max_quantity)
        }
      }else{
        $(this).parents('.qtyField').find('.plus').removeClass('disabled');
      }
      let qtyFieldCompo = $(this).parents('.qtyField').find('.min-max-quantity-error');
      var error_msg = "";
      if(min_quantity && current_value < min_quantity ){
        error_msg = window.min_msg_on_pdp.replaceAll('XXX',min_quantity);
      }
      if(max_quantity && current_value > max_quantity ){
        error_msg = window.max_msg_on_pdp.replaceAll('XXX',max_quantity);
      }
      if(error_msg != ""){
        qtyFieldCompo.removeClass('tw-hidden').find('.error-msg').text(error_msg);
        clearTimeout(window.quantity_validation_timer);
        window.quantity_validation_timer = setTimeout(function() {
          qtyFieldCompo.addClass('tw-hidden')
        },window.min_max_time_to_show);
      }
      UpdatePriceOnCarts($(this).val());  
      if (
        ($('.estimation-input-area').length > 0 && $('.estimation-input-area').val().length > 0) ||
        ($('.estimation-input-width').length > 0 && $('.estimation-input-width').val().length > 0) ||
        ($('.estimation-input-length').length > 0 && $('.estimation-input-length').val().length > 0)
      ){
        if($('.pdp-container').length && error){
          calculatorUpdates();
        }
      }
  });
 
  function changeVariantImg(element,status, newImage = null) {
    var $element = $(element),
    newImage = newImage ? newImage : $(element).attr('rel'),
    gridWrapper = $(element).parents('.grid-view-item').find('.grid-view-item__link');     
      if(status == 'hover'){
        var oldImage = $(element).parents('.grid-view-item').find('.gridSwatches li:not(.noImg).active').attr('rel'); 
        if(oldImage) {
          $(element).parents('.grid-view-item').find('.variantImg').data('old-image',oldImage);
        }
      }
      if(status == 'exit') {
        $(gridWrapper).find('.variantImg').css("background-image", "");
        $element.removeClass('active');
        $element.siblings().removeClass('active');
        $(element).parents('.grid-view-item').find('.variantImg').data('old-image',null);
        
          $(gridWrapper).removeClass("showVariantImg");
        
        if($element.hasClass('active'))
        {
          $(gridWrapper).find('.variantImg').css("background-image", "url('"+newImage+"')");
        }
      } else {
        //$(gridWrapper).addClass("showLoading");
        $(gridWrapper).find('.variantImg').css("background-image", "url('"+newImage+"')");
        var image = document.createElement('img');
        image.src = newImage;
        image.onload = function () {
          $(gridWrapper).removeClass("showLoading").addClass("showVariantImg");
          $element.siblings().removeClass(status);
          $element.addClass(status);
        };
      } 
      if (status == 'active') {
        $(element).parents('.grid-view-item').find('.variantImg').data('old-image',newImage);
      }
    return false;
  } 

  $(document).on('click', '.gridSwatches li:not(.noImg)', function(){      
    if($(this).hasClass('active')) {
      changeVariantImg(this, 'exit');
    } else {
      changeVariantImg(this, 'active');
    }
  });
  $(document).on('mouseover', '.gridSwatches li:not(.noImg)', function(e) {
    changeVariantImg(this, 'hover');
  });
  $(document).on('mouseout', '.gridSwatches li:not(.noImg)', function(e) {
    const swatch = $(this);
      if(swatch.hasClass('active')) return;
      var oldImage = swatch.parents('.grid-view-item').find('.variantImg').data('old-image');
      if (oldImage) {
        changeVariantImg(this,'', oldImage);
      }else{
    changeVariantImg(this, 'exit');
      }
    
  });
});

const handlePricePerUnitVisibility = (price_per_unit, price, hidePricePerUOM = "false") => {
  const displayElements = (!price_per_unit || price_per_unit === '$0.00' || price_per_unit === price || isBundleTemplate() || hidePricePerUOM === 'true') ? false : true;
  const items = $('.js-optional-price');
  displayElements ? items.removeClass('tw-hidden') : items.addClass('tw-hidden');
}
const updateDetailsSpecs = async function (variantID) {
  if ($('#details-specs-content').length > 0) {
    var url = window.location.origin + window.location.pathname;
    let sectionID = $('.kanopi-product-details-section').data('section-id');

    var res = await fetch(url + '?sections=' + sectionID + '&variant=' + variantID+ '&variant_id=' + variantID)
    .then(res => res.json())
    .then(resJson => {
      var html = resJson[sectionID];
      var sectionString =$(html).find('#details-specs-content');
      $('#details-specs-content').html(sectionString.html());
    });
  }
}

const updateFreeShippingMsg = (priceTotal, free_shipping_price) => {
  loadingFreeShippingText = true;
  if(typeof priceTotal == 'undefined'){
   priceTotal = shippingPriceFree.total/100;
  }
  if(typeof free_shipping_price == 'undefined'){
   free_shipping_price = shippingPriceFree.freePrice;
  }
  const $shipping_msg = $(".instock-wp .stock-text .st-1 .free-shipping-msg.not-free-shipping");
  if(priceTotal > free_shipping_price && !$shipping_msg.hasClass('active') || priceTotal < free_shipping_price && $shipping_msg.hasClass('active')) {
    $shipping_msg.toggleClass('active');
  }
  const $shipping_msg_otherinfo_text = $(".option.free-message > .text").find("span");
  if(priceTotal!=0 && free_shipping_price!=0 && priceTotal >= free_shipping_price) {
    $shipping_msg_otherinfo_text.first().addClass('tw-hidden');
    $shipping_msg_otherinfo_text.last().removeClass('tw-hidden');  
    }else{
    $shipping_msg_otherinfo_text.first().removeClass('tw-hidden');
    $shipping_msg_otherinfo_text.last().addClass('tw-hidden');
    }
  loadingFreeShippingText = false;
}

let controllerSections;
const updateSections = async (path, key) => {
  loadingOnSelectChange = true;
  try {
    if (controllerSections) {
      controllerSections.abort();
    }
    controllerSections = new AbortController();
    const { signal } = controllerSections;
    const response = await fetch(path,{ signal });
    if (response.status === 200) {
      const sections = await response.json();
      const upsellHolder = $('#product-upsell-holder');
      const volumenDiscountsWrapper = $('.vol-discounts-msg-wrapper');
      if (sections.hasOwnProperty('stock-info-banner')) {
        $('#stock_banner_holder').html(sections['stock-info-banner']);
      }
      if (sections.hasOwnProperty('product-shipping-time')) {
        $('.product-general-shipping').html(sections['product-shipping-time']);
      }
      if (sections.hasOwnProperty('specs-block')) {
        $('#specficiations_holder').html(sections['specs-block']);
      }
      if (upsellHolder.length > 0 && sections.hasOwnProperty('section-upsell-component')) {
        upsellHolder.html(sections['section-upsell-component']);
      } 
      if (volumenDiscountsWrapper.length > 0 && sections.hasOwnProperty('pdp-volume-discount-promo')) {
        volumenDiscountsWrapper.html(sections['pdp-volume-discount-promo']);
        checkVolumeDiscount(true);
      }
      if (sections.hasOwnProperty('cart-template')) {
        let scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
        let html = sections['cart-template'].replace(scriptRegex, "");
        let contentLeftTable = $(html).find(`#cartItemsId tbody`);
        if(contentLeftTable) {
          let cookieData = getCookie('cookieyes-consent')
          let consentValue = '';
          if (cookieData ){
            cookieData = getCookie('cookieyes-consent').split(',');
            for (const pair of cookieData) {
              if (pair.startsWith('consent:')) {
                  consentValue = pair.split(':')[1];
                  break;
              }
            }
          }
          let yourCartText = $(html).find(`#pageTitleCartId`);
          $(`#pageTitleCartId`).html( yourCartText.html() );
          $(`#cartItemsId tbody`).replaceWith(contentLeftTable);
          $(`#asm-discount-title`).replaceWith($(html).find(`#asm-discount-title`));
          $(`#asm-discount-rate`).replaceWith($(html).find(`#asm-discount-rate`));
          if(consentValue != 'no'){
            $(`.additional-express-buttons`).replaceWith($(html).find(`.additional-express-buttons`));
          }
          $(`#pdp-shipedy-by-container-cart`).replaceWith($(html).find(`#pdp-shipedy-by-container-cart`));
          $(`#pdp-shipedy-by-container-cart-mobile`).replaceWith($(html).find(`#pdp-shipedy-by-container-cart-mobile`));
          $(`#additional-discounts-scripts`).replaceWith($(sections['cart-template']).find(`#additional-discounts-scripts`));
          if (typeof checkSurchargeInCompatibleGrid === 'function') checkSurchargeInCompatibleGrid(force=1);
          if (CartJS.cart.items.length == 0){
            $("#kanopi-cart-template").html($(html).find("#kanopi-cart-template").html());
            $('body').removeClass('loading cartUpdating');
          }
          if(window.cart_min_max_error){
            let id = window.cart_min_max_error.id;
            if(window.cart_min_max_error.validation == "min"){
              error_msg = window.min_msg_on_cart.replaceAll('XXX',window.cart_min_max_error.min_quantity);
            }else{
              error_msg = window.max_msg_on_cart.replaceAll('XXX',window.cart_min_max_error.max_quantity);
            }
            let qtyFieldCompo = $('[data-variant-id="'+id+'"]').find('.qtyField .min-max-quantity-error')
            qtyFieldCompo.removeClass('tw-hidden').find('.error-msg').text(error_msg);
            clearTimeout(window.quantity_validation_timer);
            window.quantity_validation_timer = setTimeout(function() {
              qtyFieldCompo.addClass('tw-hidden')
            },window.min_max_time_to_show);
            delete window.cart_min_max_error;
          }
          calculateCartPrices();
          if(key != 1){
            forcetoUpdateASMwoZIP();
          }       
        }
      }
    } 
  } catch(error){
    if (error.name !== 'AbortError') {
      console.error(error);
    }
  } finally {
    loadingOnSelectChange = false;
    if ($('.volume_promotion_msg.vol-cart').length){
      $('.volume_promotion_msg.vol-cart').each(function(i, v) {
        let variantId = $(v).attr('data-variant-id'); 
        let lineItem = Shopify.lineItems[variantId];
  
        if (lineItem && lineItem.variantTierData) {
            let variantTierData = JSON.parse(lineItem.variantTierData);
            if (variantTierData.length > 0) {
                variantTierData.sort((a, b) => a.tier_min_quantity - b.tier_min_quantity);
                let tierHtml = '';
                variantTierData.forEach((tier, index) => {
                    let discountValue = (tier.tier_discount_type === "percentage") 
                        ? `${tier.tier_discount_percentage}%` 
                        : `$${tier.tier_discount_amount}`;
  
                    if (index === variantTierData.length - 1) {
                        tierHtml += `<li>${tier.tier_min_quantity}+ cartons: ${discountValue} off</li>`;
                    } else {
                        tierHtml += `<li>${tier.tier_min_quantity}-${tier.tier_max_quantity} cartons: ${discountValue} off</li>`;
                    }
                });
  
                $(v).find('.cart-tooltip-main ul').html(tierHtml);
                $(v).find('.promotion-text').text(lineItem.volumeMsg);
            }
        }
      });
    }
  }
  hideReturnPolicy();
}

const renderCharacteristicsDetailsCommon = function (variantId) {
  const tplRowFeature = `
      <span class="characteristic-title tw-relative tw-flex tw-text-arm-plt-col27" char="%title%" style="margin-top: 12px">
        <img width="34" src="%img%" alt="%title%" style="margin-right: 8px" ><span class="tw-characteristics-title tw-text-arm-plt-col27"> %title%</span>
      </span>
    `;
  const tplRowFeatureModal = `
  <div class="accordion-features">
    <div class="header-accordion-features">
      <a href="javascript:void(0);" class="link-feature">
        <span class="characteristic-title tw-relative focus:tw-text-arm-black hover:tw-text-arm-black tw-text-arm-black">
          <img width="34" src="%img%" alt="%title%"> %title%
        </span>
        <i class="ad ad-angle-down-l tw-ml-auto"></i>
      </a>
    </div>
    <div class="body-accordion-features">%description%</div>
  </div>`;

  const index = isGridTemplate() ? 0 : variantId;
  var productMeta = Shopify.productMeta && Shopify.productMeta[index];
  const handleChartsVisibility = (displayStyle = 'display: none !important') => {
    $('.char-tile-graph > div.char-tile-graph-first').attr('style', displayStyle);
    $('.char-tile-graph, .triggerModal, .nrc-up-to, .char-tile-rows').attr('style', displayStyle);
  }
  var feature_desc = Shopify.feature_meta && Shopify.feature_meta.feature_descriptions ? Shopify.feature_meta.feature_descriptions.array_characteristics_description: [];
  if (!productMeta || !productMeta.characteristics) {
    handleChartsVisibility();
    return;
  }
  
  var listHtml = [];
  var listHtmlModal = [];
  let hasCharts = false;
  Object.keys(productMeta.characteristics).forEach(function (key,index) {
    var item = productMeta.characteristics[key];
    if (item.finalValue.toString() !== 'false') {
      let itemDesc = feature_desc.find(i => i.name.includes(key));
      if (isCoolEdgeTemplate()) {
        tmpItemDesc = feature_desc.find(i => i.name.includes(key+'_cooledge'));
        if (tmpItemDesc) {
          itemDesc = tmpItemDesc;
        }
      }
      if (isSpaceKitTemplate()) {
        tmpItemDesc = feature_desc.find(i => i.name.includes(key+'_spacekit'));
        if (tmpItemDesc) {
          itemDesc = tmpItemDesc;
        }
      }
      let description = itemDesc? itemDesc.description:'';
      let titleKey = key;
      switch(key.trim()){
        case 'Sound Absorption':
          if(item.value == "null" || item.value == null || item.value == 0 || item.value == "0" || item.value == false || item.value == "false"){
            $('.char-tile-absorption').parent().addClass('tw-hidden');
            $('.char-tile-absorption').parent().removeClass('tw-flex');
            break;
          }else{
            if(item.value > 0){
              $('.char-tile-absorption').parent().addClass('tw-flex');
              $('.char-tile-absorption').parent().removeClass('tw-hidden');
              $('.nrc-up-to').show();
              hasCharts = true;
            }
            $('.char-tile-absorption .title-percent').html(parseFloat(item.value).toFixed(2));
            let percent = parseInt(item.value*100,0);
            $('.char-tile-absorption').attr('class', `char-tile-absorption c100 small blue p${percent}`);
            break;
          }
        case 'Sound Blocking':
          if(item.value == "null" || item.value == null || item.value == 0 || item.value == "0" || item.value == false || item.value == "false"){
            $('.char-tile-blocking').parent().removeClass('tw-flex');
            $('.char-tile-blocking').parent().addClass('tw-hidden');
            break;
          }
          else{
            if(item.value > 0){
              $('.char-tile-blocking').parent().addClass('tw-flex');
              $('.char-tile-blocking').parent().removeClass('tw-hidden');
              hasCharts = true;
            }
            $('.char-tile-blocking .title-percent').html(item.value);
            let percent2 = parseInt(((item.value*100)/50),0);
            $('.char-tile-blocking').attr('class', `char-tile-blocking c100 small blue p${percent2}`);
            break;
          }
        default:
          if(key == "Sag/Humidity Resistance"){
            titleKey = item.value;           
          }
          if(key == "Mold/Mildew Resistance"){
            titleKey = item.value;           
          }
          if(key == "Fire Guard"){
            titleKey = titleKey.trim().replace('Fire Guard', "FIRE GUARD");
          }
          if(isCoolEdgeTemplate()){
            item.value = item.value.replaceAll('"','');
            let titleKeyExrta = '';
            if(key === 'Light Output'){
              item.value = item.value.replace(' lumens','').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              titleKeyExrta=' lumens';
            }
            if(key === 'CCTs'){
              switch (parseInt(item.value,0)) {
                case 3000: titleKeyExrta = ', warm white color'; break;
                case 3500: titleKeyExrta = ', neutral white color'; break;
                case 4000: titleKeyExrta = ', cool white color'; break;
              }
            }
            if(key === 'CRI'){
              titleKey = `${ key }:<b style='margin-left:2px;'>>${ item.value.replace('>','') }</b>`;
            } else {
              titleKey = `${ key }:<b style='margin-left:2px;'>${ item.value }${ titleKeyExrta }</b>`;
            }
          }
          if(listHtml.length > 4 && $(window).width() <= 1280){
            if (item.value) {
              listHtml.push(
                tplRowFeature.replace(/%title%/ig, titleKey)
                .replace('%img%', item.iconUrl)
              .replace('characteristic-title','characteristic-title mobile-exta-features-btn'));
            }
          }else{
            if (item.value) {
              listHtml.push(
                tplRowFeature.replace(/%title%/ig, titleKey)
                .replace('%img%', item.iconUrl)
              );
            }              
          }
        break;
      }
      if (item.value) {
        listHtmlModal.push(
          tplRowFeatureModal.replace(/%title%/ig, titleKey)
          .replace('%description%', description)
          .replace('%img%', item.iconUrl)
        );
      }
    }
  });
  if(hasCharts) {
    $('.char-tile-graph').show();
    handleChartsVisibility('display: flex');
  }else {
     handleChartsVisibility();
  }
  const sound_blocking = $('#char-tile-blocking');
  if(sound_blocking.length){
    Number(sound_blocking.find('.title-percent').text())==0 ? sound_blocking.parent().hide(): '';
  }
  if(listHtml.length){
    $('.triggerModal').show();
    $('.char-tile-rows').show();
  } else {
    if($('.fDatacenterBlock').length) {
      $('.container-details-special').css('margin-top','18px');
      $('.triggerModal').show();
      $('#hr-modal-feature-extra').hide();
    }
  }
  let listHtmlCE = [...listHtml];
  let half = Math.ceil(listHtml.length/2);
  let col1 = listHtml.splice(0,half).join('');
  let col2 = listHtml.splice(0,listHtml.length).join('');
  
  // if(isCoolEdgeTemplate() || ['acoustical-accents-square','acoustical-accent-tear-drop'].includes(product.handle)){
  //   col1 = listHtmlCE.join('');
  //   col2 = '';
  //   $('#char-tile-col-1').removeClass('col-lg-6');
  //   $('#char-tile-col-2').remove();
  // }
  if($(window).width() <= 1280){
    let label='';
    let modalfeatures='';
    if (listHtmlCE.length > 0 ){
      if (listHtmlCE.length > 5) {
        label ='<div class="tw-flex xl:tw-hidden"><a href="javascript:void(0);" class="tw-view-more-btn more tw-group tw-mt-4" data-type="features"><span id="swatch-view-label" class="tw-basic-link">View more features</span><i class="ad ad-angle-down-l lg:group-hover:tw-text-arm-plt-col04 group-active:tw-text-arm-plt-col04"></i></a></div>';
      }
      modalfeatures = `<a href="javascript:void(0);" data-modal-id="modal-features" class="pdp-features-mean open-modal-btn ${listHtmlCE.length > 5 ? 'mobile-exta-features-btn' : '' } tw-mt-4 tw-basic-link">What do these features mean?</a>`
    }
    let features = col1 + col2 ;
    $('.char-tile-col-1').html(features+modalfeatures+label);
  } else {
    if (listHtmlCE.length > 0 ) {
      $('#features-copy-desktop').addClass('xl:tw-block');
    } else {
      $('#features-copy-desktop').removeClass('xl:tw-block');
    }
    $('.char-tile-col-1').html(col1);
    if(col2.length){
      $('.char-tile-col-2').html(col2);
    }
  }
 
  
  let half_modal = Math.ceil(listHtmlModal.length/2);
  let col1_modal = listHtmlModal.splice(0,half_modal).join('');
  let col2_modal = listHtmlModal.splice(0,listHtmlModal.length).join('');
  $('#modal-features-col-1').html(col1_modal);
  $('#modal-features-col-2').html(col2_modal);
  
  $('.link-feature').off('click').on('click', function() {
    $('.link-feature i').addClass('ad-angle-down-l').removeClass('ad-angle-up-l');
    $('.feature-open').find(".body-accordion-features").slideUp(500);
      if(!$(this).parent().parent().hasClass("feature-open")){
        $(this).parent().parent().find(".body-accordion-features").slideDown(500);
        if(!isTileTemplate() && !isWallTemplate()){
          $(".container-features").find(".feature-open").removeClass('feature-open');
        }
        $(this).parent().parent().addClass('feature-open');
        $(this).find('i').addClass('ad-angle-up-l').removeClass('ad-angle-down-l');
      }else { 
        $(this).parent().parent().removeClass('feature-open');
      }
  });
};
$(document).on('click','.pdp-features-mean',function(){
  let modal_name =  $(this).attr('data-modal-id');
  openModalFunction(modal_name);
});
function checkSurchargeInCompatibleGrid(force = 0) {
  const currentCompatibleGridItems = $('.pdpCompatibleGridSystems.active .grid-system-container');
  if(currentCompatibleGridItems.length === 0 || typeof Shopify.gridUpsell === 'undefined'|| typeof kanopiSurcharge === 'undefined' || typeof theme.Currency.formatMoney === 'undefined') return;
  const mobilePrice = $('.pdpCompatibleGridSystems.active .product-mobile .regular-price .price_per_sqft');
  const variantId = mobilePrice.attr("data-id");
  const mainData = Shopify.gridUpsell[variantId];
  const mainSurcharge = kanopiSurcharge._getProductSurchargeAmount(mainData);
  if(mainSurcharge !== '0' || force == 1) {
    const sqft = mobilePrice.attr("data-sqft");
    const sqftPrice = kanopiSurcharge._getSurchargePriceHelper(sqft, mainSurcharge);
    if(sqftPrice) mobilePrice.html(sqftPrice);
  }
  currentCompatibleGridItems.each(function() {
    const item = $(this);
    const itemId = item.attr('data-id');
    const metafields = Shopify.gridUpsell[itemId];
    const expectedSurcharge = kanopiSurcharge._getProductSurchargeAmount(metafields);
    const itemBox = item.find('.js-compatible-grid-item');
    const price = parseFloat(metafields.price);
    const surcharge_price = Math.floor(price * (expectedSurcharge/100));
    const finalPrice = price + surcharge_price;
    const priceHtml = item.find(`.regular-wrp #slider-price-${itemId}`);
    if(expectedSurcharge !== '0' || force == 1) {
      itemBox.attr('data-price', finalPrice);
      priceHtml.html(theme.Currency.formatMoney(finalPrice, theme.moneyFormat));
    }
    var applyDiscount = localStorage.getItem('applyDiscount') === 'true' && metafields.has_discount === 'true' ;
    if (applyDiscount){
      const discountedPrice = finalPrice - (finalPrice * metafields.discount_value) / 100
      itemBox.attr('discount-value', metafields.discount_value);
      itemBox.attr('data-price', discountedPrice);
      itemBox.attr('data-discount-price',discountedPrice);
      item.find('.wrp-reg .reg-price').html(theme.Currency.formatMoney(finalPrice, theme.moneyFormat));
      priceHtml.html(theme.Currency.formatMoney(discountedPrice, theme.moneyFormat));
    } else {
        item.find('.wrp-reg').removeClass('has-discount');
        item.find('.regular-wrp').removeClass('has-discount');
    }
  });

  if (typeof recalcPrice === 'function'){
    recalcPrice();
  } else if (typeof CalculateNewTotal === 'function') {
    CalculateNewTotal();
  }
}
function updateCompatibleGrid(variantId) {
  const compatibleGridMap = $('#compatible-grid-map')?.val();
  if(!compatibleGridMap || !variantId) return;
  const data = compatibleGridMap.split(',');
  const activeGrid = $('.pdpCompatibleGridSystems.active');
  data.pop();
  const currentCompatibleGrid = data.find(item => {
    const [itemId, compatibleName] = item.split(':');
    return variantId == itemId ? true : false;
  });
  const hideCompatibleElement = () => {
    activeGrid.toggleClass('active tw-hidden');
  }
  const showCompatibleElement = (handle) => {
    const newCurrentCompatibleGrid = $(`.pdpCompatibleGridSystems.${handle}`);
    newCurrentCompatibleGrid.toggleClass('active tw-hidden');
  }
  const updateVariantTitle = (variant, handle) => {
    if(!handle || typeof variant !== 'object') return;
    const variantName = variant.name;
    const variantImage = variant.thumbnail;
    const newCurrentCompatibleGrid = $(`.pdpCompatibleGridSystems.${handle}`);
    const nameHtml = newCurrentCompatibleGrid.find('.js-compatible-grid-name');
    const imageHtml = newCurrentCompatibleGrid.find('.js-compatible-grid-image');
    nameHtml.text(variantName);
    imageHtml.attr('src', variantImage);
  } 
  if(currentCompatibleGrid) {
    const [itemId, compatibleName] = currentCompatibleGrid.split(':');
    if(!activeGrid.hasClass(compatibleName)) {  
      hideCompatibleElement();
      showCompatibleElement(compatibleName);
    }
    updateVariantTitle(Shopify.productMeta[itemId], compatibleName);
    checkSurchargeInCompatibleGrid();
  }else {
    hideCompatibleElement();
  }
} 

function validateInput(input) {
  const hasValue = (input && input.value)? true : false;
  if(!hasValue) input.classList.add('input--error');
  else input.classList.remove('input--error');
  return hasValue;
}


//Modals JS

$(document).ready(function() {  
  setTimeout(function(){
    const openModalBtn = $('.open-modal-btn:not(.customizeBtn)');
    const closeModalBtn = $('.close-modal-btn');

    window.openModalFunction = (modalID) => {
      if(modalID){
        $('div#chat-widget-container').addClass('popupopen');
        if (modalID == 'modal-audio-tools'){
          $('.modal-audio-tools-mobile').removeClass('tw-hidden');
          $('html').first().css('overflow','hidden');
        }else{
            $('#' + modalID).removeClass('tw-hidden');
            $('html').first().css('overflow','hidden');
        }
      
      }
    }

    const closeModalFunction = (modalID) => {
      if(modalID) {
        $('div#chat-widget-container').removeClass('popupopen');
        if (modalID == 'modal-audio-tools'){
          $('.modal-audio-tools-mobile').addClass('tw-hidden');
        }else if (modalID == 'promo-modal'){
          
          $('#' + modalID).addClass('tw-hidden');
          $.cookie("lastClosePopup", new Date().toISOString(), {expires:365, path:'/'});
          $.cookie("lastAddtoCart", null, { path: '/' });
          clearInterval(window.promoInterval);
          promoIntervalFun();
        }else{
          $('#' + modalID).addClass('tw-hidden');
        }
        $('html').first().css('overflow','auto');
        if ( (modalID  == 'modal-audio-tools') && sound_player ){
          sound_player.stopVideo(); 
        }
      }
    }

    openModalBtn.click(function() {
      openModalFunction($(this).data('modal-id'));
    });

    closeModalBtn.click(function() {
      closeModalFunction($(this).data('modal-id'));
    });

    $(document).mouseup(function(e) 
    {
      var container = $(".kanopi-modal-content");
      var modal = $('.kanopi-modal').not('.tw-hidden');
      
      // if the target of the click isn't the container nor a descendant of the container
        if ((modal.length > 0) && (!container.is(e.target) && container.has(e.target).length === 0) && !$(e.target).hasClass('dont-close-modal')) 
        {
          var current_modal = modal[0].id;
          if(modal.length > 1){
            // check which modal is on the top if have multiple modal open
            var index_highest = 0;
            modal.each(function(){
                var index_current = parseInt($(this).css("z-index"), 10);
                if(index_current > index_highest) {
                    index_highest = index_current;
                    current_modal = this;
                }
            });
            current_modal = current_modal.id;
          }
          closeModalFunction(current_modal);
          if(modal.attr('id')=="modal-quote"){
            $(".input_email_k input").val("").removeClass("invalid-email valid-email");
            $(".container-info").removeClass("tw-hidden");
            $(".quote-confirmation-section").addClass("tw-hidden");
            $(".email-error").addClass("tw-hidden"); 
          }
        }
    });


    //Video Setup

    const coverVideoPlayer = $('#cover-video-player');

    coverVideoPlayer.click(function() {
      if (yt_ready){
        
        sound_player.playVideo();
        $('#cover-video-player').addClass('tw-hidden');
      }
    }); 
  },1000)

  const checkedSwatchColor = $('.swatch-element.is-color input:checked').val();
  const itemSwatchColor = $(".js-swatch-item[data-color-label='" + checkedSwatchColor + "']");
  // ChangeSingleImgColorLabel(itemSwatchColor);  

  
});

function CalculateNewTotal(){
  const gridUpsellContainer = $('.parent-grid-system-container');
  gridUpsellContainer.each(function(index,element){
    var total = 0;
    const productsGrid = $(element).find('.grid-system-container');
    productsGrid.each(function(i,el){
      let itemPrice;
      let item = $(el).find(".product-form__item--quantity");
      let qty = $(el).find(".product-form__input.qty").val();
      if(item.attr('data-discount-price')){
        itemPrice = parseInt(item.attr('data-discount-price'));
      }else{
        itemPrice = parseInt(item.attr('data-price'));
      }
      total += parseInt(itemPrice * qty);
    });
    $(element).parent().parent().find('.total-bundle')
      .attr('total',total)
      .html(`<b>${ Shopify.formatMoney(total) }</b>`);
  })
}
function handleSelectedSwatch(item) {
  const templateName = $(item).data('template');
  const inputId = $(item).data('id');
  const input = $(`#${inputId}`);
  if(input.length) input.trigger('click');
  let data_variant_id = getParameterByName('variant');
  const data_image_id = $('.product-form__variants option[value='+data_variant_id+']').attr('data-image-id');
  if(data_image_id?.length) {
    let slideIndex = $("a[data-image-id='" + data_image_id + "']").data("slide");
    const insideModalSample = $(item).closest('#modal-sample');
    const isInsideModalSample = insideModalSample.length;
    if(!isInsideModalSample){
      $('.product-single__thumbnails-item[data-slick-index="'+slideIndex+'"').trigger('click');
    }
  }
    ChangeSingleImgColorLabel(item);
}

function handleSelectedImg(element){
  let swatchID = $(element).data('image-id');
  if(swatchID?.length) {
    let inputColorSwatch = $("input[data-image-id='" + swatchID + "']");
    if (inputColorSwatch){
      if(inputColorSwatch.length == 1){
        inputColorSwatch.click();
      }else{
        var alreadySelected = false;
        inputColorSwatch.each(function(i,el){
          if($(el).prop('checked')){
            alreadySelected = true;
          }
        });
        if(!alreadySelected){
          inputColorSwatch.click();
        }
      }
    }
  } 
}

$(document).on('click', '.primgthumb', function () {
  CheckGridSampleInCart();
});

/* Change main image when current color option is not available */
function ChangeMainImageWithNoAvailableOption(){
  if($('.swatch-element.is-color input:checked').length < 2){
    checkedSwatchColor = $('.swatch-element.is-color input:checked').val();  
    itemSwatchColor = $(".js-swatch-item[data-color-label='" + checkedSwatchColor + "'] .swatch-color");
    var swatchImgID = itemSwatchColor.data('image-id');
    var slickInstance = $('.product-single__thumbnails');
    var currentSlideIndex = slickInstance.slick('slickCurrentSlide');
    var thumbImgID = $(".primgthumb[data-slide='" + currentSlideIndex + "']").data('image-id');
    var swatchInput = $(".swatchInput[data-image-id='" + thumbImgID + "']");

    if ((swatchInput.length > 0) && (currentSlideIndex != 0) && (swatchImgID != thumbImgID)){
      let carouselImage = $("a[data-image-id='" + swatchImgID + "']");
      if (carouselImage.length > 0){
        let slideIndex = $("a[data-image-id='" + swatchImgID + "']").data("slide");
        $('.product-single__thumbnails-item[data-slick-index="'+slideIndex+'"').trigger('click');
      }
    }
  }
}

$('.product-single__thumbnails').on('afterChange', function(event, slick, currentSlide, nextSlide) {
  var imageId = "";
  $(".primgthumb[data-slide='" + currentSlide + "']").each(function() {
      if($(this).attr('id')){
          $thumbImg = $(this);
          imageId = $(this).attr('id');
          return false;
      }
  })
  if(window.clickLabel != ""){
    let item = $('.js-swatch-item[data-image-id="'+imageId+'"]');
    let swatchColorLabel = $(item).data('color-label0');
    $(".color-label").html(swatchColorLabel);
  }else{
    let label = $('.color-label-data[media-id="'+imageId+'"]').attr('color-label0');
    if($('.swatch-element[data-value="'+label+'"]').hasClass('tw-hidden')){
      $(".color-label").html('');
    }else{
      $(".color-label").html(label);
      $('.swatch-element[data-value="'+label+'"] .js-swatch-item').click();
      var label1 = $('.color-label-data[media-id="'+imageId+'"]').attr('color-label1');
      if(label1 != ""){
        $('.swatch-element[data-value="'+label1+'"] .js-swatch-item').click();
        var label2 = $('.color-label-data[media-id="'+imageId+'"]').attr('color-label2');
        if(label2 != ""){
          $('.swatch-element[data-value="'+label2+'"] .js-swatch-item').click();
        }
      }
    }
  }
  window.clickLabel = "";
  window.sliderclick = false;
});

/* Change main image color label when we have just one img on PDP */
function ChangeSingleImgColorLabel (item) {
  let swatchColorLabel = $(item).data('color-label');
  if($(item).data('image-id')){
    $(".color-label:visible").html(swatchColorLabel);
  }
   var $container = $('.color-swatch-list');
   if(!isElementVisibleHorizontally($('[data-value="'+swatchColorLabel+'"]'),$container)){
      var scrollTo = $('[data-value="'+swatchColorLabel+'"]').position().left;
      $container.animate({'scrollLeft': scrollTo}, 500);
   }
}

//Sticky Banner anchors
let anchorClick = false;
$('a.anchor').on('click', function (){
  anchorClick = true;
  $('a.anchor').each(function () {
    normalStateNav($(this));
  });
  selectedStateNav($(this));
  setTimeout(function() {
    anchorClick = false;
  },1000);

});
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
var doc_height = $(document).height();
var third = (doc_height / 3);
var widthBrowser=375;
const back2TopLogic = () => {
  let chatIconWidth = 60;
  let hasCartFooter = $('#cart-sticky').is(':visible');
  let hasPDPFooter = $('.tw-sticky-add-to-cart').hasClass("display");//is(':visible');
  let hasCompareFooter = $('#comparison-bar').is(':visible')
  let hasCompareFooterACtive = $('#comparison-bar.active').is(':visible')
  let classCompare= `with-compare${(hasCompareFooterACtive)?' with-compare-active':''}`;
  let hasModal = $('body').hasClass('showOverly');
  if($('#chat-widget-container iframe#chat-widget-minimized').length){
    chatIconWidth = $('#chat-widget-container iframe#chat-widget-minimized').contents().find('img').width();
  }
  if(chatIconWidth >40 ){
    // backgroundSize: '60px'
  }
  if(hasCompareFooter){
    $('#chat-widget-container, #back-to-top').removeClass('with-compare with-compare-active');
    $('#chat-widget-container, #back-to-top').addClass(classCompare);
  }else{
    $('#chat-widget-container, #back-to-top').removeClass('with-compare with-compare-active');
  }
  if(hasPDPFooter || hasCartFooter){
    $('#chat-widget-container, #back-to-top').addClass('with-sticky');
  }else{
    $('#chat-widget-container, #back-to-top').removeClass('with-sticky');
  }
  $('#chat-widget-container').css({visibility:'visible',opacity:1});
  if ($(window).scrollTop() > third && !(/^\/(cart)/.test(location.pathname))) {
    $('#chat-widget-container').addClass('with-back');
    if($(window).width() > 767) {
      $('#back-to-top').show();
    }else{
      if(hasPDPFooter || hasCompareFooter){
        $('#chat-widget-container').removeClass('with-back');
        $('#back-to-top').hide();
      }else{
        $('#back-to-top').show();
      }
    }
  } else {
    $('#back-to-top').hide();
    $('#chat-widget-container').removeClass('with-back');
  }
  if(hasModal){
    $('#chat-widget-container, #back-to-top').hide();
  }else{
    $('#chat-widget-container').show();
  }
};

const isVisible = ($el,extraTop=0) => {
  let docViewBottom = $(window).scrollTop() + $(window).height();
  let docViewTop = $(window).scrollTop()+ $('#header').height() +$('#kanopi-sticky-banner').height();
  let elTop = $el.offset().top+extraTop;
  let elBottom = elTop + $el.height();
  return((elBottom <= docViewBottom) && (elTop >= docViewTop));
}
function isElementInViewport(elem) {
  var $elem = $(elem);

  var elemTop = $elem.offset()?.top;
  var elemBottom = elemTop + $elem.height();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elemBottom > viewportTop && elemTop < viewportBottom;
}
const getVisibility = (element) => {
  if (typeof element === 'undefined') return false;
  const rect = element.getBoundingClientRect();
  const viewPortBottom = window.innerHeight || document.documentElement.clientHeight;
  const isTopInViewPort = rect.top >= 0;
  const isBottomInViewPort = rect.bottom <= viewPortBottom;
  return isTopInViewPort && isBottomInViewPort;
}
$(function () {
  $(window).on('resize', function(){
    widthBrowser = $(window).width()
    if ($(window).width() <= 767) {
      back2TopLogic();
    }
  });
  //Adding Anchor on Review Section
  let anchorElement = '<div class="section-anchor tw-absolute tw-top-[-200px]" id="reviewsSection" ></div>'
  $('#stamped-main-widget').append(anchorElement);
  $('#stamped-main-widget').addClass('tw-relative');
  if(isSpaceKitTemplate()) $('#stamped-main-widget').addClass("tw-my-0");
  $(window).on("scroll", function() {
    if($('.quick-order-landing').length > 0){
      let btnIsVisible = isVisible($('.quick-order-landing .quick-order-add-to-cart'),16);
      if(btnIsVisible){
        $('.quick-order-sticky').removeClass('sticky-quick-addcart');
        $('.quick-order-sticky').addClass('tw-hidden');
      }else{
        $('.quick-order-sticky').addClass('sticky-quick-addcart');
        $('.quick-order-sticky').removeClass('tw-hidden');
      }
    }
    
    back2TopLogic();
    const addToCartSticky = $('#add-to-cart-sticky');
    const addToCartStickyMobileFotter = $('.tw-sticky-add-to-cart');
    const addToCartMobileIsVisible = $(window).width() > tabletBreakpoint ? false : getVisibility($('.add-to-cart--buttons')?.get(0));
    $('.section-anchor').each(function() {
      let current = $(this);
      const sectionTop = current.offset().top - 40;
      const sectionHeight = 300;
      let sectionId = current.attr("id");
      sectionId = sectionId != "reviewsSection"  ? sectionId : "stamped-main-widget";
      let currentNav = $("a[href*=" + sectionId + "].anchor");
      //Avoid two add to carts buttons
      if (current.hasClass('add-to-cart') || addToCartMobileIsVisible) {
        let btnIsVisible = isVisible($('.add-to-cart'),16)
        if (btnIsVisible || addToCartMobileIsVisible) {
          addToCartSticky.addClass('tw-hidden');
          addToCartStickyMobileFotter.removeClass('display');
        } else {
          addToCartSticky.removeClass('tw-hidden');
          addToCartStickyMobileFotter.addClass('display');
        }
      }
      if(!anchorClick){
        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight
          ){
          scrollStateNav(currentNav);
        } else {
          normalStateNav(currentNav);
        }
      }
    });
  });
});

$(document).on('ready', function(){
 function collapsibleStampedReviewContent() {
    let windowWidth = $(window).width();
    var sectionMobileStampedReviews = "#stamped-main-widget .stamped-container .stamped-content #stamped-reviews-tab";
    
      $(sectionMobileStampedReviews+" .stamped-review").each(function () { 
        let reviewCommentText = $(this).find('.stamped-review-content-body').not( ".originalCompleteText" );
        if(!$(this).find('.originalCompleteText').length){
          reviewCommentText.clone().addClass('originalCompleteText tw-hidden').insertAfter(reviewCommentText);
        }
        $(this).find('.stamped-review-content-body').not( ".originalCompleteText" ).remove(); 
        $(this).find('.originalCompleteText').clone().insertBefore($(this).find('.originalCompleteText')).removeClass('originalCompleteText').removeClass('tw-hidden').removeAttr("style");
        reviewCommentText = $(this).find('.stamped-review-content-body').not( ".originalCompleteText" );
        reviewCommentText.nextAll().removeAttr("style");
        if(windowWidth <= 767){
        if( reviewCommentText.text().length>200){ 
          let reviewCommentTextMaxLength = reviewCommentText.text().substring(200);
          let reviewCommentTextArray = reviewCommentText.text().split(reviewCommentTextMaxLength);
          reviewCommentTextArray[1] = '<span>'+reviewCommentTextMaxLength+'</span>';
          reviewCommentText = reviewCommentText.text(reviewCommentTextArray[0]);
          let reviewCommentTextArrayElement = $(reviewCommentTextArray[1]);
          reviewCommentTextArrayElement.addClass('completeText tw-hidden');
          reviewCommentText.append(reviewCommentTextArrayElement);
          reviewCommentText.addClass('trimedReviewComment');
          reviewCommentText.append('<div><a href="#" class="showmore tw-text-base tw-text-arm-plt-col08 tw-underline tw-w-auto hover:tw-text-arm-plt-col04 tw-group tw-transition-none"><span>More</span></a></div>');
          reviewCommentText.nextAll().css("cssText", "display: none !important;");
        }
      }
      });
    
  }
  collapsibleStampedReviewContent();
  
  $(window).on('resize', function(){
    collapsibleStampedReviewContent();
  });
  function showMore(thisItem) {
    $('.completeText').removeClass('tw-hidden');
    thisItem.parent().parent().removeClass('trimedReviewComment');
    thisItem.parent().parent().nextAll().removeAttr("style");
    thisItem.text('Less');
  }
  function showLess(thisItem) {
    $('.completeText').addClass('tw-hidden');
    thisItem.parent().parent().addClass('trimedReviewComment');
    thisItem.parent().parent().nextAll().css("cssText", "display: none !important;");
    thisItem.text('More');
  }
  $(document).on('click', '.showmore', function() {
    let thisItem = $(this);
    if(thisItem.text() == 'More'){
    showMore(thisItem);
    }else {
    showLess(thisItem);
    }
    return false;
  })
  

   
});

$(document).on('ready', function() {
  if($("#addToCartSection").length === 0) return false;
  const sectionTopMobile = $("#addToCartSection").offset().top - $('#header').height() - 482;
  if(sectionTopMobile <= $(window).height()){

    $('.tw-sticky-add-to-cart').removeClass('display');
  }
});

const selectedStateNav = function (element) {
  element.addClass("tw-font-extrabold");
  element.removeClass("tw-text-arm-plt-col02");
  element.removeClass("tw-text-arm-plt-col08");
  element.addClass("tw-text-arm-plt-col04");
}

const normalStateNav = function (element) {
  element.removeClass("tw-font-extrabold");
  element.removeClass("tw-text-arm-plt-col08");
  element.removeClass("tw-text-arm-plt-col04");
  element.addClass("tw-text-arm-plt-col02");
}

const scrollStateNav = function (element) {
  element.addClass("tw-font-extrabold");
  element.removeClass("tw-text-arm-plt-col02");
  element.removeClass("tw-text-arm-plt-col04");
  element.addClass("tw-text-arm-plt-col08");
}


function showOverly(show, zindex= 100, top=0) {
  $(".modalOverly").css("top", top+"px");
  if(show) {
    $('body').addClass("showOverly");
    $('html').addClass("no-scroll");
    $(".modalOverly").css("z-index", zindex + 1);
    if(typeof isQuickView === "function" && isQuickView()){
    }
  } else {
    $('body').removeClass("showOverly");
    $('html').removeClass("no-scroll");
    $(".modalOverly").css("z-index", "100");
  }
  back2TopLogic();
}
//Collapsable Items
const initCollapseAcordionPosition = function (resized) {  
  $(".panel").each(function() {
    let panelIndex = $(this).attr('data-index');
    let currentCollapsable = 'collapse-'+ panelIndex;
    let currentCollapsableID = '#' + currentCollapsable;
    let collapsedElement = $(this).find(currentCollapsableID+' .panel-body.tw-collapse-acordion-transition');
    let heightQuestionText = $(this).find('.collapsed').height(); 
    let lineHeightQuestionText = $(this).find('.collapsed').css('line-height');
    lineHeightQuestionText = parseFloat(lineHeightQuestionText)
    var rowsQuestionText = heightQuestionText / lineHeightQuestionText;
    rowsQuestionText = Math.round(rowsQuestionText)
    let movePxTop = isBundleTemplate() ? 32 : 16;
    var i=0;
    var topInPixels = 0;
    for(i=0; i<rowsQuestionText; i++){
      topInPixels = topInPixels+16;
      $(this).find('.collapsed').css('top', topInPixels+'px');
    }
    
    var collapsedElementHeight = collapsedElement.height()+movePxTop;
    if (currentCollapsableID.indexOf('chart-') != -1){
      collapsedElementHeight = 132;
    }
    let currentQuestionText = $(this).find('.collapsed');
    if( !currentQuestionText.hasClass('tw-collapsed') || collapsedElement.parent().attr('id') == 'collapse-detailsMobile' || resized == true ){
      $(currentCollapsableID + ' > .panel-body').css({'margin-top': '-'+collapsedElementHeight+'px'});
      $(currentCollapsableID + ' > .panel-body').attr('data-m-top', '-'+collapsedElementHeight+'px');
      
      if(collapsedElement.parent().attr('id') == 'collapse-detailsMobile') {
        if($('#detailSectionTile').find('.tw-collapsed').length >= 1){
          let detailsCol = '#' + $('#detailSectionTile').find('.tw-collapsed').data("toggle-id");
          if(!resized){
          $(detailsCol + ' > .panel-body').css({'margin-top': '0%', 'visibility': 'visible', 'height': 'auto'});
          $(detailsCol).removeClass('hidden');
          $(detailsCol).addClass('shown');
          }else if(resized == true){
            let detailscollapsedElementDetailsMobile = $(currentCollapsableID + ' > .panel-body').height()+movePxTop;
            $(currentCollapsableID + ' > .panel-body').attr('data-m-top', '-'+detailscollapsedElementDetailsMobile+'px');
          $(detailsCol).removeClass('hidden');
          $(detailsCol).addClass('shown');
          }
        }
        window.addEventListener("load", (event) => {
          let collapsedElementDetailsMobile = $(currentCollapsableID + ' > .panel-body').height()+movePxTop;
          $(currentCollapsableID + ' > .panel-body').attr('data-m-top', '-'+collapsedElementDetailsMobile+'px');
        });
      } 
    }
    if(!currentQuestionText.hasClass('tw-collapsed') && collapsedElement.parent().parent().hasClass('more-questions') && !collapsedElement.parent().parent().is(':visible')) {
      $(currentCollapsableID + ' > .panel-body').removeAttr("data-m-top");
      $(currentCollapsableID + ' > .panel-body').removeAttr("style");
      }  
  
  });
}
$(document).ready(function() {
  const openDetails = () => {
    const detailsBlock = $('.js-specification-accordion');
    detailsBlock.trigger('click');
  }
  initCollapseAcordionPosition();
 $(document).on('click','.panel .panel-title', function() {
    let panelIndex = $(this).attr('data-index');
    let currentCollapsable = 'collapse-'+ panelIndex;
    let currentCollapsableID = '#' + currentCollapsable;
   if($('#collapse-'+panelIndex).hasClass('shown')){
    let mTop = $(currentCollapsableID + ' > .panel-body').attr('data-m-top');
    $(currentCollapsableID + ' > .panel-body').css({'margin-top': mTop});
    $('a[data-toggle-id=' + currentCollapsable + ']').removeClass('tw-collapsed');
    $('a[data-toggle-id=' + currentCollapsable + ']').addClass('tw-expand');
    $(currentCollapsableID).removeClass('shown');
    $(currentCollapsableID).addClass('hidden');
    }else {
      $(currentCollapsableID + ' > .panel-body').css({'margin-top': '0%', 'visibility': 'visible', 'height': 'auto'});
      $('a[data-toggle-id=' + currentCollapsable + ']').removeClass('tw-expand');
      $('a[data-toggle-id=' + currentCollapsable + ']').addClass('tw-collapsed');
      $(currentCollapsableID).removeClass('hidden');
      $(currentCollapsableID).addClass('shown');
   }
  });

  if($(window).width() > mobileBreakpoint ) openDetails();

  var dwidth = $(window).width();
  $(window).on('resize', function(){
    if(dwidth!==$(window).width()){
      dwidth = $(window).width();
      var resized = true;
      initCollapseAcordionPosition(resized);
      $('.panel > .panel-heading > .panel-title > .collapsed').removeClass('tw-collapsed').addClass('tw-expand');
      if($('.panel-collapse').hasClass('shown')){
        $('.panel-collapse').removeClass('shown');
        $('.panel-collapse').addClass('hidden');
      }
    }
  });
  back2TopLogic();
  setTimeout(() => {
    back2TopLogic();
  }, 2000);
});

//View More Swatches Mobile
$(document).on('click','.tw-view-more-btn', function() {
  var type = $(this).data('type');
  var className = 'mobile-exta-' + type + '-btn';
  let hiddenSwatches = $('.' + className);
  let visibleSwatches = $('.visible-' + className);

  if ($(this).hasClass('more')) {
    hiddenSwatches.each(function() {
      $(this).removeClass(className);
      $(this).addClass('visible-' + className);
    });

    $(this).removeClass('more');
    $(this).addClass('less');
    $(this).find('#swatch-view-label').html('View less ' + type);
    $(this).find('i').removeClass('ad-angle-down-l');
    $(this).find('i').addClass('ad-angle-up-l');
    
  } else {
    visibleSwatches.each(function() {
      $(this).removeClass('visible-' + className);
      $(this).addClass(className);
    });
    $(this).removeClass('less');
    $(this).addClass('more');
    $(this).find('#swatch-view-label').html('View more ' + type);
    $(this).find('i').removeClass('ad-angle-up-l');
    $(this).find('i').addClass('ad-angle-down-l');
    
  }
});
//Show More Filters
$(document).on('click','.tw-show-more-filters-btn', function() {
  var type = $(this).data('type');
  var className = 'extra-' + type + '-btn';
  let hiddenSwatches = $('.' + className);
  let visibleSwatches = $('.visible-' + className);

  if ($(this).hasClass('more')) {
    hiddenSwatches.each(function() {
      $(this).removeClass(className);
      $(this).addClass('visible-' + className);
    });

    $(this).removeClass('more');
    $(this).addClass('less');
    $(this).find('#swatch-view-label').html('Show less');
    //$(this).find('i').removeClass('ad-angle-down-l');
    //$(this).find('i').addClass('ad-angle-up-l');
    
  } else {
    visibleSwatches.each(function() {
      $(this).removeClass('visible-' + className);
      $(this).addClass(className);
    });
    $(this).removeClass('less');
    $(this).addClass('more');
    $(this).find('#swatch-view-label').html('Show more');
    //$(this).find('i').removeClass('ad-angle-up-l');
    //$(this).find('i').addClass('ad-angle-down-l');
    
  }
});


//Color Swatch mobile scroll
let lastColorSwatchScrollLeft = 0;
$('.product-swatches .color-swatch-list').on('scroll', function() {
  const elementWidth = $(this).outerWidth();
  const scrollLeft = $(this).scrollLeft();
  const scrollWidth = $(this).get(0).scrollWidth;
  const borderXWidth = 2;
  const scrollRemainingRightSpace = (scrollWidth - scrollLeft + borderXWidth) - elementWidth;
  const swatchWidth = 30;
  if (scrollRemainingRightSpace < swatchWidth && scrollRemainingRightSpace  >= 0 ) {
    $('.product-swatches .tw-mobile-gradient.right').addClass('tw-hidden');
  } else {
    $('.product-swatches .tw-mobile-gradient.right').removeClass('tw-hidden');
  }

  if (scrollLeft > lastColorSwatchScrollLeft) {
    $('.product-swatches .tw-mobile-gradient.left').addClass('scrolled');
  }
  
  lastColorSwatchScrollLeft = scrollLeft;
  if (lastColorSwatchScrollLeft == 0){
    $('.product-swatches .tw-mobile-gradient.left').removeClass('scrolled');
  }
});

//Color Swatch mobile scroll
let lastBreadcrumpMobilelLeft = 0;
$(document).ready(function(){
  if ($('.bredcrumbWrap .breadcrumbs').length > 0) {
    let breadcrumbsMaxScroll = $('.bredcrumbWrap .breadcrumbs')[0].scrollWidth;
    $('.bredcrumbWrap .breadcrumbs').scrollLeft(breadcrumbsMaxScroll);
  }
});

$('.bredcrumbWrap .breadcrumbs').on('scroll', function() {
  var scrollLeft = $(this).scrollLeft();
  if (scrollLeft > lastBreadcrumpMobilelLeft) {
   $('.bredcrumbWrap .breadcrumbs .tw-mobile-gradient.left').addClass('scrolled');
  }
  lastBreadcrumpMobilelLeft = scrollLeft;
  if (lastBreadcrumpMobilelLeft == 0){
    $('.bredcrumbWrap .breadcrumbs .tw-mobile-gradient.left').removeClass('scrolled');
  }
});

$(document).on('click','.swatch-element',function(){
  var type = $(this).find('.swatchInput').data('type');
  $('.pdp-container').attr('data-last-element-clicked',type);
})
function checkExtraSwatches (){
  let last_element_clicked = $('.pdp-container').attr('data-last-element-clicked');
  let swatchElementSizes = $('.swatch-element.is-size');
  let swatchElementEdges = $('.swatch-element.is-edge');
  let swatchElementShapes = $('.swatch-element.is-shape');
  let viewMoreBtnSizes = $('.tw-view-more-btn.sizes');
  let viewMoreBtnEdges = $('.tw-view-more-btn.edges');
  let viewMoreBtnShapes = $('.tw-view-more-btn.shapes');
  let maxWatchToShow = 6;
  
  
  if($(window).width() <= tabletBreakpoint) {
    
      if(swatchElementSizes.not('.tw-hidden').length > maxWatchToShow){      
        viewMoreBtnSizes.removeClass('tw-hidden');
        for (var i = maxWatchToShow; i <= swatchElementSizes.not('.tw-hidden').length; i++){
          if (viewMoreBtnSizes.hasClass('less')) {
            $(swatchElementSizes.not('.tw-hidden')[i]).find('.swatchLbl').addClass('visible-mobile-exta-sizes-btn');
          }else{
            $(swatchElementSizes.not('.tw-hidden')[i]).find('.swatchLbl').addClass('mobile-exta-sizes-btn');
          }
        }
      }else{
        if (last_element_clicked != 'size') {
          viewMoreBtnSizes.addClass('tw-hidden');
        }
      }
    if(swatchElementEdges.not('.tw-hidden').length > maxWatchToShow){      
      viewMoreBtnEdges.removeClass('tw-hidden');
      for (var i = maxWatchToShow; i < swatchElementEdges.not('.tw-hidden').length; i++){
        if (viewMoreBtnEdges.hasClass('less')) {
          $(swatchElementEdges.not('.tw-hidden')[i]).find('.swatchLbl').addClass('visible-mobile-exta-edges-btn');
        }else{
          $(swatchElementEdges.not('.tw-hidden')[i]).find('.swatchLbl').addClass('mobile-exta-edges-btn');
        }
      }
    }else{
      if (last_element_clicked != 'edge') {
        viewMoreBtnEdges.addClass('tw-hidden');
      }
    }
    
    if(swatchElementShapes.not('.tw-hidden').length > maxWatchToShow){      
      viewMoreBtnShapes.removeClass('tw-hidden');
      for (var i = 6; i < swatchElementShapes.not('.tw-hidden').length; i++){
        if (viewMoreBtnShapes.hasClass('less')) {
          $(swatchElementShapes.not('tw-hidden')[i]).find('.swatchLbl').addClass('visible-mobile-exta-shapes-btn');
        }else{
          $(swatchElementShapes.not('tw-hidden')[i]).find('.swatchLbl').addClass('mobile-exta-shapes-btn');
        }
      }
    }else{
      if (last_element_clicked != 'shape') {
        viewMoreBtnShapes.addClass('tw-hidden');
      }
    }
  }  
}

// Start Installation services functionality
const toggleInstallationCheckbox = () => {
  const checkboxes = $('.cmp-checkbox-installation .customCheckbox');
  const installationAdditionalInfo =  $('.installation__info-install');
  
  installationAdditionalInfo.toggle();
  checkboxes.toggleClass('customCheckboxChecked');

  const isChecked = checkboxes.hasClass('customCheckboxChecked') ? true : false; 
  localStorage.setItem("require_installation_help", isChecked);
};

const checkInstallationLs = () => {
  const installationIsActive = localStorage.getItem("require_installation_help");
  if(installationIsActive === 'true') toggleInstallationCheckbox();
};

//Hide paypal payment from express methods in cartflyout
// const maxNumberOfChecks = 10;
// let currentCheck = 0;
// const expressButtonsWatcher = () => {
//   currentCheck = 0;
//   const interval = 1000;
//   const expressButtonsContainer = $('.tw-express-cartflyout.initial-load')
//   const checkAlreadyInjectedButtons = setInterval(() => {
//     const displayButtons = () => {
//       if(expressButtonsContainer.length > 0) expressButtonsContainer.removeClass('initial-load');
//       clearInterval(checkAlreadyInjectedButtons);
//     }
//     const paypalIframe = $('#cart-drawer .tw-express-cartflyout iframe[title="Checkout with PayPal"');
//     if(paypalIframe.length === 0 && currentCheck < maxNumberOfChecks) {
//       currentCheck++;
//       return;
//     }
//     if( currentCheck === maxNumberOfChecks) {
//       displayButtons();
//       return;
//     }
//     const iframeContainer = paypalIframe.closest('li');
//     if(iframeContainer.length > 0) iframeContainer.addClass('tw-hidden');
//     if(typeof kanopiSurcharge !== 'undefined' && kanopiSurcharge._isSurchargeZone()){
//       const shoPay = $('#cart-drawer .tw-express-cartflyout div[data-testid="ShopifyPay-button"');
//       const shoPayContainer = shoPay.closest('li');
//       if(shoPayContainer.length > 0) shoPayContainer.addClass('tw-hidden');
//       if(kanopiSurcharge._isLowcharge()) {
//         $('#cart-drawer .tw-express-cartflyout div:contains(GooglePay)').addClass('tw-hidden');
//         $('#cart-drawer .tw-express-cartflyout div:contains(Apple)').addClass('tw-hidden');
//       }
//     }
//     displayButtons();
//   }, interval);
// }

const checkFlagDisplay = () => {
 let currentSlideImgeIndx =  $('.product-single__thumbnails').slick('slickCurrentSlide');
 let $ribbon = $('.tw-kanopi-product .ribbon');
 let $productLargeImg = $('.prod-large-img');
 if ($ribbon.hasClass('has-flag')){
  $ribbon.removeClass('tw-hidden');
  $ribbon.addClass('tw-inline-block');
  $productLargeImg.addClass('has-flag');
 } else {
   if($ribbon.hasClass('has-flag')){
     $ribbon.removeClass('tw-inline-block');
     $ribbon.addClass('tw-hidden');
     $productLargeImg.removeClass('has-flag');
   }
 }
}
const checkDiscountFlag = () => {
  const $ribbon = $('.tw-kanopi-product .ribbon');
  const hasRegularDiscount = checkDiscounts(Shopify.hasDiscount, lsRegularDiscount);
  const hasVolDiscount = checkDiscounts(Shopify.hasDiscount, lsVolumeDiscount);
  const variantDiscountFlag = $('.vol-pdp').attr("data-vol-discount");
  if(hasRegularDiscount || hasVolDiscount) {
    if(variantDiscountFlag != "false"){
      $ribbon.addClass('tw-discount-ribbon has-flag');
    }
  }
}
// On after slide change
$('.product-single__thumbnails').on('afterChange', function(){
  checkFlagDisplay();
});

$(document).on('ready', function() {
  checkDiscountFlag();
  checkInstallationLs();
  //expressButtonsWatcher();
  $('.cmp-checkbox-installation .customCheckbox').on('click', toggleInstallationCheckbox);
  checkFlagDisplay();
  $.getJSON('/cart.js', function(cart) {
    if (cart && cart.attributes && cart.attributes.surchargeZipCode) {
      const surchargeZipCode = cart.attributes.surchargeZipCode;
      const surchargeZone= cart.attributes.surchargeZone;
      $('#asm-ship-to-zip').text(surchargeZipCode)      
      $('#asm-force-zip').val(surchargeZipCode).change();
      localStorage.setItem('surchargeZone',surchargeZone)
      $('#asm-force-zip-apply').trigger('click');
    } else if (cart && cart.attributes && !cart.attributes.surchargeZipCode){
      const surchargeZoneLs = localStorage.getItem('surchargeZone');
      const surchargeZipCodeLS = localStorage.getItem('detectedZipcode');
      const surchargeValueLS = localStorage.getItem('surchargeValue');
      // Merge all attributes into one object
        const attributesToUpdate = {
          'surchargeZone': surchargeZoneLs,
          'surchargeZipCode': surchargeZipCodeLS,
          'surchargeValue': surchargeValueLS,
      };

      if (surchargeZoneLs && surchargeZipCodeLS && surchargeValueLS) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attributesToUpdate })
        });
      }
    }
  }).fail(function() {
    console.error('Failed to retrieve cart data.');
  });
})

$(document).on("click", function(event) {
  var container = $(".tw-kanopi-predictive-search");
  if (!container.is(event.target) && !container.has(event.target).length && container.hasClass('active')) {
    container.removeClass("active");
    $('html').removeClass("no-scroll");
  }
  if (!$(event.target).parents('top-level-modal').length && !$(event.target)[0].tagName == "top-level-modal") {
    showOverly(false);
  }
});

//Debounce fn definition
function debounce(fn, timeout = 1000) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { fn.apply(this, args); }, timeout);
  };
}
const updateBundleTable = () => {
  const quantity = $('#quantity').val();
  $('#bundle-description-qty').html(`Based on your selections, your bundle${ quantity > 1 ? 's' : '' } will include the following components:`);
  $('.bundle-calc-qty').each((index,element) => {
    let qty_col = $(element).attr('data-qty') * quantity;
    let int_qty_col = qty_col;
    qty_col = qty_col.toLocaleString();
    $(element).html(`${qty_col} <span class="bundle-crt-desktop tw-hidden lg:tw-inline-block">carton${int_qty_col > 1 ? 's' : '' }</span><span class="bundle-crt-mobile lg:tw-hidden">ctn${int_qty_col > 1 ? 's' : '' }</span>`);
  });
}

/** Shogun **/
function setSelectElement(selectOne, selectTwo) {
  if (selectOne === 'Architect/Specifier/Designer') {
    $('.results-images-kanopi').hide();
    $('.results-kanopi').show();
    $('.results-kanopi-contractor').hide();
  } else if (selectOne != 'Architect/Specifier/Designer' && selectTwo === '10,000 sqft or less') {
    $('.results-images-kanopi').show();
    $('.results-kanopi').hide();
    $('.results-kanopi-contractor').hide();
  } else if (selectOne === 'General or Sub Contractor' && selectTwo === 'over 10,000 sqft') {
    $('.results-images-kanopi').hide();
    $('.results-kanopi').hide();
    $('.results-kanopi-contractor').show();
  } else {
    $('.results-images-kanopi').hide();
    $('.results-kanopi').show();
    $('.results-kanopi-contractor').hide();
  }
}


$(document).ready(function () {
  $('.results-kanopi').hide();
  $('.results-kanopi-contractor').hide();
  $('.btn-submit').on('click', function () {
    var selectOne = $('select.select-roles').val();
    var selectTwo = $('select.select-project').val();
    setSelectElement(selectOne, selectTwo);
    $('.container-component').hide();
  });
  $('.return-link').on('click', function () {
    $('.container-component').show();
    $('.results-images-kanopi').hide();
    $('.results-kanopi').hide();
    $('.results-kanopi-contractor').hide();
  });
  $('.icon-unselect:first-child').each(function () {
    $("#width_tmp_option").html($('option:selected', this).text());
    $(this).width($("#width_tmp_select").width());
  });
  var selectOption = $(".icon-unselect").val();
  $(".icon-unselect").on({
    "change": function () {
      $(this).blur();
      $("#width_tmp_option").html($('option:selected', this).text());
      $(this).width($("#width_tmp_select").width());
    },
    'focus': function () {
      $(this).parent().find('i').addClass('select-active');
    },
    "blur": function () {
      $(this).parent().find('i').removeClass('select-active');
    },
    "keyup": function (e) {
      if (e.keyCode == 27)
        $(this).parent().find('i').addClass('select-active');
    },
    "click": function () {
      if ($(this).val() === selectOption) {
        $(this).parent().find('i').removeClass('select-active');
      } else {
        selectOption = $(this).val();
      }
    }
  });
  var timeSelectShow = 2000;
  setTimeout(function () {
    var $dropDownElement = $('.dropdown-toggle');
    $dropDownElement.click(
      function () {
        $(this).toggleClass('select-active');
      });
    $('.selectpicker').change(
      function () {
        $dropDownElement.removeClass('select-active');
      });
    $dropDownElement.focusout(
      function () {
        $(this).removeClass('select-active');
      });
  }, timeSelectShow);

  if($(".parent-grid-system-container").length && $('.template-cart').length && $(".parent-grid-system-container.horizontal-slider").overflown() ){
    $('.pdpCompatibleGridSystems .c-g-system .parent-grid-system-container .arrow').show();
  };

  
  $('.tw-ctLink').hover(function(){
    $(this).find('i').fadeToggle(0);
   // $(this).toggleClass('jshoverLink');
    $(this).find('span').fadeToggle(0);
    });


});
function checkProductCardsSurcharge() {
  const productCards = $('.product-card-surcharge-info');
  if(typeof kanopiSurcharge === 'undefined' || !kanopiSurcharge._isSurchargeZone() || productCards.length === 0) return;
  productCards.each(function() {
    const input = $(this);
    const hasSurcharge = input.attr('data-surcharge');
    const productSurcharge = input.attr('data-product-surcharge');
    const surchargeData = input.val();
    const surcharge = kanopiSurcharge._getProductSurchargeAmount({has_surcharge: `${hasSurcharge}`, product_surcharge: `${productSurcharge}`, surcharge: `${surchargeData}`});
    if(surcharge !== '0') {
      const isPopular = input.attr('data-popular');
      const hidePricePerUOM = input.attr('data-hidePricePerUOM');
      const price = input.attr('data-price');
      const sqft = input.attr('data-sqft');
      const variantUrl = input.attr('data-url');
      const id = input.attr('data-id');
      const product_id = input.attr('data-pid');
      const finalPrice =  kanopiSurcharge._getSurchargePriceHelper(price, surcharge);
      const finalSqft =  kanopiSurcharge._getSurchargePriceHelper(sqft, surcharge);
      const sqftHtml = $(`.popular-price-${id} .price_per_sqft`);
      const priceHtml = $(`.popular-price-${id} .final-price`);
      const compare_info = $(`.compare-button span[item-id="${product_id}"]`).data("obj");
      const discountedPrice = input.attr('discounted-price');
      const discountedSqft = input.attr('discounted-sqft');
      const zipsetValue = kanopiSurcharge._getSurchargeLs();
      const numericPartMatch = zipsetValue.match(/\d+/);
      const numericPart = numericPartMatch ? numericPartMatch[0] : '';
      const regionId = `region_${numericPart}`;
      const updatedVariantUrl = regionId ? `${variantUrl}?region_id=${regionId}` : variantUrl;

      if(isPopular === 'true') {
        $(`.popular-price-${id}`)?.parent()?.parent()?.parent()?.find('.popular-product-url').attr('href', updatedVariantUrl);
        $(`.popular-price-${id}`)?.parent()?.parent()?.parent()?.find('.popular-product-title a').attr('href', updatedVariantUrl);
       
      } else {
        $(`.popular-price-${id}`)?.parent()?.parent()?.parent()?.find('.tw-product-title').attr('href', updatedVariantUrl);
        $(`.popular-price-${id}`)?.parent()?.parent()?.parent()?.parent()?.find('.grid-view-item__link').attr('href', updatedVariantUrl);
      }

      if(finalPrice && priceHtml.length) priceHtml.html(finalPrice);
      if(finalSqft && sqftHtml.length) sqftHtml.html(finalSqft);
      if(sqft == 0 &&  sqftHtml.length) sqftHtml.html(finalPrice);
      
      //check discounts and insert RPA
      if(discountedPrice != 'false' && discountedSqft != 'false' ) {
        const regLinearPrice = $(input).parent().find('.product-price__tilesqft_reg');
        const regPrice = $(input).parent().find('.originalPriceRegular');
        const DiscountedPrice = $(input).parent().find('.tw-sale-price .card-price');
        const linearDiscountedPriceLinear = $(input).parent().find('.tw-sale-price .price_per_sqft');
      
        const priceRpa = finalPrice;
        const priceSqfRpa = finalSqft;
        const priceRpaDiscount = kanopiSurcharge._getSurchargePriceHelper(discountedPrice, surcharge);
        const priceSqftRpaDiscount = kanopiSurcharge._getSurchargePriceHelper(discountedSqft, surcharge);

        $(regLinearPrice).html(priceSqfRpa);
        if(hidePricePerUOM !== "true") {
          $(regPrice).html('('+priceRpa);
          $(DiscountedPrice).html('('+priceRpaDiscount+' /carton)');
        }else {
          $(regPrice).html(priceRpa);
          $(DiscountedPrice).html(`<span class='h3'>${priceRpaDiscount}</span> /carton`);
        }
        $(linearDiscountedPriceLinear).html(priceSqftRpaDiscount);
        
      }
      //Modify data-obj to add RPA to compare.
      if ($('body').hasClass('template-collection') && typeof compare_info !== 'undefined'){
        compare_info.price = sqft == 0 ? finalPrice : finalSqft;
        
        $(`.compare-button span[item-id="${product_id}"]`).data("obj",compare_info);
      }
    }
  });
}
function displayVolDiscountMsg (display) {
  const volDscWrapper = $('.volume_promotion_msg.vol-pdp');
  if(display) {    
    volDscWrapper.addClass('active');
  }else {
    volDscWrapper.removeClass('active');
  }
}
function displaySaleFlagOnPDP(display) {
  if (display) {
    $('.tw-kanopi-product .ribbon').addClass('tw-discount-ribbon has-flag tw-inline-block');
    $('.tw-kanopi-product .prod-large-img').addClass('has-flag');
    $('.tw-kanopi-product .ribbon').removeClass('tw-hidden');
  } else {
    if($('.tw-kanopi-product .ribbon.tw-discount-ribbon').length) {
      $('.tw-kanopi-product .ribbon').removeClass('tw-discount-ribbon has-flag tw-inline-block');
      $('.tw-kanopi-product .prod-large-img').removeClass('has-flag');
      $('.tw-kanopi-product .ribbon').addClass('tw-hidden');
    }
  }

}
function checkComparePopularProductsSurcharge() {
    const productCards = $('.jsPopularCardCompare');
  if(typeof kanopiSurcharge === 'undefined' || !kanopiSurcharge._isSurchargeZone() || productCards.length === 0) return;
  productCards.each(function() {
    const input = $(this);
    const hasSurcharge = input.attr('data-surcharge');
    const productSurcharge = input.attr('data-product-surcharge');
    const surchargeData = input.attr('srg-value');
    const surcharge = kanopiSurcharge._getProductSurchargeAmount({has_surcharge: `${hasSurcharge}`, product_surcharge: `${productSurcharge}`, surcharge: `${surchargeData}`});    
    if(surcharge !== '0') {
      const price = input.attr('variant-price');      
      const sqft = input.attr('variant-sqft');
      let pricePerSqft = price / sqft;
      const id = input.attr('card-id');
      const discountPrice = input.attr('discount-price');
      if (discountPrice?.length > 0 ){
        pricePerSqft = discountPrice * 100;
      }
      const finalSqft =  kanopiSurcharge._getSurchargePriceHelper(pricePerSqft, surcharge);   
      $(`.jsPopularCardCompare[card-id="${id}"]`).find('.js-price-rpa').each(function() { $(this).html(finalSqft); });
    }
  });
 
}
$(document).on("ready", function(){
  checkProductCardsSurcharge();  
});

$(window).on('load', function() { //detect when popular component is visible
   function onElementVisible() {
    checkComparePopularProductsSurcharge();
  }

  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        onElementVisible();
        observer.disconnect();
      }
    });
  });

  var elements = document.querySelector('.jsPopularCardCompare');

  if (elements) {
    observer.observe(elements);
  }
});

$(document).on("ready", function() {
  waitForElm('.patternModalZoom .zoomImg').then(function (){
    setTimeout(function(){
      removeZoomForSmallImg();
    },3000)
  })
});

function removeZoomForSmallImg(){
    $('.patternModalZoom').each(function(){
    let $mainImg = $(this).find('.main-img')
    let $zoomImg = $(this).find('.zoomImg');
    let mainImgWidth = $mainImg.width();
    let zoomImgWidth = $zoomImg.width();
    if (zoomImgWidth < (mainImgWidth + 100)){
      $zoomImg.addClass("tw-hidden removed");
    }
  });   
}
function capitalize(string) {
  let capitalize = string.toLowerCase();
  let firstLetter = capitalize[0].toUpperCase();
  capitalize = capitalize.slice(1);
  capitalize = firstLetter + capitalize;
  return capitalize;
}

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

async function showLocationForm() {
  const $locationForm =  $('#kanopi-location-form');
  if($locationForm.length > 0) {
    let countryCode = await checkLocationByIP();
    if (countryCode === 'US') {
      let isLocationSet = localStorage.getItem('locationFormSet');
      if (!isLocationSet)
        $locationForm.removeClass('tw-hidden');
    }
  }
}

async function  checkLocationByIP() {
  let resExpired = await getZipByIpExpired(true);
  return resExpired.country_code;
}

$(document).on("ready", function() {
  waitForElm('.patternModalZoom .zoomImg').then(function (){
    setTimeout(function(){
      removeZoomForSmallImg();
    },3000)
  })
  setTimeout(function() {
    CheckGridSampleInCart() },500);
});

function removeZoomForSmallImg() {
    $('.patternModalZoom').each(function() {
    let $mainImg = $(this).find('.main-img')
    let $zoomImg = $(this).find('.zoomImg');
    let mainImgWidth = $mainImg.width();
    let zoomImgWidth = $zoomImg.width();
    if (zoomImgWidth < (mainImgWidth + 100)) {
      $zoomImg.addClass("tw-hidden removed");
    }
  });
}

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}
const hideCartExpress = ()=> {
  waitForElm('.shopify-cleanslate').then(() => {
    const googleBtn = $('.shopify-cleanslate li:contains(GooglePay)');
    const appleBtn = $('.shopify-cleanslate li:contains(Apple)');
    const shopPayBtn = $('.shopify-cleanslate li:contains(ShopPay)');
    if(typeof kanopiSurcharge !== 'undefined' && kanopiSurcharge._isSurchargeZone()){
      shopPayBtn.addClass('tw-hidden');
      if(kanopiSurcharge._isLowcharge()) {
        googleBtn.addClass('tw-hidden');
        appleBtn.addClass('tw-hidden');
      } else {
        googleBtn.removeClass('tw-hidden');
        appleBtn.removeClass('tw-hidden');
      }
    } else {
      shopPayBtn.removeClass('tw-hidden');
      googleBtn.removeClass('tw-hidden');
      appleBtn.removeClass('tw-hidden');
    }
  });
}
/** Customize persistent cart app content **/
$(document).on("ready", function () {
  const hasMultipleRows = (id) => {
    const table = $(`${id}`);
    if(table.length > 0) {
      const rows = table.find('tbody tr');
      if(rows.length > 1) table.addClass('multi-rows');
      if(rows.length > 0) {
        const lastIndex = rows.length - 1;
        const lastTr = $(rows[lastIndex]);
        lastTr.addClass('last-row');
      }
    }
  }
  hideCartExpress();

  waitForElm('#cffPCConflictModalTitle').then((elm) => {
    let conflictTitleHtml = $('#cffPCConflictModalTitle' ).html();
    conflictTitleHtml = conflictTitleHtml.replace(/%user-name%/ig,capitalize(customerData?.firstName));
    $('#cffPCConflictModalTitle').html(conflictTitleHtml);
    hasMultipleRows('#cffPCFoundCartConflictModalTable');
    hasMultipleRows('#cffPCCurrentCartConflictModalTable');
    let itemCountFoundCart = $("#cffPCFoundCartCartTableMainBody").children().length;
    let itemCountCurrentCart = $("#cffPCCurrentCartTableMainBody").children().length;
    let itemLabelFoundCart = itemCountFoundCart > 1 ? "items" : "item";
    let itemLabelCurrentCart = itemCountCurrentCart > 1 ? "items" : "item";
    let titleFoundCart = $('#cffPCFoundCartTitle').html();
    let titleCurrentCart = $('#cffPCCurrentCartTitle').html()
    titleFoundCart = titleFoundCart.replace(":"," ") + "(" + itemCountFoundCart + " " + itemLabelFoundCart + "):";
    titleCurrentCart = titleCurrentCart.replace(":"," ") + "(" + itemCountCurrentCart + " " + itemLabelCurrentCart + "):";
    if (itemCountFoundCart > 0) {
      $('#cartItemsDetectedModal tr:contains("Regional Pricing Adjustment")').addClass('tw-hidden');
      $('#cartItemsDetectedModal').toggleClass("opened");
      $('html').addClass('persistent-modal-open');
    }
    $('#cffPCFoundCartTitle').html(titleFoundCart);
    $('#cffPCCurrentCartTitle').html(titleCurrentCart);
    $('#cffPCFoundCartTitle').on("click", function () {
      $(this).toggleClass("expanded");
      $("#cffPCFoundCartConflictModalTable").toggleClass("active");
    } );
    $('#cffPCCurrentCartTitle').on("click", function () {
      $(this).toggleClass("expanded");
      $("#cffPCCurrentCartConflictModalTable").toggleClass("active");
    } );

    if(itemCountFoundCart === 1 && itemCountCurrentCart === 1){
      $('#cffPCFoundCartTitle').click();
      $('#cffPCCurrentCartTitle').click();
    }

    $('#cartItemsDetectedModal .close').on("click", function () {
      $('#cartItemsDetectedModal').toggleClass("opened");
      $('html').removeClass('persistent-modal-open');
     });
    $("#cartItemsDetectedModal").click(function(e) {
      if (e.target == this) {
          $(this).toggleClass('opened');
          $('html').removeClass('persistent-modal-open');
      }
   });
  });
});

/** Quick overflow check for compatible grid systems **/
$.fn.overflown=function(){var e=this[0];return e.scrollHeight>e.clientHeight||e.scrollWidth>e.clientWidth;}
function isElementVisibleHorizontally(element,$container) {
  try{
    var $element = $(element);
    var containerLeft = $container.scrollLeft();
    var containerRight = containerLeft + $container.width();
    var elementLeft = $element.offset().left - $container.offset().left + containerLeft;
    var elementRight = elementLeft + $element.outerWidth();
    return (elementLeft < containerRight && elementRight > containerLeft);
  }catch(error){
    return true;
  }
}
function CheckGridSampleInCart () {
  const gridItems = $('.compatible-grid-sample-block');
  const cartItems = CartJS?.cart?.items;
  if(typeof cartItems === 'undefined' || cartItems.length === 0 || gridItems.length === 0) return;
  cartItems.map(item => {
    const compatibleItem = $(`.grid-sample-added-${item.id}`);
    if(compatibleItem.length > 0) {
      compatibleItem.toggleClass("tw-hidden");
      $('.grid-sample-before-add').toggleClass("tw-hidden");
    }
  });
}


$(document).on('click', '.mini-products-list .cart-item .remove', function () {
  CheckGridSampleInCart();
});
function labelWidth(force = 0){
    $( ".upsell-product-card .ribbon .normal_v" ).each(function( index ) {
      let imagewidth = $(this).parents('.image-ribbon').outerWidth();
      let allocate = $(this).parents('.ribbon').outerWidth();
      if( ( !$(this).hasClass('done') || force) && imagewidth < allocate){
        let wid = parseInt($(this).width()) + 18 ;
        if($(this).parents('.product_with_discount').length == 0){
          $(this).parents('.ribbon').css('width',wid+'px');
          $(this).addClass('done')
        }
      }
    });
}
$(document).on("ready", function() {
  labelWidth();
});
$(window).on('resize', function() {
  labelWidth(force = 1);
});

// Sample bundle collection loader issue for the mobile view //
function onPageChange() {
  document.body.classList.remove("loading", "showOverlay");
}
if (window.history && window.history.pushState) {
  window.addEventListener('popstate', onPageChange);
}


function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// klaviyo subscription
function preventDefault(e) {
  e.preventDefault();
}

function disableScroll() {
  document.body.addEventListener('touchmove', preventDefault, { passive: false });
}
function enableScroll() {
  document.body.removeEventListener('touchmove', preventDefault);
}

KlaviyoSubscribe.attachToForms('#subscribe', {
  hide_form_on_success: false
});

// == Modal Validations ===

// Validation Checkboxes

$('.klaviyo_field_group')
  .find('input')
  .click(function () {
    if ($(this).prop('checked')) {
      $(this).parent().find('.checkmark').css('border', '1.5px solid #f86b16');
    } else {
      $(this).parent().find('.checkmark').css('border', '1.5px solid #5e7183');
    }
    if (checkboxesValidation() == true) {
      $('.nooptions_message').hide();
      $('.options_message').show();
    } else {
      $('.nooptions_message').show();
      $('.options_message').hide();
    }
  });
function checkboxesValidation() {
  var inputs = $('.checkmark');
  var inputFlag = false;
  inputs.each(function () {
    if ($(this).parent().find('input').prop('checked')) {
      inputFlag = true;
    }
  });
  if (inputFlag) {
    return true;
  } else {
    return false;
  }
}

//Close modal
function close_modal() {
  $('#k_id_modal').css('display', 'none');
  $('body').css('overflow', 'visible');
  enableScroll();
}
//END  == Modal Validations ==

//hidden tooltip when write
$('.input_email_k input').on('input', function () {
  setError_Msg(false);
  setNotification_Msg(false);
});

//setError Message
function setError_Msg(val) {
  if (val) {
    $('.input_email_k input').css('border', '1px solid #b10813');
    $('.tooltip_validation').css('visibility', 'visible');
  } else {
    $('.input_email_k input').css('border', '1px solid #ddd');
    $('.tooltip_validation').css('visibility', 'hidden');
  }
}
function setNotification_Msg(val) {
  if (val) {
    $('.tooltip_notification').css('visibility', 'visible');
  } else {
    $('.tooltip_notification').css('visibility', 'hidden');
  }
}
function validateEmail(value = "") {
  if(value == ""){
    value = $('.input_email_k input').val();
  }
  emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
  if (emailRegex.test(value)) {
    return true;
  } else {
    return false;
  }
}
function submit_Form() {
  if (validateEmail()) {
    window.Northbeam.identify("email", $('.input_email_k input').val())
    $('#subscribe').ajaxForm({
      url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      dataType: 'json',
      success: function (response) {
        if (response.data.is_subscribed == false) {
          //setEmail in the hidden field
          $('#k_id_modal_email').val($('.input_email_k input').val());
          //open modal
          $('#subscribe').hide();
          $('.success_message_k').show();
          $('body').css('overflow', 'hidden');
          disableScroll();
          KlaviyoSubscribe.attachToModalForm('#k_id_modal', {
            list: 'V4EyBu',
            delay_seconds: 1,
            hide_form_on_success: false,
            ignore_cookie: true,
            success_message: false,
            extra_fields: [
              'Creating healthier spaces',
              'Reducing noise',
              'Replacing a few tiles',
              'Ceilings for your business',
              'Ceilings for your home',
              'Role'
            ]
          });
        } else {
          //notification Message
          if (validateEmail()) {
            setNotification_Msg(true);
          }
        }
      }
    });
  } else {
    setError_Msg(true);
  }
}
var x, i, j, l, ll, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName('custom-select');
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName('select')[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement('DIV');
  a.setAttribute('class', 'select-selected');
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement('DIV');
  b.setAttribute('class', 'select-items select-hide');
  for (j = 1; j < ll; j++) {
    /*for each option in the original select element,
  create a new DIV that will act as an option item:*/
    c = document.createElement('DIV');
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener('click', function (e) {
      /*when an item is clicked, update the original select box,
    and the selected item:*/
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName('select')[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName('same-as-selected');
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute('class');
          }
          this.setAttribute('class', 'same-as-selected');
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener('click', function (e) {
    /*when the select box is clicked, close any other select boxes,
  and open/close the current select box:*/
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle('select-hide');
    this.classList.toggle('select-arrow-active');
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
except the current select box:*/
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName('select-items');
  y = document.getElementsByClassName('select-selected');
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove('select-arrow-active');
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide');
    }
  }
}
// Global function that will return the youtube video's Video ID from URL
function youtube_parser(url){
  var regExp = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  var match = url.match(regExp);
  return (match&&match[1].length==11)? match[1] : false;
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener('click', closeAllSelect);
$('.select-items div').click(function () {
  $('.k_form_actions button').removeAttr('disabled');
});
// END klaviyo subscription
// this script will handle the video player on PDP 

/* Quick Order Functionality Start */
function refreshQuickOrder(){
  $('.quick-order-add-to-cart').attr('disabled',true);
  var totalCount = 0;
  var sectionClass="";
  var rowHtml = "";
  if(window?.isQuickOrderLanding){
    sectionClass = ".quick-order-landing ";
    totalCount = window.quickOrderLandingDefault;
    rowHtml = $("#quick-order-sample").text();
  }else{
    rowHtml = $("#dropdown-quick-order-sample").text();
    sectionClass = ".quick-order-header ";
    totalCount = window.quickOrderDropDownDefault;
    $(`${sectionClass} .dynamic_quick_row`).html('');
  }
  $(".quick-order-landing .dynamic_quick_row").html('');
  for (let i = 1; i <= totalCount;i++){
    if(localStorage.getItem(`QuickOrderData${i}`) != ""){
      var data = JSON.parse(localStorage.getItem(`QuickOrderData${i}`));
    }else{
      var data = {};
    }
    if(data?.finder && data?.quantity && data?.variantData && data?.variantid){
      var current_pro_obj = $(rowHtml);
      current_pro_obj.attr('data-index',i);
      current_pro_obj.find('.product-finder-input').val(data.finder);
      current_pro_obj.find('.quick-product-qty').val(data.quantity);
      current_pro_obj.find('.variant_input_hidden').val(data.variantid);
      current_pro_obj.find('.quickProductJson').text(JSON.stringify(data.variantData));
      var item_obj = data?.variantData.variants;
      
      if(item_obj.length > 1){
        // with multiple colors
        let option_html = $('#quick-dropdown-option').text();
        item_obj.forEach(function (value, i) {
          if(value.id == data?.variantid){
            let color_swatch_class = 'current_color swt'+(item_obj[i].color.toLowerCase().replaceAll(' ','-'));
            current_pro_obj.find('.color-dropdown-component .dropdown-toggle').find('.current_color').removeAttr('class').addClass(color_swatch_class);
            current_pro_obj.find('.color-dropdown-component .dropdown-toggle').find('.slVariant').html(item_obj[i].color);
          }
          Shopify.productMeta[value.id] = value;
          let option_obj = $(option_html);
          let color_swatch_class = 'current_color swt'+(value.color.toLowerCase().replaceAll(' ','-'));
          option_obj.find('.quick-input-swatch').attr('data-swt-class',color_swatch_class);
          option_obj.find('.quick-input-swatch').attr('data-color',value.color);
          option_obj.find('.quick-input-swatch').attr('data-variant-id',value.id);
          option_obj.find('.swatch_variant_name').html(value.color);
          option_obj.find('.swatchLbl').addClass(color_swatch_class);
          if( i == 0){
            option_obj.find('dropdown-item').addClass('checked');
          }
          current_pro_obj.find('.dropdown-menu-color').append(option_obj);
        });
        current_pro_obj.find('.color-dropdown-component').removeClass('tw-hidden');
        current_pro_obj.find('.blank-input-component').addClass('tw-hidden');
        current_pro_obj.find('.color-input-component').addClass('tw-hidden');
      }else{
        let color_name = ( item_obj[0].color == "" ? "White": item_obj[0].color);
        let color_swatch_class = 'current_color swt'+(color_name.toLowerCase().replaceAll(' ','-'));
        // with only single color
        Shopify.productMeta[item_obj[0].id] = item_obj[0];
        current_pro_obj.find('.color-dropdown-component').addClass('tw-hidden');
        current_pro_obj.find('.blank-input-component').addClass('tw-hidden');
        current_pro_obj.find('.color-input-component').find('.current_color').removeAttr('class').addClass(color_swatch_class);
        current_pro_obj.find('.color-input-component').find('.slVariant').html(color_name);
        current_pro_obj.find('.color-input-component').removeClass('tw-hidden');
      }
      $(`${sectionClass} .dynamic_quick_row`).append($(current_pro_obj));
    }else{
      var current_pro_obj = $(rowHtml);
      current_pro_obj.attr('data-index',i);
      $(`${sectionClass} .dynamic_quick_row`).append($(current_pro_obj));
    }
  }
  var validrows = 0;
  $("input[name='variantid[]']").map(function(){ validrows = $(this).val() != "" ? validrows+1 : validrows;return $(this).val();}).get();
  if(validrows > 0){
    $('.quick-order-add-to-cart').removeAttr('disabled');
  }else{
    $('.quick-order-add-to-cart').attr('disabled',true);
  }
  if(window?.isQuickOrderLanding){
    for (let i = 1; i <= totalCount;i++){
      localStorage.removeItem(`QuickOrderData${i}`)
    }
  }
}
function storeQuickData(){
  // var storeData = [];
  var index = 1;
  $(".dropdown-menu .dynamic_quick_row .single-product-row").each(function() {
    var currentData = {};
    if($(this).find('.variant_input_hidden').val() != ""){
      currentData.variantData = JSON.parse($(this).find('.quickProductJson').text());
      currentData.variantid = $(this).find('.variant_input_hidden').val();
      currentData.quantity = $(this).find('.quick-product-qty').val();
      currentData.finder = $(this).find('.product-finder-input').val().toUpperCase();
    }
    // storeData.push(currentData);
    localStorage.setItem(`QuickOrderData${index}`, JSON.stringify(currentData));
    index+=1;
  });
}
$(document).ready(function() {
  if(window?.isQuickOrderLanding){
    $('.quick-order-header').addClass('inactive');
  }
  if($.cookie("quickOrderJson")){
    // read the data and load it 
  }else{
    refreshQuickOrder();
  }
  var buttonOffset;
  if (window.isQuickOrderLanding) {
    var $button = $('.quick-add-cart-button1');
  
    // Debounce function to limit how often the scroll handler is called
    function debounce(func, wait) {
      var timeout;
      return function() {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
      };
    }
    
    if ($button.length) {
      buttonOffset = $button.offset().top;
  
      // Function to handle the scroll logic
      function handleScroll() {
        var scrollPosition = $(window).scrollTop() + $(window).height();
        
        // Add the class if the button is out of the viewport
        if (scrollPosition < buttonOffset) {
          $button.addClass('sticky-quick-addcart');
        } else {
          $button.removeClass('sticky-quick-addcart');
        }
      }
  
      // Call handleScroll when scroll happens, with debounce for better performance
      $(window).on('scroll', debounce(handleScroll, 20));
  
      // Trigger the function immediately in case the user has already scrolled
      handleScroll();
    }
  }

	$(document).on('click','.dynamic-add-quick-row',function(){
    $(".dynamic_quick_row").append($("#quick-order-sample").text());
	});
	$(document).on('keyup change','.product-finder-input',async function(event){
    var currentValue = $(this).val();
    var currentIndex = $(this).parents('.single-product-row').attr('data-index');
    var controllervar = "fetchController"+currentIndex 
    if(window[controllervar]){
      window[controllervar].abort('decline old call');
    }
    window[controllervar] = new AbortController();
    var current_pro_obj = $(this).parents('.single-product-row');
    var material_sku = "";
    if(currentValue.length > 2){
      material_sku = $(this).val().toUpperCase();
    }
    
    current_pro_obj.find('.quick-product-qty').val(1);
    if(material_sku != ""){
      var data = await fetch(`/collections/quick-order?filter.v.m.custom.material_id=${material_sku}&view=quick-order-json`,{
                    signal: window[controllervar].signal
                  })
              .then(res => res.json())
              .then(resJson => {
                return resJson;
              });
      if(data.status == 404){
        data = await fetch(`/collections/quick-order?filter.v.m.custom.sku=${material_sku}&view=quick-order-json`,{
          signal: window[controllervar].signal
        })
                .then(res => res.json())
                .then(resJson => {
                  return resJson;
                });
      }
      if(data.status == 200){
        // if found then remove error message 
        current_pro_obj.find('.quick-error').addClass('tw-hidden');
        current_pro_obj.find('.product-finder-input').removeClass('input--error');
      }else{
        // if not then reset everything, disabled button and show error 
        current_pro_obj.find('.variant_input_hidden').val('');
        current_pro_obj.find('.quickProductJson').html('');
        current_pro_obj.find('.quick-error').removeClass('tw-hidden');
        current_pro_obj.find('.quick-error').html(data.message);
        current_pro_obj.find('.product-finder-input').addClass('input--error');
        current_pro_obj.find('.blank-input-component').removeClass('tw-hidden');
        current_pro_obj.find('.color-input-component').addClass('tw-hidden');
        current_pro_obj.find('.color-dropdown-component').addClass('tw-hidden');
      }
      current_pro_obj.find('.color-dropdown-component .dropdown-menu-color').html('');
      if(data.status == 200){
        var item_obj = data.variants;

        if(item_obj.length > 1){
          let color_swatch_class = 'current_color swt'+(item_obj[0].color.toLowerCase().replaceAll(' ','-'));
          // with multiple colors
          current_pro_obj.find('.color-dropdown-component .dropdown-toggle').find('.current_color').removeAttr('class').addClass(color_swatch_class);
          current_pro_obj.find('.color-dropdown-component .dropdown-toggle').find('.slVariant').html(item_obj[0].color);
          let option_html = $('#quick-dropdown-option').text();
          item_obj.forEach(function (value, i) {
            Shopify.productMeta[value.id] = value;
            let option_obj = $(option_html);
            let color_swatch_class = 'current_color swt'+(value.color.toLowerCase().replaceAll(' ','-'));
            option_obj.find('.quick-input-swatch').attr('data-swt-class',color_swatch_class);
            option_obj.find('.quick-input-swatch').attr('data-color',value.color);
            option_obj.find('.quick-input-swatch').attr('data-variant-id',value.id);
            option_obj.find('.swatch_variant_name').html(value.color);
            option_obj.find('.swatchLbl').addClass(color_swatch_class);
            if( i == 0){
              option_obj.find('dropdown-item').addClass('checked');
            }
            current_pro_obj.find('.dropdown-menu-color').append(option_obj);
          });
          current_pro_obj.find('.color-dropdown-component').removeClass('tw-hidden');
          current_pro_obj.find('.blank-input-component').addClass('tw-hidden');
          current_pro_obj.find('.color-input-component').addClass('tw-hidden');
        }else{
          let color_name = ( item_obj[0].color == "" ? "White": item_obj[0].color);
          let color_swatch_class = 'current_color swt'+(color_name.toLowerCase().replaceAll(' ','-'));
          // with only single color
          Shopify.productMeta[item_obj[0].id] = item_obj[0];
          current_pro_obj.find('.color-dropdown-component').addClass('tw-hidden');
          current_pro_obj.find('.blank-input-component').addClass('tw-hidden');
          current_pro_obj.find('.color-input-component').find('.current_color').removeAttr('class').addClass(color_swatch_class);
          current_pro_obj.find('.color-input-component').find('.slVariant').html(color_name);
          current_pro_obj.find('.color-input-component').removeClass('tw-hidden');
        }
        current_pro_obj.find('.quickProductJson').html(JSON.stringify(data));
        current_pro_obj.find('.variant_input_hidden').val(item_obj[0].id);
      }
    }else{
      current_pro_obj.find('.variant_input_hidden').val('');
      current_pro_obj.find('.product-finder-input').removeClass('input--error');
      current_pro_obj.find('.quick-error').addClass('tw-hidden');
      current_pro_obj.find('.blank-input-component').removeClass('tw-hidden');
      current_pro_obj.find('.color-input-component').addClass('tw-hidden');
      current_pro_obj.find('.color-dropdown-component').addClass('tw-hidden');
    }
    if(window?.isQuickOrderLanding){
      // Quick order landing page 
    }else{
      // Quick order Dropdown
      storeQuickData();
    }
    var validrows = 0;
    $("input[name='variantid[]']").map(function(){ validrows = $(this).val() != "" ? validrows+1 : validrows;return $(this).val();}).get();
    var errorcount = $('.quick-error:not(.tw-hidden)').length;
    if(validrows > 0 && errorcount == 0){
      $('.quick-order-add-to-cart').removeAttr('disabled');
    }else{
      $('.quick-order-add-to-cart').attr('disabled',true);
    }
	})
  $(document).on('change','.quick-product-qty', function(e) {
    if($(this).val() == 0 || $(this).val().trim() == "" ){
      $(this).val(1);
    }
    if(window?.isQuickOrderLanding){
      // Quick order landing page 
    }else{
      // Quick order Dropdown
      storeQuickData();
    }
  });
  $(document).on('keyup keypress','.quick-product-qty', function(e) {
    const keyArray = [];
    const currentKey = e.which;
    for (i = 48; i < 58; i++)
      keyArray.push(i);
    if (!(keyArray.indexOf(currentKey)>=0))
        e.preventDefault();
  });
  $(document).on('click','.quick-input-swatch',function(){
    let newColorClass = $(this).attr('data-swt-class');
    let newColor = $(this).attr('data-color');
    let newVariantID = $(this).attr('data-variant-id');
    let current_pro_obj = $(this).parents('.color-dropdown-component');
    current_pro_obj.find('.dropdown-toggle .current_color').removeAttr('class').addClass(newColorClass);
    current_pro_obj.find('.dropdown-toggle .slVariant').html(newColor);
    $(this).parents('.single-product-row').find('.variant_input_hidden').val(newVariantID);
    if(window?.isQuickOrderLanding){
      // Quick order landing page 
    }else{
      // Quick order Dropdown
      storeQuickData();
    }
  })
  $(document).on('click','.quick-order-add-to-cart',async function(){
    var mainSection = $(this).parents('.quick-order-section');
    var variantsids = mainSection.find("input[name='variantid[]']").map(function(){ return $(this).val();}).get();
    var quantityIds = mainSection.find("input.quick-product-qty").map(function(){ return $(this).val();}).get();
    var itemsToAdd = [];
    if(window.isCartPage){
      $('body').addClass('loading');
    }else{
      showOverly(true);
    }
    $('.quick-order-landing .quick-order-add-to-cart').addClass('active');
    variantsids.forEach(function (value, i) {
      if(value != ""){
        let metafields = Shopify.productMeta[value];
        let qnt = quantityIds[i];
        var props = {};
        props['Item #'] = metafields.sku;
        props['_shipping_time'] = metafields.mfgProcess;
        props = setDiscountProperties(metafields, props, value);
        itemsToAdd.push({id: value, quantity: qnt, properties: props});
      }
    });
    await CartJS.addItems(itemsToAdd);
    var totalCount = 0;
    if(window?.isQuickOrderLanding){
      totalCount = window.quickOrderLandingDefault;
    }else{
      totalCount = window.quickOrderDropDownDefault;
    }
    for (let i = 1; i <= totalCount;i++){
      localStorage.removeItem(`QuickOrderData${i}`)
    }
    setTimeout(function() {
      for (let i = 1; i <= totalCount;i++){
        localStorage.removeItem(`QuickOrderData${i}`)
      }
      $('.quick-order-landing .quick-order-add-to-cart').removeClass('active');
      refreshQuickOrder();
      if(window.isCartPage){
        showOverly(false);
        if($('.empty-page-content').length){
          location.reload();
        }
      }
    }, 3500);
  })
  $(document).on('mouseenter', '.quick-order-header', function(e) {
      $(this).addClass('active')
  });
  $(document).on('mouseleave', '.quick-order-header', function(e) {
    if(!$(".quick-order-header *").is(":focus")){
      $(this).removeClass('active');
    }
  });
  $(document).on('click', function(e) {
    if (!$(e.target).parents('.quick-order-header').length && !$(e.target).hasClass('quick-order-header')) {
      $('.quick-order-header').removeClass('active');
    }
  });
});
/* Quick Order Functionality End */

$(document).ready(function() {
  if(typeof hideReturnPolicy == "function" && window.isCartPage){
    hideReturnPolicy();
  }
});

// Hide express checkout in cart page when user accept the cookie yes.
function getCookie(name){
  var pattern = RegExp(name + "=.[^;]*")
  var matched = document.cookie.match(pattern)
  if(matched){
      var cookie = matched[0].split('=')
      return cookie[1]
  }
  return false
}
$(document).ready(function(){
  let cookieData = getCookie('cookieyes-consent')
  if (cookieData ){
    cookieData = getCookie('cookieyes-consent').split(',');
    let consentValue = '';
    for (const pair of cookieData) {
      if (pair.startsWith('consent:')) {
          consentValue = pair.split(':')[1];
          break;
      }
    }
    if(consentValue == 'no'){
      $('#dynamic-checkout-cart').hide();
    }
  }

// KPD-5020 WHen user click on the megamenu that time open and close that menu through click.
  var menuListData = $('#siteNav li.megamenu');
  $(document).on("click","#siteNav li .hover-style",function(event) {
    if($(this).parent('.no-overlay').length == 0){
      if (!$(this).parent('.megamenu').hasClass("hovered")) {
          menuListData.removeClass('hovered')
          $(this).parent('.megamenu').addClass('hovered');
          switchHoverMenu();
          showOverly(true, 3,150);
      }else{
          $(this).parent('.megamenu').removeClass('hovered');
          showOverly(false);
          switchHoverMenu();
      }
    }
  })
});

// Calculator updates Vice versa change.
$(document).on("change",'.qty-estimator-toggle [name="estimation-type"]',function() {
  let min_quantity = parseInt($('.product-form__input[name="quantity"]').attr('data-min')) > 0 ? parseInt($('.product-form__input[name="quantity"]').attr('data-min')) :1;
  $('.product-form__input[name="quantity"]').val(min_quantity);
  $('.product-form__input[name="quantity"]').change();
})
$(document).on("keyup keypress",'.product-form__input[name="quantity"]',function(e) {
    const keyArray = [];
    const currentKey = e.which;
    for (i = 48; i < 58; i++)
    keyArray.push(i);
    if (!(keyArray.indexOf(currentKey)>=0))
    e.preventDefault();
    if($('.pdp-container').length){
      calculatorUpdates();
    }
})
function calculatorUpdates(){
    let getCurrentQuantity = parseInt($('.product-form__input[name="quantity"]').val());
    let getCurrentVariant = $('.pdp-container').attr('data-current-variant');
    let getCurrentSqftPrice = parseFloat(Shopify.productMeta[getCurrentVariant]?.sqftPerCarton);
    let getTotalArea = getCurrentQuantity * getCurrentSqftPrice;
    let getTotalAreaWithoutBuffer = getTotalArea / 1.02;
    $(".estimation-input-list-items .estimation-input-list-item:not(:first)").remove();
    if($(".calculateTotalArea").prop('checked') == true && ($('.estimation-input-area').length > 0 && $('.estimation-input-area').val().length > 0) && getCurrentQuantity > 0){
        $('.estimation-input-area').val(Math.trunc(getTotalAreaWithoutBuffer).toLocaleString());
        $('.qty-estimator-results-txt-inner').removeClass('tw-hidden');
        $('.qty-estimator-results-txt-inner #qty-estimator-calculated-area').text(getTotalArea);
    }
    if($(".calculateLengthAndWidth").prop('checked') == true &&  ($('.estimation-input-width').length > 0 && $('.estimation-input-width').val().length > 0) && ($('.estimation-input-length').length > 0 && $('.estimation-input-length').val().length > 0) && getCurrentQuantity > 0){
        $('.estimation-input-length').val(Math.sqrt(getTotalAreaWithoutBuffer).toFixed(2));
        $('.estimation-input-width').val(Math.sqrt(getTotalAreaWithoutBuffer).toFixed(2));
        $('.qty-estimator-results-txt-inner').removeClass('tw-hidden');
        $('.qty-estimator-results-txt-inner #qty-estimator-calculated-area').text(getTotalArea)
    }
    
  }
// End Calculator updates Vice versa change

// Templok calculator start.
$(document).ready(function() {
  $(document).on("keyup",".estimation-input-area,.estimation-input-length,.estimation-input-width",function() {
    tempLokCalculation();
  })
  
  $(document).on("click",".select-dropdown__button",function() {
    $('.select-dropdown__list, .select-dropdown__button').toggleClass('active');
  });

  $(document).on("click",".select-dropdown__list-item",function() {
    var itemValue = $(this).data('value');
    $('.select-dropdown__button span').text($(this).text()).parent().attr('data-value', itemValue);
    $('.select-dropdown__list, .select-dropdown__button').toggleClass('active');
  });

  $(document).on("click", function(event) {
    if (!$(event.target).closest('.select-dropdown__button, .select-dropdown__list').length) {
      $('.select-dropdown__list, .select-dropdown__button').removeClass('active');
    }
  });

$(document).on("click",'.select-dropdown__list-item',function() {
    let totalAreaofTemplok = 0;
    let totalAreaofRegular = 0;
    totalAreaofTemplok = $(this).attr("data-value");
    totalAreaofRegular = 100 - totalAreaofTemplok;
    $('.remainingTilePercentage').html('<div class="xl:tw-hidden">Coverage: </div>'+totalAreaofRegular+'%');
    totalAreaofTemplok = totalAreaofTemplok / 100;
    totalAreaofRegular = totalAreaofRegular / 100;
    tempLokCalculation(totalAreaofTemplok,totalAreaofRegular,defaultCheckBoXChecked=false)
})

// we can hide the material estimation box when change the calculator type.
$(document).on("change",'[name="estimation-type"]',function() {
  tempLokCalculation(); 
  updateProductQuantity();
  $('.material-estimate-section').addClass('tw-hidden');
  $('.material-estimate-section').removeClass('tw-block');
})
  
// When click on theremove button we can call the function to refresh the values. 
$(document).on("click",'.estimation-input-list-item .remove-btn',function() {
  tempLokCalculation(); 
})

// On variant change we update the calculator.
$(document).on("click",".swatchInput",function(){
  setTimeout(function() {
    tempLokCalculation();
  }, 500);
})

function tempLokCalculation(totalAreaForTamplokRatio=false,totalAreaForTileRatio=false,defaultCheckBoXChecked){
  let totalAreaForTemplok = 0;
  let totalAreaForRegular = 0;
  let totalQuantityforTemplok = 0;
  let totalQuanityforRegular = 0;
  let totalPriceforTemplok = 0;
  let totalPriceforRegular = 0;
  let totalArea = 0;

  // Buffer ratio for all the calculations.
  let bufferRatio = 1.02;

  let currentVariantIdTemplok = $('.pdp-container').attr('data-current-variant');

  // Check object is blank or not.
  if (window.templokProduct && window.templokProduct[currentVariantIdTemplok] && !$.isEmptyObject(window.templokProduct[currentVariantIdTemplok])){
  let sqftForTemplok = window.templokProduct[currentVariantIdTemplok].currentVariantSqftPrice;
  let sqftForRegular = window.templokProduct[currentVariantIdTemplok].regularProductSqftPrice;

  let ratioForTemplok = window.templokProduct[currentVariantIdTemplok].templokRatio / 100;
  let ratioForRegular = 1 - ratioForTemplok;

  // Update currentprduct and regularproduct Id table
  $('#productTemplok').attr('currentVariant',currentVariantIdTemplok);
  $('#productTemplok').attr('perCartonQty',window.templokProduct[currentVariantIdTemplok].currentVariantPriceUnitsTileQty)
  $('#productTemplok').attr('perTileSqft',parseInt(window.templokProduct[currentVariantIdTemplok].currentVariantSqftPrice));
  $('#productRegular').attr('regularVariant',window.templokProduct[currentVariantIdTemplok].regularProductId);
  $('#productRegular').attr('perCartonQty',window.templokProduct[currentVariantIdTemplok].RegularProductPriceUnitsTileQty);
  $('#productRegular').attr('perTileSqft',parseInt(window.templokProduct[currentVariantIdTemplok].regularProductSqftPrice));

  // Target the <i> tags 
  const $iTags = $('.calculations-caption i strong');
  const $iTooltipTags = $('.info-cil-tooltip p i');
  
  if ($iTags.length >= 2) {
      // Update the first <i> tag
      $iTags.eq(0).text((ratioForTemplok * 100) + '%');
      $iTooltipTags.eq(0).text((ratioForTemplok * 100) + '%');
      // Update the second <i> tag 
      $iTags.eq(1).text((ratioForRegular.toFixed(1) * 100) + '%');
      $iTooltipTags.eq(1).text((ratioForRegular.toFixed(1) * 100) + '%');
  }

  // Override the default variables when someone change the value from the dropdown.
  if(totalAreaForTamplokRatio || totalAreaForTileRatio){
    ratioForTemplok = totalAreaForTamplokRatio;
    ratioForRegular = totalAreaForTileRatio;
  }

  // Calculate Total Area from all the input
  $('.estimation-input-area').each(function(){
    if($(this).val().replace(/,/g, '') > 0){
      totalArea += parseInt(totalAreaForTemplok) + parseFloat($(this).val().replace(/,/g, ''));
    }
  })

  $('.estimation-width-length').each(function(){
      if ($(this).find('.estimation-input-length').length > 0 &&  $(this).find('.estimation-input-width').length > 0 &&  parseFloat($(this).find('.estimation-input-length').val().replace(/,/g, '')) > 0 && parseFloat($(this).find('.estimation-input-width').val().replace(/,/g, '')) > 0) {
      let getLength = parseFloat($(this).find('.estimation-input-length').val().replace(/,/g, ''));
      let getWidth = parseFloat($(this).find('.estimation-input-width').val().replace(/,/g, ''));
      let getLengthWidth = getLength * getWidth;
      totalArea += getLengthWidth
    }
  })
  
  if (totalArea > 0 &&  totalArea != NaN) {
   
  // Calculate Total Area from width and length
  
  
  if(totalAreaForTamplokRatio == false && totalAreaForTileRatio == false){
    $('.bydefaultCoverage').text(window.templokProduct[currentVariantIdTemplok].templokRatio+'%');
    let remainingForRegularProduct = 100 - window.templokProduct[currentVariantIdTemplok].templokRatio;
    $('.remainingTilePercentage').html('<div class="xl:tw-hidden">Coverage: </div>'+ remainingForRegularProduct+'%')
  }
 
  // Append Coverage Ratio
  let coverageRatioForTemplok = window.templokProduct[currentVariantIdTemplok].templokCoverageRatio.split(',');
  $('.coverageDropdown ul').html(''); 
  for(var i=0;i<coverageRatioForTemplok.length;i++){
    let currentCoverageActiveClass = ''
    if(ratioForTemplok*100 == parseInt(coverageRatioForTemplok[i])){
      currentCoverageActiveClass = 'active'
    }
    const coverageHTML = '<li data-value="'+coverageRatioForTemplok[i]+'" class="'+currentCoverageActiveClass+' select-dropdown__list-item tw-block tw-text-arm-plt-col01 tw-cursor-pointer tw-list-none tw-py-[2px] tw-pr-[21px] tw-pl-[12px] tw-bg-arm-plt-col00 tw-text-[14px] tw-leading-[21px]">'+coverageRatioForTemplok[i]+'%</li>';
    $('.coverageDropdown ul').append(coverageHTML);
  }

  // Display the element if the value is not 0 or NaN
  $('.material-estimate-section').removeClass('tw-hidden');
  $('.material-estimate-section').addClass('tw-block');

  // Update total area for templok
  totalAreaForTemplok = totalArea * bufferRatio;
  totalAreaforTemplok = totalAreaForTemplok * ratioForTemplok
  totalQuantityforTemplok = Math.ceil(totalAreaforTemplok / sqftForTemplok);
  $('.totalAreaForTemplok').html('<span class="xl:tw-hidden">Qty: </span><span class="qty-width" data-qty="'+totalQuantityforTemplok+'">'+totalQuantityforTemplok+'</span>');
  $('.regularproductTitle').text(window.templokProduct[currentVariantIdTemplok].regularProductTitle)
  


  // Update total area for the regular PDP
  totalAreaForRegular = totalArea * bufferRatio;
  totalAreaForRegular = totalAreaForRegular * ratioForRegular;
  totalQuanityforRegular = Math.ceil(totalAreaForRegular / sqftForRegular);
  $('.totalAreaForRegular').html('<span class="xl:tw-hidden">Qty: </span><span class="qty-width" data-qty="'+totalQuanityforRegular+'">'+totalQuanityforRegular +'</span>');

  // Update the product Prices for templok and regular both.
  totalPriceforTemplok = totalQuantityforTemplok * parseFloat(window.templokProduct[currentVariantIdTemplok].currentVariantPrice);
  totalPriceforRegular = totalQuanityforRegular * parseFloat(window.templokProduct[currentVariantIdTemplok].regularProductPrice);
  $('.templokPrice').html('<span class="xl:tw-hidden">Total: </span><span class="qty-width">'+theme.Currency.formatMoney(totalPriceforTemplok * 100, theme.moneyFormat)+'</span>');
  $('.regularPrice').html('<span class="xl:tw-hidden">Total: </span><span class="qty-width">'+theme.Currency.formatMoney(totalPriceforRegular * 100, theme.moneyFormat)+'</span>');

  // Update the variant Id and in addtocart button.
  $('.addtocrtBtnRegularProduct').attr('data-regularVariantId',window.templokProduct[currentVariantIdTemplok].regularProductId);
  $('.addtocrtBtnRegularProduct').attr('data-templokVariantId',currentVariantIdTemplok)
  $('.addtocrtBtnRegularProduct').attr('data-quantity',totalQuanityforRegular);
  $('#templokregularvariantid').attr('value',window.templokProduct[currentVariantIdTemplok].regularProductId)

  // Update the value in quantity selector
  if(totalQuantityforTemplok > 0 && totalQuantityforTemplok != NaN){
    $('.add-to-cart--details .unit-qty').text(totalQuantityforTemplok);
    $('.product-form__input.qty.cart-qty').val(totalQuantityforTemplok);
    $('.product-form__input.qty.cart-qty').trigger('change');
    $('.qty-estimator-results-txt-inner').removeClass('tw-hidden');
    $('p.qty-estimator-area-text').html('<strong>Quantities are based a </strong><strong>'+totalAreaforTemplok.toLocaleString()+ ' sq. ft.*</strong> room size with <strong>'+ratioForTemplok*100+'% Templok coverage.</strong>')
  }

  // Checked both checkbox when anything search through calculator. 
    if(defaultCheckBoXChecked == false){
      updateAddToCartContent(false);
    } else{
      updateAddToCartContent(true);
    }
  }else{
    $('.material-estimate-section').addClass('tw-hidden');
    $('.material-estimate-section').removeClass('tw-block');
    $('button.product-form__cart-submit').removeAttr('disabled');
    $('button.product-form__cart-submit').removeClass('templokProductAddToCart');
    $('.qtyBtn').removeClass('qtytemplokProductAddToCart');
    $('.grid__item .qtyField').addClass('tw-inline-flex');
    $('.add-to-cart--buttons').removeClass('button-full-width')
    $('.grid__item .qtyField').show();
    $('.product-form__input[name="quantity"]').change();
  }
  }
} 

// Checkbox checked and unchecked class add or remove.
$(document).on('change', '#productTemplok,#productRegular', function() {
  if($(this).is(":checked")) {
    $(this).parents('tr').removeClass('selectedProduct');
    updateAddToCartContent();
  }else{
    $(this).parents('tr').addClass('selectedProduct');
    updateAddToCartContent();
  }     
});

function updateAddToCartContent(defaultCheckBoXChecked=false){
  if(defaultCheckBoXChecked == true){
    $('#productTemplok').prop('checked', true);
    $('#productTemplok').parent('.customCheckbox').addClass('customCheckboxChecked');
    $('#productRegular').prop('checked', true);
    $('#productRegular').parent('.customCheckbox').addClass('customCheckboxChecked');
  }
  let getTemplokQty = parseInt($('.totalAreaForTemplok .qty-width').text());
  let getRegularQty = parseInt($('.totalAreaForRegular .qty-width').text());
  let getTemplokPrice = $('.templokPrice .qty-width').text().split('$')[1].replace(/,/g, '');
  let getRegularPrice = $('.regularPrice .qty-width').text().split('$')[1].replace(/,/g, '');

  let getTotalQty = 0;
  let getTotalPrice = 0;
  let getTotalCartonQty = 0;
  let getTotalsqftCover = 0;

  let checkTemplokSelected = false;
  let checkRegularSelected = false;

  if($("#productTemplok").prop('checked') == true){
    getTotalQty = getTotalQty + getTemplokQty;
    getTotalPrice = getTotalPrice + parseFloat(getTemplokPrice);
    getTotalCartonQty += parseInt($('#productTemplok').attr('perCartonQty')) * getTemplokQty;
    getTotalsqftCover += parseInt($('#productTemplok').attr('pertilesqft')) * getTemplokQty;
    $('.totalAreaForTemplok .qty-width').attr('data-qty',getTemplokQty)
    checkTemplokSelected = true;
  }
  if($("#productRegular").prop('checked') == true){
    getTotalQty = getTotalQty + getRegularQty;
    getTotalPrice = getTotalPrice + parseFloat(getRegularPrice);
    getTotalCartonQty += parseInt($('#productRegular').attr('perCartonQty')) * getRegularQty;
    getTotalsqftCover += parseInt($('#productRegular').attr('pertilesqft')) * getRegularQty;
    $('.totalAreaForRegular .qty-width').attr('data-qty',getRegularQty)
    checkRegularSelected = true;
  }

  // Quantity selector visibility: Show if one checkbox is selected, hide if both or none are selected.
  if(checkTemplokSelected == true && checkRegularSelected == true){
    $('.grid__item .qtyField').removeClass('tw-inline-flex');
    $('.add-to-cart--buttons').addClass('button-full-width')
    $('.grid__item .qtyField').hide();
  }else{
    $('.grid__item .qtyField').addClass('tw-inline-flex');
    $('.add-to-cart--buttons').removeClass('button-full-width')
    $('.grid__item .qtyField').show();
  }

  // Update text in qty button.
  updateTotalAmountContent(getTotalQty,getTotalPrice,getTotalCartonQty,getTotalsqftCover)
}

// Updates the button and carton total when we change the quantity. 
function updateTotalAmountContent(qty,price,cartonQty,sqftcover){
  $('.qtytemplokProductAddToCart.qtyBtn').parent(".qtyField").find('#quantity').val(parseInt(qty))
  $('.title-sub-total .unit-qty').text(qty);
  if(qty > 1){
    $('.title-sub-total .unit-label').text('cartons');
  }else{
    $('.title-sub-total .unit-label').text('carton');
  }
  $('.button-add-x-items-to-cart .unit-qty').text(qty);
  if(qty > 1){
    $('.button-add-x-items-to-cart .cart-items-label').text('items');
  }else{
    $('.button-add-x-items-to-cart .cart-items-label').text('item');
  }
  $('button.product-form__cart-submit').addClass('templokProductAddToCart');
  $('.qtyBtn').addClass('qtytemplokProductAddToCart')
  $('#price-subtotal').text(theme.Currency.formatMoney(price * 100, theme.moneyFormat));
  $('.title-carton-info .price-unit-qty-number').removeClass('tw-hidden');
  $('.title-carton-info .price-unit-qty-number').text(cartonQty);
  $('.title-carton-info .convers-price .price-unit-covers').text(sqftcover);

  $('.tw-sticky-add-to-cart .kanopi-current-variant-price').text(theme.Currency.formatMoney(price * 100, theme.moneyFormat));
  $('.tw-sticky-add-to-cart .unity-qty-labels .unit-qty').removeClass('tw-hidden');
  $('.tw-sticky-add-to-cart .unity-qty-labels .unit-qty').text(qty);
  if(qty > 1){
    $('.tw-sticky-add-to-cart .unity-qty-labels .unit-label').text('cartons');
  }

  $('.tw-sticky-add-to-cart .price-unit-qty-number').removeClass('tw-hidden');
  $('.tw-sticky-add-to-cart .price-unit-qty-number').text(cartonQty);
  $('.qty-estimator-results-txt-inner').removeClass('tw-hidden')


  // Button disabled if quantity is zero.
  if(qty > 0 && qty != NaN){
    $('button.product-form__cart-submit').removeAttr('disabled');
  }else{
    $('button.product-form__cart-submit').attr('disabled','disabled');
  }
}

// Add to cart for the templok product
$(document).on('click', '.templokProductAddToCart', function() {
  let itemsToAdd = [];
  let getTemplokQty = parseInt($('.totalAreaForTemplok .qty-width').attr('data-qty'));
  let getRegularQty = parseInt($('.totalAreaForRegular .qty-width').attr('data-qty'));
  if($("#productTemplok").prop('checked') == true){
    let templokId = parseInt($('#productTemplok').attr('currentvariant'));
    const props = {}
    props['_templokRegularVariantId'] = $('#productRegular').attr('regularvariant');
    const currentObject = { id : templokId, quantity : getTemplokQty ,properties: props}
    itemsToAdd.push(currentObject)
  }
  if($("#productRegular").prop('checked') == true){
    let regularId = parseInt($('#productRegular').attr('regularvariant'));
    const props = {}
    props['_templokVariantId'] = $('#productTemplok').attr('currentvariant');
    const currentObject = { id : regularId, quantity : getRegularQty,properties: props }
    itemsToAdd.push(currentObject)
  }
  if(Object.keys(itemsToAdd).length) {
    CartJS.addItems(itemsToAdd);
  }
})

// Add to cart Single or double product for the templok 
$(document).on('click', '.product-single .qtytemplokProductAddToCart.qtyBtn', function() {
  let qtyField = $(this).parent(".qtyField");
  let oldValue = $(qtyField).find(".qty").val();
  let totalPriceforTemplok = 0;
  let currentVariantIdTemplok = $('.pdp-container').attr('data-current-variant');
  let newVal = 1;

  if ($(this).is(".plus")) {
    newVal = parseInt(oldValue) + 1;
  } else if (oldValue > 1) {
    newVal = parseInt(oldValue) - 1;
  }
  $(qtyField).find(".qty").val(newVal);
  
  if($("#productTemplok").prop('checked') == true){
    const getTemplokQty = parseInt($(qtyField).find(".qty").val());
    const getTemplokPrice = getTemplokQty * parseFloat(window.templokProduct[currentVariantIdTemplok].currentVariantPrice);
    const getTotalCartonQty = parseInt($('#productTemplok').attr('perCartonQty')) * getTemplokQty;
    const getTotalsqftCover = parseInt($('#productTemplok').attr('pertilesqft')) * getTemplokQty;
    $('.totalAreaForTemplok .qty-width').attr('data-qty',getTemplokQty);
    updateTotalAmountContent(getTemplokQty,getTemplokPrice,getTotalCartonQty,getTotalsqftCover);
  }
  if($("#productRegular").prop('checked') == true){
    const getRegularQty = parseInt($(qtyField).find(".qty").val());
    const getRegularPrice = getRegularQty * parseFloat(window.templokProduct[currentVariantIdTemplok].regularProductPrice);
    const getTotalCartonQty = parseInt($('#productRegular').attr('perCartonQty')) * getRegularQty;
    const getTotalsqftCover = parseInt($('#productRegular').attr('pertilesqft')) * getRegularQty;
    $('.totalAreaForRegular .qty-width').attr('data-qty',getRegularQty);
    updateTotalAmountContent(getRegularQty,getRegularPrice,getTotalCartonQty,getTotalsqftCover);
  }
  });

  $(document).on('keyup','.qty-estimator-result-input', function(e) {
      if($(this).parent('.qtyField').find('a').hasClass('qtytemplokProductAddToCart') && $(this).val() > 0 && $(this).val() != NaN){
      let qtyField = $(this).parent(".qtyField");
      let currentVariantIdTemplok = $('.pdp-container').attr('data-current-variant');

      if($("#productTemplok").prop('checked') == true){
        const getTemplokQty = parseInt($(qtyField).find(".qty").val());
        const getTemplokPrice = getTemplokQty * parseFloat(window.templokProduct[currentVariantIdTemplok].currentVariantPrice);
        const getTotalCartonQty = parseInt($('#productTemplok').attr('perCartonQty')) * getTemplokQty;
        const getTotalsqftCover = parseInt($('#productTemplok').attr('pertilesqft')) * getTemplokQty;
        $('.totalAreaForTemplok .qty-width').attr('data-qty',getTemplokQty);
        updateTotalAmountContent(getTemplokQty,getTemplokPrice,getTotalCartonQty,getTotalsqftCover);
      }
      if($("#productRegular").prop('checked') == true){
        const getRegularQty = parseInt($(qtyField).find(".qty").val());
        const getRegularPrice = getRegularQty * parseFloat(window.templokProduct[currentVariantIdTemplok].regularProductPrice);
        const getTotalCartonQty = parseInt($('#productRegular').attr('perCartonQty')) * getRegularQty;
        const getTotalsqftCover = parseInt($('#productRegular').attr('pertilesqft')) * getRegularQty;
        $('.totalAreaForRegular .qty-width').attr('data-qty',getRegularQty);
        updateTotalAmountContent(getRegularQty,getRegularPrice,getTotalCartonQty,getTotalsqftCover);
      }
    }
  });
   
  $(document).on('change','.qty-estimator-result-input', function(e) {
    if($(this).parent('.qtyField').find('a').hasClass('qtytemplokProductAddToCart')){
      if($(this).val() > 0 && $(this).val() != NaN){}else{
        $(this).val(1);
      }
    }
  })
});
// Templok calculator end.

// Hide ReturnPolicy Text.
function hideReturnPolicy() {
  let isHideReturnPolicy = [];
  if($('.cart__row.cart-item').length > 0){
    $('.cart__row.cart-item').each(function(){
        isHideReturnPolicy.push($(this).attr('data-return'));
    })  
    if(isHideReturnPolicy.includes('false')){
      $('.cart-info-return').removeClass('hideReturnPolicy');
      $('.mobile-policy-return-btn').removeClass('hideReturnPolicy');
    }else{
      $('.cart-info-return').addClass('hideReturnPolicy');
      $('.mobile-policy-return-btn').addClass('hideReturnPolicy');
    }
  }
}



// Update the cart quantity and product quantity toghether
$(document).ready(function(){
  // This condition check for like category page
  if(typeof window.topCollectionName !== 'undefined'){
    filterOrderChange();
  }
  if ($('.mobile-nav-wrapper .quick-order').length && $('.mobile-nav-wrapper .nav-Sale').length) {
    $('.mobile-nav-wrapper .quick-order').insertBefore('.mobile-nav-wrapper .nav-Sale');
  }
  if($('body').hasClass('template-product')){
    setTimeout(function() {
      updateProductQuantity();
    }, 1000); 
  }
});
function updateProductQuantity(){
  if(window.isTemplokProduct == false && !$('.product-form__cart-submit').hasClass('grid__cart-submit')){
    let currentVariantSelected = $('.pdp-container').attr('data-current-variant');
    if (currentVariantSelected && currentVariantSelected.length > 0) {
    var foundVariantInCart = false;
    CartJS.cart.items?.forEach(items => {
      if(currentVariantSelected == items.id){
        $('.updateItem').remove();
        $('.add-to-cart-sticky .item-available').addClass('tw-hidden');
        if(Shopify.productMeta[currentVariantSelected]?.available){
          $('.add-to-cart-sticky .item-available').after('<div class="tw-flex tw-justify-center tw-items-center updateItem"><span class="button-add-x-items-to-cart tw-tracking-[1px] tw-leading-[21px] tw-text-[14px">Update quantity</span></div>')
        }
        
        $('.add-to-cart-sticky .item-available').parent('button').addClass('updateItemBtn')
        $('.product-form__cart-submit .item-available').addClass('tw-hidden')
        $('.product-form__cart-submit .item-available').parent('button').addClass('updateItemBtn')
        if(Shopify.productMeta[currentVariantSelected]?.available){
          $('.product-form__cart-submit .item-available').after('<div class="tw-flex tw-justify-center tw-items-center updateItem">Update Quantity</div>');
        }
        $('.qty-estimator-result-input').val(items.quantity);
        $('.qty-estimator-result-input').change();
        foundVariantInCart = true;
        return true;
      }
    })
    if(foundVariantInCart == false){
      // if(Shopify.productMeta[currentVariantSelected]?.available){
      $('.add-to-cart-sticky .item-available').removeClass('tw-hidden');
      $(".item-available").removeClass("tw-hidden");
      $(".item-not-available").addClass("tw-hidden");
      $('.product-form__cart-submit .item-available').parent('button').removeClass('updateItemBtn')
      $('.add-to-cart-sticky .item-available').parent('button').removeClass('updateItemBtn')
      if(quantityChangeDetected == false){
        let metafields = Shopify.productMeta[currentVariantSelected];
        let min_quantity = parseInt(metafields?.min_quantity);
        if(metafields?.min_quantity){
          $('.product-single .product-form__input[name="quantity"]').val(min_quantity).change();
        }else{
          $('.product-single .product-form__input[name="quantity"]').val(1).change();
        }
      }
      $('.updateItem').remove();
      // }
    }
  }
  }
}

function filterOrderChange() {
  if (typeof window.topCollectionName !== 'undefined') {
      let getFirstVariantId = '';
      let data = '';

      // First loop: Reordering elements based on topCollectionName
      $('#CollectionFiltersForm .filterBox').each(function (index) {
          if (index === 0) {
              getFirstVariantId = $(this).attr('id');
          }
          if ($(this).attr('data-filter-title') == window.topCollectionName) {
              $(this).insertBefore($('#' + getFirstVariantId)); // Corrected selector
          }
      });

      // Resetting getFirstVariantId for the next section
      getFirstVariantId = '';

      // Second loop: Checking Type of Space elements
      $('#CollectionFiltersForm .filterBox[data-filter-title="Type of Space"] ul div').each(function (index) {
          if (index === 0) {
              getFirstVariantId = $(this).attr('id');
          }

          let filterTitle = $(this).attr('data-filter-title');
          if (filterTitle) { // Check if the attribute exists before splitting
              data = filterTitle.split("-");
              if (data[1] == window.topCollectionName) {
                  $('#accordion-'+window.topCollectionName).insertBefore('#'+getFirstVariantId);
                  $('#filter-'+window.topCollectionName).insertBefore('#'+getFirstVariantId);
              }
          }
      });
  }
}


// Discount Upsell For Tier and Volume Discount Start
let tierLevelRemainingQuantity = 0; 
let tierLevelDiscountMessage = '';
let tierLevelRemainingItems = 0;
function tierLevelUpsell(){
  // If more than one products into the cart then we only showcase the qualified discount bar.
  if(CartJS.cart.items?.length > 1){
      $('.volumeComponentMiniCart').addClass('tw-hidden');
      const cartItems = CartJS.cart.items;
      const $volMsgAway = $('.tw-volMsg-away');
      const $volMsgAwayComplete = $('.tw-volMsg-away-complete');
      const $itemCartToAdd = $('.item-cart-to-add');
      const $volumeComponentMiniCart = $('.volumeComponentMiniCart');
      const $progressBar = $volumeComponentMiniCart.find('.progress-bar');
      const $volPercentage = $volumeComponentMiniCart.find('.volPercentage');
  
      handleQualifiedDiscountBar(cartItems, $volumeComponentMiniCart, $progressBar, $volPercentage, $volMsgAway, $volMsgAwayComplete, $itemCartToAdd);
  }else{
    // If one product into the cart then we showcase the upsell add product 
    $('.volumeComponentMiniCart').addClass('tw-hidden');
    const currentCarrVariantId = CartJS.cart.items[0].id
    let cartJSON = "";
    let variantLevelDiscountEnable = "";
    let variantLevelDiscounts = "";
    let productLevelDiscountEnable = "";
    let productLevelDiscounts = "";

    if (!CartJS.cart.sections?.cartObject) {
        const firstItem = CartJS.cart.items?.[0] || {};
        variantLevelDiscountEnable = firstItem.variantTierDiscountEnable || "";
        variantLevelDiscounts = firstItem.variantTierDiscounts || "";
        productLevelDiscountEnable = firstItem.productTierDiscountEnable || "";
        productLevelDiscounts = firstItem.productTierDiscounts || "";
    } else {
        try {
            cartJSON = JSON.parse(CartJS.cart.sections.cartObject.replace(/<\/?[^>]+(>|$)/g, ""));
            if (cartJSON?.[currentCarrVariantId]) {
                variantLevelDiscountEnable = cartJSON[currentCarrVariantId].variantTierDiscountEnable || "";
                variantLevelDiscounts = cartJSON[currentCarrVariantId].variantTierDiscounts || "";
                productLevelDiscountEnable = cartJSON[currentCarrVariantId].productTierDiscountEnable || "";
                productLevelDiscounts = cartJSON[currentCarrVariantId].productTierDiscounts || "";
            }
        } catch (error) {
            console.error("Error parsing cart JSON:", error);
        }
    }

      const shopDiscounts = JSON.parse(shop_tier_volume_discounts)
      let applicableDiscounts = [];

      // Ensure at least one discount is enabled
      if (!variantLevelDiscountEnable && variantLevelDiscountEnable) {
        return;
      }
      if (!variantLevelDiscountEnable && !productLevelDiscountEnable && productLevelDiscounts) {
        return;
      }
      if (!variantLevelDiscountEnable && !productLevelDiscountEnable) {
        return;
      }

      // Determine applicable discounts
      if (variantLevelDiscountEnable == true && variantLevelDiscounts?.length > 0) {
        applicableDiscounts = variantLevelDiscounts
      } else if (productLevelDiscountEnable == true && productLevelDiscounts?.length > 0) {
        applicableDiscounts = productLevelDiscounts
      } else if (shop_enabled_tier_volume_discounts?.length > 0) {
        applicableDiscounts = shop_enabled_tier_volume_discounts
      }

      let loopBreak = false;
      // Iterate through discount objects
      $.each(shopDiscounts[0], function (index, discountObj) {
        $.each(discountObj, function (key, discount) {
            if (!applicableDiscounts.includes(key)) return;
    
            const cartItem = CartJS.cart.items[0];
            if (!cartItem) return;
    
            let tierLevelRemainingItems = discount.tier_min_quantity - cartItem.quantity;
            let percentage = (cartItem.quantity * 100) / discount.tier_min_quantity;
            let isinThreshold = tierLevelRemainingItems > 0 && tierLevelRemainingItems <= tierUpsellThreshold;

            // jQuery selectors
            const $volMsgAway = $('.tw-volMsg-away');
            const $volMsgAwayComplete = $('.tw-volMsg-away-complete');
            const $itemCartToAdd = $('.item-cart-to-add');
            const $volumeComponentMiniCart = $('.volumeComponentMiniCart');
            const $progressBar = $volumeComponentMiniCart.find('.progress-bar');
            const $volPercentage = $volumeComponentMiniCart.find('.volPercentage');

            if (isinThreshold) {
                tierLevelRemainingQuantity = tierLevelRemainingItems
                // Show threshold message
                $volMsgAwayComplete.hide();
                $volMsgAway.show();
                $itemCartToAdd.show();
                $volumeComponentMiniCart.removeClass('tw-hidden');
    
                // Update UI
                $volumeComponentMiniCart.find('.cartonsToAdd').text(tierLevelRemainingItems);
                $volumeComponentMiniCart.find('.itemSelectedImage').attr('src', cartItem.featured_image.url);
                $volumeComponentMiniCart.find('.productTitle').text(cartItem.product_title);
                $progressBar.width(`${percentage}%`);
    
                // Discount type check
                if (discount.tier_discount_type === "fixed") {
                    $volPercentage.text(`$${discount.tier_discount_amount} OFF`);
                } else {
                    $volPercentage.text(`${discount.tier_discount_percentage}% OFF`);
                }     
                loopBreak = true;
            } else if (cartItem.line_level_discount_allocations.length) {
                // Show complete discount message
                let discountApplication = cartItem.line_level_discount_allocations[0].discount_application;
                let tierLevelDiscountMessage = discountApplication.value_type === "fixed_amount"
                    ? `$${Math.round(discountApplication.value)} OFF`
                    : `${Math.round(discountApplication.value)}% OFF`;
    
                $itemCartToAdd.hide();
                $volMsgAway.hide();
                $volMsgAwayComplete.show();
                $volMsgAwayComplete.find('.volPercentage').text(tierLevelDiscountMessage);
                $progressBar.width('100%');
                $volumeComponentMiniCart.removeClass('tw-hidden');
            }
        });
        if(loopBreak){
          return false;
        }
    }); 
  }
}


$(document).ready(function() {
  $('.volume_promotion_msg.vol-cart').each(function(i, v) {
      let variantId = $(v).attr('data-variant-id'); 
      let lineItem = Shopify.lineItems[variantId];

      if (lineItem && lineItem.variantTierData) {
          let variantTierData = JSON.parse(lineItem.variantTierData);
          
          if (variantTierData.length > 0) {
              variantTierData.sort((a, b) => a.tier_min_quantity - b.tier_min_quantity);

              let tierHtml = '';

              variantTierData.forEach((tier, index) => {
                  let discountValue = (tier.tier_discount_type === "percentage") 
                      ? `${tier.tier_discount_percentage}%` 
                      : `$${tier.tier_discount_amount}`;

                  if (index === variantTierData.length - 1) {
                      tierHtml += `<li>${tier.tier_min_quantity}+ cartons: ${discountValue} off</li>`;
                  } else {
                      tierHtml += `<li>${tier.tier_min_quantity}-${tier.tier_max_quantity} cartons: ${discountValue} off</li>`;
                  }
              });

              $(v).find('.cart-tooltip-main ul').html(tierHtml);
              $(v).find('.promotion-text').text(lineItem.volumeMsg);
          }
      }
  });
});



$(document).on("click","#add-product-custom",function() {
  if(tierLevelRemainingQuantity > 0){
    if(window.isCartPage){
      $('body').addClass('loading');
    }
    
    setTimeout(() => {
      var element = $('.jsAddQty[data-id="'+CartJS.cart.items[0].id+'"]');
      var currentQty = parseInt(element.attr('data-cart-quantity')) - 1;
      element.attr('data-cart-quantity',currentQty + tierLevelRemainingQuantity);
      element.trigger('click');
    }, 500);
  }
});

let volumeRemainingItems = 0;
let volumeVariantId = 0;
function volumeDiscountUpsell() {
  const cartItems = CartJS.cart.items;
  let cartJSON = ""
  if(CartJS.cart.sections?.cartObject){
    cartJSON = JSON.parse(CartJS.cart.sections.cart_object.replace(/<\/?[^>]+(>|$)/g, ""));
  }
  // Cache DOM elements
  const $volMsgAway = $('.tw-volMsg-away');
  const $volMsgAwayComplete = $('.tw-volMsg-away-complete');
  const $itemCartToAdd = $('.item-cart-to-add');
  const $volumeComponentMiniCart = $('.volumeComponentMiniCart');
  const $progressBar = $volumeComponentMiniCart.find('.progress-bar');
  const $volPercentage = $volumeComponentMiniCart.find('.volPercentage');

  const volumeUpsellProductObject = {};

  let  itemData = ""
  for (let item of cartItems) {
    if(cartJSON?.[item.id]){
      itemData = cartJSON?.[item.id];
      variantVolumeDiscount = itemData;
      productVolumeDiscount = itemData;
    }else{
      itemData = item;
      variantVolumeDiscount = itemData.variantVolumeDiscount;
      productVolumeDiscount = itemData.productVolumeDiscount;
    }
      
      let discountSource = null;

      // Determine the appropriate discount source
      if (variantVolumeDiscount?.has_variant_volume_discount) {
        discountSource = variantVolumeDiscount;
      } else if (productVolumeDiscount?.has_product_volume_discount) {
        discountSource = productVolumeDiscount;
      } else if (!productVolumeDiscount?.has_product_volume_discount && productVolumeDiscount.length > 0) {
        discountSource = JSON.parse(shopLevelVolumeDiscount); // Assuming `shopVolumeDiscount` is globally defined
      }

      if (!discountSource) continue;

      const remainingQuantity = discountSource.quantity - item.quantity;
      const percentage = (item.quantity * 100) / discountSource.quantity;

      if (item.quantity >= min_cartons_volume_cart && remainingQuantity > 0 && item.line_level_discount_allocations.length === 0) {
          volumeUpsellProductObject[item.id] = {
              product_title: item.product_title,
              image_url: item.featured_image.url,
              remaining_quantity: remainingQuantity,
              percentage: percentage,
              discount_amount: discountSource.amount,
              variant_id: item.id
          };
      }
  }

  if (Object.keys(volumeUpsellProductObject).length > 0) {
      // Get the item with the lowest discount amount
      let lowestDiscountItem = Object.values(volumeUpsellProductObject).reduce((min, item) =>
          item.discount_amount < min.discount_amount ? item : min
      );

      $volMsgAwayComplete.hide();
      $volMsgAway.show();
      $itemCartToAdd.show();
      $volumeComponentMiniCart.removeClass('tw-hidden');

      // Update UI elements
      $volumeComponentMiniCart.find('.cartonsToAdd').text(lowestDiscountItem.remaining_quantity);
      $volumeComponentMiniCart.find('.itemSelectedImage').attr('src', lowestDiscountItem.image_url);
      $volumeComponentMiniCart.find('.productTitle').text(lowestDiscountItem.product_title);
      $progressBar.width(`${lowestDiscountItem.percentage}%`);
      $volPercentage.text(`$${lowestDiscountItem.discount_amount} OFF`);
      volumeRemainingItems = lowestDiscountItem.remaining_quantity;
      volumeVariantId = lowestDiscountItem.variant_id;
  } else {
      handleQualifiedDiscountBar(cartItems, $volumeComponentMiniCart, $progressBar, $volPercentage, $volMsgAway, $volMsgAwayComplete, $itemCartToAdd);
  }
}
$(document).on("click","#add-product-custom",function() {
  if(volumeRemainingItems > 0){
    if(window.isCartPage){
      $('body').addClass('loading');
    }
    setTimeout(() => {
      var element = $('.jsAddQty[data-id="'+volumeVariantId+'"]');
      var currentQty = parseInt(element.attr('data-cart-quantity')) - 1;
      element.attr('data-cart-quantity',currentQty + volumeRemainingItems);
      element.trigger('click');
    }, 500);
  }
});

function handleQualifiedDiscountBar(cartItems, $volumeComponentMiniCart, $progressBar, $volPercentage, $volMsgAway, $volMsgAwayComplete, $itemCartToAdd) {
  $volumeComponentMiniCart.addClass('tw-hidden');

  let isFixedAmount = false;
  let isPercentageAmount = false;
  let calculateFixedAmount = 0;
  let tempValue = 0;

  cartItems.forEach((item) => {
      if (item.line_level_discount_allocations.length > 0) {
          const discount = item.line_level_discount_allocations[0].discount_application;
          if (discount.value_type === 'fixed_amount') {
              calculateFixedAmount += parseFloat(discount.value);
              isFixedAmount = true;
          } else if (discount.value_type === 'percentage') {
              tempValue = Math.max(tempValue, discount.value);
              isPercentageAmount = true;
          }
      }
  });

  if (isPercentageAmount) {
      calculateFixedAmount = tempValue;
  }

  if (calculateFixedAmount > 0) {
      $itemCartToAdd.hide();
      $volMsgAway.hide();
      $volMsgAwayComplete.show();

      const discountText = isFixedAmount && !isPercentageAmount
          ? `$${Math.round(calculateFixedAmount)} OFF`
          : `${Math.round(calculateFixedAmount)}% OFF`;

      $volPercentage.text(discountText);
      $progressBar.width('100%');
      $volumeComponentMiniCart.removeClass('tw-hidden');
  }
}
// End Discount Upsell For Tier and Volume Discount Start


// Handle Email Validation on Button Click
$(document).on('input change keydown','.modal-quote input',function(){
  let email = $(this).val().trim();
  var emailError = $(".email-error"); // Select error message
  if(validateEmail(email)){
    emailError.addClass("tw-hidden");
    $(".modal-quote .quote-btn").attr('disabled',false);
  }else{
    emailError.removeClass("tw-hidden");
    $(".modal-quote .quote-btn").attr('disabled',true);
  }
});
$(document).on("click",".modal-quote .quote-btn", function (e) {
  e.preventDefault();

  var emailInput = $(".modal-quote input");
  var emailValue = emailInput.val().trim();
  var containerInfo = $(".modal-quote .container-info");
  var quoteConfirmation = $(".quote-confirmation-section"); // Select quote-confirmation-section
  var emailError = $(".email-error"); // Select error message

  if (validateEmail(emailValue)) {
    $(this).prop("disabled", true).find('.before-it').addClass('tw-hidden');
    $(this).find('.after-it').removeClass('tw-hidden');
    let body_object = buildObjectForQuote(emailValue);
    let this_obj = $(this);
    $.ajax({
      url: baseWorker + "/draft-order", 
      type: 'POST',
      data: JSON.stringify(body_object),
      dataType: 'json',
      success: function(data) {
        this_obj.prop("disabled", false).find('.before-it').removeClass('tw-hidden');
        this_obj.find('.after-it').addClass('tw-hidden');
        if (data?.link) {
          window.open(data?.link, '_blank').focus();
        }
        containerInfo.addClass("tw-hidden");
        quoteConfirmation.removeClass("tw-hidden");
        emailError.addClass("tw-hidden");
        emailInput.removeClass("invalid-email").addClass("valid-email");
        $('.quote-api-error').addClass('tw-hidden');
      },
      error: function(xhr, status, error) {
        $('.quote-api-error').removeClass('tw-hidden');
        setTimeout(() => {
          $('.quote-api-error').addClass('tw-hidden');
        }, 3000);
      }
  });
  } else {
    containerInfo.removeClass("tw-hidden");
    quoteConfirmation.addClass("tw-hidden");
    emailError.removeClass("tw-hidden");
    emailInput.addClass("invalid-email").removeClass("valid-email");
  }
});
function buildObjectForQuote(email){
  let items = [];
  var address,shipping;
  CartJS.cart.items?.forEach(item => {
    let properties = item.properties;
    properties['__rpaPercentage'] = (CartJS.cart?.attributes?.surchargeValue)?CartJS.cart?.attributes?.surchargeValue: "0";
    let single_item = {
      "properties": properties,
      "quantity": item.quantity,
      "variant_id": "gid://shopify/ProductVariant/" + item.variant_id
    }
    items.push(single_item);
  });

  var asm_geo_data = sessionStorage.getItem('ASM-Geo-Data');
  if(sessionStorage.getItem('ASM-Geo-Data')){
    var asm_geo_exploded = asm_geo_data.split('~');
    var state = asm_geo_exploded[1];
    var zip = asm_geo_exploded[2];
    var country = asm_geo_exploded[3];
    address={
      "postcode": zip,
      "statecode":state,
      "country": country
    };
  }else{
    address={
      "postcode":  (CartJS.cart?.attributes?.surchargeZipCode)?CartJS.cart?.attributes?.surchargeZipCode: $('#asm-ship-to-zip').text()
    }
  }
  
  selectedshippingdiv = $('[name=asm-selected-shipping-method]:checked');
  if(selectedshippingdiv.length){
    let str = selectedshippingdiv.attr('onclick');
    let shipping_arr = str.replaceAll('asm_save_method (','').replaceAll(')','').replaceAll("'",'').replaceAll(";",'').replaceAll(" ",'').split(',');
    shipping = {
      "title": shipping_arr[0],
      "price": parseFloat(shipping_arr[1])
    }
  }else{
    shipping = {
      "title": '-',
      "price": 0
    }
  }
  return {
    "store": store_domain,
    "Cart": {
      "items": items
    },
    "address": address,
    "shipping": shipping,
    "customer": {
      "email": email
    }
  }
}
// Reset Modal Data When Modal is Closed
$(document).on("click","#modal-quote .close-modal-btn", function () {
  $(".input_email_k input").val("").removeClass("invalid-email valid-email");
  $(".container-info").removeClass("tw-hidden");
  $(".quote-confirmation-section").addClass("tw-hidden");
  $(".email-error").addClass("tw-hidden");
});
$( document ).ready(function() {
  $(document).on('mouseenter','.cart-tooltip-main img,.tooltip-content',function () {
        let $tooltip = $(this).closest('.cart-tooltip-main');
        let $tooltipContent = $tooltip.find('.tooltip-content');
        let $tooltipContentAerrow = $tooltipContent.find('.tooltip__arrow');
        let windowWidth = $(window).width();
        let offsetLeft = $tooltip.offset().left;
        let remainingSpace = windowWidth - offsetLeft;
        if (remainingSpace < 110) {
            $tooltipContent.css({
                'right': '-16px',
                'left':'initial',
                'display':'block'
            });
            $tooltipContentAerrow.css({
              'left': '76.5%'
            })
        } else if (offsetLeft < 110 && offsetLeft !== 0) {
            $tooltipContent.css({
                'right': 'initial',
                'left': '-16px',
                'display':'block'
            });
            $tooltipContentAerrow.css({
              'left': '-3px'
            })
        } else {
            $tooltipContent.css({
                'right': 'initial',
                'left': '-94px',
                'display':'block'
            });
            $tooltipContentAerrow.css({
              'left': '37.5%'
            })
        }
    });
    $(document).on('mouseleave','.cart-tooltip-main img',function () {
      let $tooltip = $(this).closest('.cart-tooltip-main');
      let $tooltipContent = $tooltip.find('.tooltip-content');
      $tooltipContent.css({ 'display':'none' })
    })



});
/* activate-account page */
$(document).on("keyup", ".activate-account #CustomerPassword, .activate-account #CustomerPasswordConfirmation", function () {
  let password = $(".activate-account #CustomerPassword").val();
  let confirmPassword = $(".activate-account #CustomerPasswordConfirmation").val();
  let submitButton = $(".activate-account input[type='submit']");
  let errorMsg = $(".activate-account .error-msg");
  let confirmPasswordField = $(".container-password");

  if (password.length > 0 && confirmPassword.length > 0) {
      if (password === confirmPassword) {
          submitButton.prop("disabled", false);
          errorMsg.hide();
          confirmPasswordField.removeClass("input-error");
      } else {
          submitButton.prop("disabled", true);
          errorMsg.show();
          confirmPasswordField.addClass("input-error");
      }
  } else {
      errorMsg.hide();
      submitButton.prop("disabled", true);
      confirmPasswordField.removeClass("input-error");
  }
});